// GENERATED by tools/build/gen-icon-data.mjs (npm run gen:icon-data) from the PHP catalogs.
// SimpleCustomIcon — flat UI/control/slug icons + alias resolutions (icon-only). Merged LAST, only filling keys not already provided by the catalogs above.
import type { IconMap } from '../types';

export const SIMPLE_ICONS: IconMap = {
	"0ap": {
		"file": "0ap",
		"tooltip": "0ap"
	},
	"10_second_warning": {
		"file": "10_second_warning",
		"tooltip": "10 Second Warning"
	},
	"1ap": {
		"file": "1ap",
		"tooltip": "1ap"
	},
	"2ap": {
		"file": "2ap",
		"tooltip": "2ap"
	},
	"3ap": {
		"file": "3ap",
		"tooltip": "3ap"
	},
	"abilities": {
		"file": "abilities",
		"tooltip": "Abilities"
	},
	"ability": {
		"file": "ability",
		"tooltip": "Ability"
	},
	"ability_activation_charges": {
		"file": "ability_activation_charges",
		"tooltip": "Ability Activation Charges"
	},
	"ability_activation_charges_max": {
		"file": "ability_activation_charges_max",
		"tooltip": "Ability Activation Charges Max"
	},
	"ability_activation_charges_min": {
		"file": "ability_activation_charges_min",
		"tooltip": "Ability Activation Charges Min"
	},
	"ability_active_if_ability_charge_is_at_median": {
		"file": "ability_active_if_ability_charge_is_at_median",
		"tooltip": "Ability Active If Ability Charge Is at Median"
	},
	"ability_applied": {
		"file": "ability_applied",
		"tooltip": "Ability Applied"
	},
	"ability_body": {
		"file": "ability_body",
		"tooltip": "Ability Body"
	},
	"ability_charge_decay_at_end_of_turn": {
		"file": "ability_charge_decay_at_end_of_turn",
		"tooltip": "Ability Charge Decay at End of Turn"
	},
	"ability_charge_decay_at_start_of_turn": {
		"file": "ability_charge_decay_at_start_of_turn",
		"tooltip": "Ability Charge Decay at Start of Turn"
	},
	"ability_charges": {
		"file": "ability_charges",
		"tooltip": "Ability Charges"
	},
	"ability_charges_not_required": {
		"file": "ability_charges_not_required",
		"tooltip": "Ability Charges Not Required"
	},
	"ability_choice": {
		"file": "ability_choice",
		"tooltip": "Ability Choice"
	},
	"ability_dc": {
		"file": "ability_dc",
		"tooltip": "Ability Dc"
	},
	"ability_does_not_effect_inventory": {
		"file": "ability_does_not_effect_inventory",
		"tooltip": "Ability Does Not Effect Inventory"
	},
	"ability_does_not_provoke_opportunity_attacks": {
		"file": "ability_does_not_provoke_opportunity_attacks",
		"tooltip": "Ability Does Not Provoke Opportunity Attacks"
	},
	"ability_does_not_work_against_creature_ancestry": {
		"file": "ability_does_not_work_against_creature_ancestry",
		"tooltip": "Ability Does Not Work Against Creature Ancestry"
	},
	"ability_does_not_work_against_creature_grouping": {
		"file": "ability_does_not_work_against_creature_grouping",
		"tooltip": "Ability Does Not Work Against Creature Grouping"
	},
	"ability_does_not_work_against_creature_lineage": {
		"file": "ability_does_not_work_against_creature_lineage",
		"tooltip": "Ability Does Not Work Against Creature Lineage"
	},
	"ability_does_not_work_against_creature_sub_type": {
		"file": "ability_does_not_work_against_creature_sub_type",
		"tooltip": "Ability Does Not Work Against Creature Sub Type"
	},
	"ability_does_not_work_against_creature_type": {
		"file": "ability_does_not_work_against_creature_type",
		"tooltip": "Ability Does Not Work Against Creature Type"
	},
	"ability_does_not_work_against_item_type": {
		"file": "ability_does_not_work_against_item_type",
		"tooltip": "Ability Does Not Work Against Item Type"
	},
	"ability_does_not_work_on_armor_type": {
		"file": "ability_does_not_work_on_armor_type",
		"tooltip": "Ability Does Not Work on Armor Type"
	},
	"ability_does_not_work_on_if_weapon_property_exists": {
		"file": "ability_does_not_work_on_if_weapon_property_exists",
		"tooltip": "Ability Does Not Work on If Weapon Property Exists"
	},
	"ability_does_not_work_on_weapon_category": {
		"file": "ability_does_not_work_on_weapon_category",
		"tooltip": "Ability Does Not Work on Weapon Category"
	},
	"ability_does_not_work_on_weapon_classification": {
		"file": "ability_does_not_work_on_weapon_classification",
		"tooltip": "Ability Does Not Work on Weapon Classification"
	},
	"ability_does_not_work_on_weapon_type": {
		"file": "ability_does_not_work_on_weapon_type",
		"tooltip": "Ability Does Not Work on Weapon Type"
	},
	"ability_essence": {
		"file": "ability_essence",
		"tooltip": "Ability Essence"
	},
	"ability_fortune": {
		"file": "ability_fortune",
		"tooltip": "Ability Fortune"
	},
	"ability_mind": {
		"file": "ability_mind",
		"tooltip": "Ability Mind"
	},
	"ability_moves_to_target_in_ft": {
		"file": "ability_moves_to_target_in_ft",
		"tooltip": "Ability Moves to Target in Ft"
	},
	"ability_only_affects_inventory": {
		"file": "inventory",
		"tooltip": "Only Affects Inventory"
	},
	"ability_requires_speed_type_remaining": {
		"file": "ability_requires_speed_type_remaining",
		"tooltip": "Ability Requires Speed Type Remaining"
	},
	"ability_soul": {
		"file": "ability_soul",
		"tooltip": "Ability Soul"
	},
	"ability_spirit": {
		"file": "ability_spirit",
		"tooltip": "Ability Spirit"
	},
	"ability_transferred_while_shapeshifted": {
		"file": "ability_transferred_while_shapeshifted",
		"tooltip": "Ability Transferred While Shapeshifted"
	},
	"ability_works_only_against_creature_ancestry": {
		"file": "ability_works_only_against_creature_ancestry",
		"tooltip": "Ability Works Only Against Creature Ancestry"
	},
	"ability_works_only_against_creature_grouping": {
		"file": "ability_works_only_against_creature_grouping",
		"tooltip": "Ability Works Only Against Creature Grouping"
	},
	"ability_works_only_against_creature_lineage": {
		"file": "ability_works_only_against_creature_lineage",
		"tooltip": "Ability Works Only Against Creature Lineage"
	},
	"ability_works_only_against_creature_sub_type": {
		"file": "ability_works_only_against_creature_sub_type",
		"tooltip": "Ability Works Only Against Creature Sub Type"
	},
	"ability_works_only_against_creature_type": {
		"file": "ability_works_only_against_creature_type",
		"tooltip": "Ability Works Only Against Creature Type"
	},
	"ability_works_only_against_item_type": {
		"file": "ability_works_only_against_item_type",
		"tooltip": "Ability Works Only Against Item Type"
	},
	"ability_works_only_on_armor_type": {
		"file": "ability_works_only_on_armor_type",
		"tooltip": "Ability Works Only on Armor Type"
	},
	"ability_works_only_on_if_weapon_property_exists": {
		"file": "ability_works_only_on_if_weapon_property_exists",
		"tooltip": "Ability Works Only on If Weapon Property Exists"
	},
	"ability_works_only_on_weapon_category": {
		"file": "ability_works_only_on_weapon_category",
		"tooltip": "Ability Works Only on Weapon Category"
	},
	"ability_works_only_on_weapon_classification": {
		"file": "ability_works_only_on_weapon_classification",
		"tooltip": "Ability Works Only on Weapon Classification"
	},
	"ability_works_only_on_weapon_type": {
		"file": "ability_works_only_on_weapon_type",
		"tooltip": "Ability Works Only on Weapon Type"
	},
	"about": {
		"file": "about",
		"tooltip": "About"
	},
	"ac_mod_environmental": {
		"file": "ac_mod_environmental",
		"tooltip": "Ac Mod Environmental"
	},
	"ac_mod_magical": {
		"file": "ac_mod_magical",
		"tooltip": "Ac Mod Magical"
	},
	"ac_mod_non_magical": {
		"file": "ac_mod_non_magical",
		"tooltip": "Ac Mod Non Magical"
	},
	"ac_mod_other": {
		"file": "ac_mod_other",
		"tooltip": "Ac Mod Other"
	},
	"accept_trade": {
		"file": "accept_trade",
		"tooltip": "Accept Trade"
	},
	"account": {
		"file": "account",
		"tooltip": "Account"
	},
	"acquire_abilities_while_unequipped": {
		"file": "acquire_abilities_while_unequipped",
		"tooltip": "Acquire Abilities While Unequipped"
	},
	"action_types": {
		"file": "hud_action_bar",
		"tooltip": "Action Types"
	},
	"add_abilities": {
		"file": "add_abilities",
		"tooltip": "Add Abilities"
	},
	"add_ability": {
		"file": "add_ability",
		"tooltip": "Add Ability"
	},
	"add_ap": {
		"file": "add_ap",
		"tooltip": "Add Ap"
	},
	"add_at_will_spell": {
		"file": "add_at_will_spell",
		"tooltip": "Add at Will Spell"
	},
	"add_attack": {
		"file": "add_attack",
		"tooltip": "Add Attack"
	},
	"add_attack_ability": {
		"file": "add_attack_ability",
		"tooltip": "Add Attack Ability"
	},
	"add_charges_to_ability": {
		"file": "add_charges_to_ability",
		"tooltip": "Add Charges to Ability"
	},
	"add_charges_to_ability_for_target": {
		"file": "add_charges_to_ability_for_target",
		"tooltip": "Add Charges to Target Ability"
	},
	"add_charges_to_ability_qty_for_target": {
		"file": "add_charges_to_ability_qty_for_target",
		"tooltip": "Add Charges to Target Ability — Quantity"
	},
	"add_charges_to_passive_ability": {
		"file": "add_charges_to_passive_ability",
		"tooltip": "Add Charges to Passive Ability"
	},
	"add_creature": {
		"file": "add_creature",
		"tooltip": "Add Creature"
	},
	"add_creature_to_combat": {
		"file": "add_creature_to_combat",
		"tooltip": "Add Creature to Combat"
	},
	"add_curse": {
		"file": "add_curse",
		"tooltip": "Add Curse"
	},
	"add_free_ability": {
		"file": "add_free_ability",
		"tooltip": "Add Free Ability"
	},
	"add_full_ability": {
		"file": "add_full_ability",
		"tooltip": "Add Full Ability"
	},
	"add_head_attack": {
		"file": "add_head_attack",
		"tooltip": "Add Head Attack"
	},
	"add_innate_spell_per_long_rest": {
		"file": "add_innate_spell_per_long_rest",
		"tooltip": "Add Innate Spell Per Long Rest"
	},
	"add_inventory": {
		"file": "add_inventory",
		"tooltip": "Add Inventory"
	},
	"add_location": {
		"file": "add_location",
		"tooltip": "Add Location"
	},
	"add_menta": {
		"file": "add_menta",
		"tooltip": "Add Menta"
	},
	"add_opportunity_attack_ability": {
		"file": "add_opportunity_attack_ability",
		"tooltip": "Add Opportunity Attack Ability"
	},
	"add_passive_ability": {
		"file": "add_passive_ability",
		"tooltip": "Add Passive Ability"
	},
	"add_quick_ability": {
		"file": "add_quick_ability",
		"tooltip": "Add Quick Ability"
	},
	"add_reaction": {
		"file": "add_reaction",
		"tooltip": "Add Reaction"
	},
	"add_reaction_ability": {
		"file": "add_reaction_ability",
		"tooltip": "Add Reaction Ability"
	},
	"add_sanguine": {
		"file": "add_sanguine",
		"tooltip": "Add Sanguine"
	},
	"add_status_effect": {
		"file": "add_status_effect",
		"tooltip": "Add Status Effect"
	},
	"add_to_cart": {
		"file": "add_to_cart",
		"tooltip": "Add to Cart"
	},
	"add_to_wishlist": {
		"file": "add_to_wishlist",
		"tooltip": "Add to Wishlist"
	},
	"add_turn_timer_seconds": {
		"file": "add_turn_timer_seconds",
		"tooltip": "Add Turn Timer Seconds"
	},
	"added_creatures": {
		"file": "added_creatures",
		"tooltip": "Added Creatures"
	},
	"adjust_charge": {
		"file": "adjust_charge",
		"tooltip": "Adjust Charge"
	},
	"admin_tools": {
		"file": "admin_tools",
		"tooltip": "Admin Tools"
	},
	"administration": {
		"file": "administration",
		"tooltip": "Administration"
	},
	"adv": {
		"file": "adv",
		"tooltip": "Adv"
	},
	"adv_dis": {
		"file": "adv_dis",
		"tooltip": "Adv Dis"
	},
	"adv_dis_stacks": {
		"file": "adv_dis_stacks",
		"tooltip": "Adv Dis Stacks"
	},
	"adv_vs_own_marked_target": {
		"file": "adv",
		"tooltip": "Adv"
	},
	"advance_grapple_restrain": {
		"file": "advance_grapple_restrain",
		"tooltip": "Advance Grapple Restrain"
	},
	"advance_grapple_takedown": {
		"file": "advance_grapple_takedown",
		"tooltip": "Advance Grapple Takedown"
	},
	"advantage": {
		"file": "adv",
		"tooltip": "Advantage"
	},
	"adventure": {
		"file": "adventure",
		"tooltip": "Adventure"
	},
	"adventure_artist": {
		"file": "adventure_artist",
		"tooltip": "Adventure Artist"
	},
	"adventure_author": {
		"file": "adventure_author",
		"tooltip": "Adventure Author"
	},
	"adventure_description": {
		"file": "adventure_description",
		"tooltip": "Adventure Description"
	},
	"adventure_encounters": {
		"file": "adventure_encounters",
		"tooltip": "Adventure Encounters"
	},
	"adventure_ending_level": {
		"file": "adventure_ending_level",
		"tooltip": "Adventure Ending Level"
	},
	"adventure_genre": {
		"file": "adventure_genre",
		"tooltip": "Adventure Genre"
	},
	"adventure_starting_level": {
		"file": "adventure_starting_level",
		"tooltip": "Adventure Starting Level"
	},
	"adventure_subgenre": {
		"file": "adventure_subgenre",
		"tooltip": "Adventure Subgenre"
	},
	"adventure_type": {
		"file": "adventure",
		"tooltip": "Adventure structure (prep/run pattern)"
	},
	"adventuring_gear": {
		"file": "adventuring_gear",
		"tooltip": "Adventuring Gear"
	},
	"age_requirement": {
		"file": "age_requirement",
		"tooltip": "Age Requirement"
	},
	"air_mote": {
		"file": "air_mote",
		"tooltip": "Air Mote"
	},
	"alchemy_recipe": {
		"file": "alchemy_recipe",
		"tooltip": "Alchemy Recipe"
	},
	"all_creatures_hidden": {
		"file": "all_creatures_hidden",
		"tooltip": "All Creatures Hidden"
	},
	"all_creatures_private": {
		"file": "all_creatures_private",
		"tooltip": "All Creatures Private"
	},
	"all_creatures_public": {
		"file": "all_creatures_public",
		"tooltip": "All Creatures Public"
	},
	"all_creatures_pulled_from_encounter": {
		"file": "all_creatures_pulled_from_encounter",
		"tooltip": "All Creatures Pulled from Encounter"
	},
	"all_creatures_revealed": {
		"file": "all_creatures_revealed",
		"tooltip": "All Creatures Revealed"
	},
	"all_damage_output_changed_by_percentage": {
		"file": "all_damage_output_changed_by_percentage",
		"tooltip": "All Damage Output Changed by Percentage"
	},
	"all_dust_is_lost": {
		"file": "all_dust_is_lost",
		"tooltip": "All Dust Is Lost"
	},
	"all_incoming_damage_changed_by_percentage": {
		"file": "all_incoming_damage_changed_by_percentage",
		"tooltip": "All Incoming Damage Changed by Percentage"
	},
	"all_skills": {
		"file": "all_skills",
		"tooltip": "All Skills"
	},
	"all_skills_icons": {
		"file": "all_skills_icons",
		"tooltip": "All Skills Icons"
	},
	"all_skills_list": {
		"file": "all_skills_list",
		"tooltip": "All Skills List"
	},
	"alterations": {
		"file": "alterations",
		"tooltip": "Alterations"
	},
	"alternative_names": {
		"file": "alternative_names",
		"tooltip": "Alternative Names"
	},
	"ambience": {
		"file": "ambience",
		"tooltip": "Ambience"
	},
	"ammo": {
		"file": "ammo",
		"tooltip": "Ammo"
	},
	"ammo_classification": {
		"file": "ammo_classification",
		"tooltip": "Ammo Classification"
	},
	"ancestral_body": {
		"file": "body",
		"tooltip": "Ancestral Body"
	},
	"ancestral_essences": {
		"file": "ancestral_essences",
		"tooltip": "Ancestral Essences"
	},
	"ancestral_fortune": {
		"file": "fortune",
		"tooltip": "Ancestral Fortune"
	},
	"ancestral_mind": {
		"file": "mind",
		"tooltip": "Ancestral Mind"
	},
	"ancestral_soul": {
		"file": "soul",
		"tooltip": "Ancestral Soul"
	},
	"ancestral_spirit": {
		"file": "spirit",
		"tooltip": "Ancestral Spirit"
	},
	"ancestries": {
		"file": "ancestries",
		"tooltip": "Ancestries"
	},
	"ancestry": {
		"file": "ancestry",
		"tooltip": "Ancestry"
	},
	"ancestry_1": {
		"file": "ancestry_1",
		"tooltip": "Ancestry 1"
	},
	"ancestry_2": {
		"file": "ancestry_2",
		"tooltip": "Ancestry 2"
	},
	"animal_blood": {
		"file": "animal_blood",
		"tooltip": "Animal Blood"
	},
	"animal_bone": {
		"file": "animal_bone",
		"tooltip": "Animal Bone"
	},
	"animal_fat": {
		"file": "animal_fat",
		"tooltip": "Animal Fat"
	},
	"animal_meat": {
		"file": "animal_meat",
		"tooltip": "Animal Meat"
	},
	"animated_summon": {
		"file": "animated_summon",
		"tooltip": "Animated Summon"
	},
	"aoe": {
		"file": "aoe",
		"tooltip": "Aoe"
	},
	"aoe_distance": {
		"file": "aoe_distance",
		"tooltip": "Aoe Distance"
	},
	"aoe_distance_depth": {
		"file": "aoe_distance_depth",
		"tooltip": "Aoe Distance Depth"
	},
	"aoe_distance_height": {
		"file": "aoe_distance_height",
		"tooltip": "Aoe Distance Height"
	},
	"aoe_distance_width": {
		"file": "aoe_distance_width",
		"tooltip": "Aoe Distance Width"
	},
	"aoe_follows_target": {
		"file": "aoe_follows_target",
		"tooltip": "Aoe Follows Target"
	},
	"aoe_spells_spare_allies": {
		"file": "effect_only_affects_opposing_team_type",
		"tooltip": "Effect Only Affects Opposing Team Type"
	},
	"aoe_type": {
		"file": "aoe_type",
		"tooltip": "Aoe Type"
	},
	"ap": {
		"file": "ap",
		"tooltip": "Ap"
	},
	"ap_change_at_start_of_turn": {
		"file": "ap_change_at_start_of_turn",
		"tooltip": "Ap Change at Start of Turn"
	},
	"ap_change_during_turn": {
		"file": "ap_change_during_turn",
		"tooltip": "Ap Change During Turn"
	},
	"ap_change_to_caster_during_turn": {
		"file": "ap_change_to_caster_during_turn",
		"tooltip": "Ap Change to Caster During Turn"
	},
	"aps_total": {
		"file": "aps_total",
		"tooltip": "Aps Total"
	},
	"arcane_threshold": {
		"file": "arcane_threshold",
		"tooltip": "Arcane Threshold"
	},
	"archived": {
		"file": "archive",
		"tooltip": "Archived"
	},
	"arcing_trajectory": {
		"file": "throw",
		"tooltip": "Throw"
	},
	"armor": {
		"file": "armor",
		"tooltip": "Armor"
	},
	"armor_bending_roll_failed": {
		"file": "armor_bending_roll",
		"tooltip": "Armor Bending Roll Failed"
	},
	"armor_class": {
		"file": "armor_class",
		"tooltip": "Armor Class"
	},
	"armor_classification": {
		"file": "armor_classification",
		"tooltip": "Armor Classification"
	},
	"armor_equipped": {
		"file": "armor_equipped",
		"tooltip": "Armor Equipped"
	},
	"armor_skill": {
		"file": "armor_skill",
		"tooltip": "Armor Skill"
	},
	"armor_type": {
		"file": "armor_type",
		"tooltip": "Armor Type"
	},
	"array_check": {
		"file": "array_check",
		"tooltip": "Array Check"
	},
	"art_recipe": {
		"file": "art_recipe",
		"tooltip": "Art Recipe"
	},
	"article": {
		"file": "article",
		"tooltip": "Article"
	},
	"article_body": {
		"file": "article_body",
		"tooltip": "Article Body"
	},
	"article_ethnicity": {
		"file": "article_ethnicity",
		"tooltip": "Article Ethnicity"
	},
	"article_law": {
		"file": "article_law",
		"tooltip": "Article Law"
	},
	"article_rank": {
		"file": "article_rank",
		"tooltip": "Article Rank"
	},
	"article_report": {
		"file": "article_report",
		"tooltip": "Article Report"
	},
	"article_technology": {
		"file": "article_technology",
		"tooltip": "Article Technology"
	},
	"artist": {
		"file": "artist",
		"tooltip": "Artist"
	},
	"artwork": {
		"file": "artwork",
		"tooltip": "Artwork"
	},
	"ascension_skill_point": {
		"file": "ascension_skill_point",
		"tooltip": "Ascension Skill Point"
	},
	"ascension_skill_point_range_mod": {
		"file": "ascension_skill_point_range_mod",
		"tooltip": "Ascension Skill Point Range Mod"
	},
	"ascension_skill_tier_up": {
		"file": "ascension_skill_point",
		"tooltip": "Ascension Skill Tier Up"
	},
	"assets": {
		"file": "assets",
		"tooltip": "Assets"
	},
	"assistable_status": {
		"file": "assistable_status",
		"tooltip": "Assistable Status"
	},
	"at_will_spell": {
		"file": "at_will_spell",
		"tooltip": "At Will Spell"
	},
	"attach_layer_to_item": {
		"file": "attach_layer_to_item",
		"tooltip": "Attach Layer to Item"
	},
	"attached": {
		"file": "attached",
		"tooltip": "Attached"
	},
	"attached_encounters": {
		"file": "attached_encounters",
		"tooltip": "Attached Encounters"
	},
	"attached_equipped_weapon": {
		"file": "attached_equipped_weapon",
		"tooltip": "Attached Equipped Weapon"
	},
	"attached_loot_table": {
		"file": "attached_loot_table",
		"tooltip": "Attached Loot Table"
	},
	"attached_weapon_form": {
		"file": "natural_weapon",
		"tooltip": "Attached to Weapon Form(s)"
	},
	"attack_abilities": {
		"file": "attack_abilities",
		"tooltip": "Attack Abilities"
	},
	"attack_ability": {
		"file": "attack_ability",
		"tooltip": "Attack Ability"
	},
	"attack_ability_throws_the_throwing_weapon_at_target": {
		"file": "attack_ability_throws_the_throwing_weapon_at_target",
		"tooltip": "Attack Ability Throws the Throwing Weapon at Target"
	},
	"attack_automatically_hits": {
		"file": "attack_automatically_hits",
		"tooltip": "Attack Automatically Hits"
	},
	"attack_automatically_misses": {
		"file": "attack_automatically_misses",
		"tooltip": "Attack Automatically Misses"
	},
	"attacks_ignore_damage_mitigation": {
		"file": "effect_ignores_damage_type_resistance",
		"tooltip": "Effect Ignores Damage Type Resistance"
	},
	"attacks_ignore_natural_damage_mitigation": {
		"file": "damage_mitigation",
		"tooltip": "Attacks ignore natural Damage Mitigation"
	},
	"audio_category": {
		"file": "audio_category",
		"tooltip": "Audio Category"
	},
	"audio_name": {
		"file": "audio_name",
		"tooltip": "Audio Name"
	},
	"audio_settings": {
		"file": "audio_settings",
		"tooltip": "Audio Settings"
	},
	"audio_subcategory": {
		"file": "audio_subcategory",
		"tooltip": "Audio Subcategory"
	},
	"audio_type": {
		"file": "audio_type",
		"tooltip": "Audio Type"
	},
	"aura_distance_mod": {
		"file": "aoe_distance",
		"tooltip": "Aoe Distance"
	},
	"author": {
		"file": "author",
		"tooltip": "Author"
	},
	"auto_end_turn_active": {
		"file": "auto_end_turn_active",
		"tooltip": "Auto End Turn Active"
	},
	"auto_end_turn_inactive": {
		"file": "auto_end_turn_inactive",
		"tooltip": "Auto End Turn Inactive"
	},
	"auto_end_turn_off": {
		"file": "auto_end_turn_off",
		"tooltip": "Auto End Turn Off"
	},
	"auto_end_turn_on": {
		"file": "auto_end_turn_on",
		"tooltip": "Auto End Turn on"
	},
	"avatar": {
		"file": "avatar",
		"tooltip": "Avatar"
	},
	"award_experience_marks": {
		"file": "award_experience_marks",
		"tooltip": "Award Experience Marks"
	},
	"award_luck": {
		"file": "award_luck",
		"tooltip": "Award Luck"
	},
	"awarded_experience_marks": {
		"file": "awarded_experience_marks",
		"tooltip": "Awarded Experience Marks"
	},
	"axis": {
		"file": "axis",
		"tooltip": "Axis"
	},
	"background": {
		"file": "background",
		"tooltip": "Background"
	},
	"background_body": {
		"file": "body",
		"tooltip": "Background Body"
	},
	"background_essences": {
		"file": "background_essences",
		"tooltip": "Background Essences"
	},
	"background_feature": {
		"file": "background_feature",
		"tooltip": "Background Feature"
	},
	"background_fortune": {
		"file": "fortune",
		"tooltip": "Background Fortune"
	},
	"background_mind": {
		"file": "mind",
		"tooltip": "Background Mind"
	},
	"background_soul": {
		"file": "soul",
		"tooltip": "Background Soul"
	},
	"background_spirit": {
		"file": "spirit",
		"tooltip": "Background Spirit"
	},
	"balance_trade": {
		"file": "balance_trade",
		"tooltip": "Balance Trade"
	},
	"bane": {
		"file": "bane",
		"tooltip": "Bane"
	},
	"bar_chart": {
		"file": "bar_chart",
		"tooltip": "Bar Chart"
	},
	"barding": {
		"file": "barding",
		"tooltip": "Barding"
	},
	"become_publisher": {
		"file": "publisher",
		"tooltip": "Become Publisher"
	},
	"blindsight_blind": {
		"file": "blindsight_blind",
		"tooltip": "Blindsight Blind"
	},
	"body_vanishes_at_zero_vitality": {
		"file": "body_vanishes_at_zero_vitality",
		"tooltip": "Body Vanishes at Zero Vitality"
	},
	"bond": {
		"file": "bond",
		"tooltip": "Bond"
	},
	"book": {
		"file": "book",
		"tooltip": "Book"
	},
	"book_read": {
		"file": "book_read",
		"tooltip": "Book Read"
	},
	"boon": {
		"file": "boon",
		"tooltip": "Boon"
	},
	"brazier": {
		"file": "brazier",
		"tooltip": "Brazier"
	},
	"brewing_recipe": {
		"file": "brewing_recipe",
		"tooltip": "Brewing Recipe"
	},
	"bright_light_dim_light": {
		"file": "bright_light_dim_light",
		"tooltip": "Bright Light Dim Light"
	},
	"brightlight": {
		"file": "brightlight",
		"tooltip": "Brightlight"
	},
	"buck_creature": {
		"file": "buck_creature",
		"tooltip": "Buck Creature"
	},
	"buff_does_not_layer_onto_opposing_team": {
		"file": "buff_does_not_layer_onto_opposing_team",
		"tooltip": "Buff Does Not Layer Onto Opposing Team"
	},
	"building": {
		"file": "building",
		"tooltip": "Building"
	},
	"building_location_type": {
		"file": "building_location_type",
		"tooltip": "Building Location Type"
	},
	"bullseye_lantern": {
		"file": "bullseye_lantern",
		"tooltip": "Bullseye Lantern"
	},
	"burning_extinguished": {
		"file": "burning_extinguished",
		"tooltip": "Burning Extinguished"
	},
	"burrows_worked_stone": {
		"file": "ignores_difficult_terrain",
		"tooltip": "Burrows through worked stone"
	},
	"cache": {
		"file": "cache",
		"tooltip": "Cache"
	},
	"calendar": {
		"file": "calendar",
		"tooltip": "Calendar"
	},
	"calendar_date": {
		"file": "calendar_date",
		"tooltip": "Calendar Date"
	},
	"calendar_time": {
		"file": "calendar_time",
		"tooltip": "Calendar Time"
	},
	"calligraphy_recipe": {
		"file": "calligraphy_recipe",
		"tooltip": "Calligraphy Recipe"
	},
	"camera_view_isometric": {
		"file": "camera_view_isometric",
		"tooltip": "Camera View Isometric"
	},
	"campaign": {
		"file": "campaign",
		"tooltip": "Campaign"
	},
	"campaign_campsite": {
		"file": "campaign_campsite",
		"tooltip": "Campaign Campsite"
	},
	"campaign_difficulty": {
		"file": "campaign_difficulty",
		"tooltip": "Campaign Difficulty"
	},
	"campaign_difficulty_easy": {
		"file": "campaign_difficulty_easy",
		"tooltip": "Campaign Difficulty Easy"
	},
	"campaign_difficulty_hardcore": {
		"file": "campaign_difficulty_hardcore",
		"tooltip": "Campaign Difficulty Hardcore"
	},
	"campaign_difficulty_normal": {
		"file": "campaign_difficulty_normal",
		"tooltip": "Campaign Difficulty Normal"
	},
	"campaign_downtime_disabled": {
		"file": "campaign_downtime_disabled",
		"tooltip": "Campaign downtime disabled"
	},
	"campaign_downtime_enabled": {
		"file": "campaign_downtime_enabled",
		"tooltip": "Campaign downtime enabled"
	},
	"campaign_downtime_time_pushed": {
		"file": "campaign_downtime_time_pushed",
		"tooltip": "Campaign downtime — time pushed"
	},
	"campaign_encounters": {
		"file": "campaign_encounters",
		"tooltip": "Campaign Encounters"
	},
	"campaign_end_date": {
		"file": "campaign_end_date",
		"tooltip": "Campaign End Date"
	},
	"campaign_house_rule_type": {
		"file": "campaign_house_rule_type",
		"tooltip": "Optional campaign rule"
	},
	"campaign_level": {
		"file": "campaign_level",
		"tooltip": "Campaign Level"
	},
	"campaign_notes": {
		"file": "campaign_notes",
		"tooltip": "Campaign Notes"
	},
	"campaign_session": {
		"file": "campaign_session",
		"tooltip": "Campaign Session"
	},
	"campaign_setting": {
		"file": "campaign_setting",
		"tooltip": "Campaign Setting"
	},
	"campaign_start_date": {
		"file": "campaign_start_date",
		"tooltip": "Campaign Start Date"
	},
	"campaign_stronghold": {
		"file": "campaign_stronghold",
		"tooltip": "Campaign Stronghold"
	},
	"campfire": {
		"file": "campfire",
		"tooltip": "Campfire"
	},
	"can_breath_underwater": {
		"file": "can_breath_underwater",
		"tooltip": "Can Breath Underwater"
	},
	"cancel_aoe": {
		"file": "cancel_aoe",
		"tooltip": "Cancel Aoe"
	},
	"cancelled_lockpicking": {
		"file": "cancelled_lockpicking",
		"tooltip": "Cancelled Lockpicking"
	},
	"candle": {
		"file": "candle",
		"tooltip": "Candle"
	},
	"candle_chandelier": {
		"file": "candle_chandelier",
		"tooltip": "Candle Chandelier"
	},
	"candleabra": {
		"file": "candleabra",
		"tooltip": "Candelabra"
	},
	"candlelight": {
		"file": "candlelight",
		"tooltip": "Candlelight"
	},
	"cannot_be_targeted_by_a_contesting_roll_ability": {
		"file": "cannot_be_targeted_by_a_contesting_roll_ability",
		"tooltip": "Cannot Be Targeted by a Contesting Roll Ability"
	},
	"carrying_capacity": {
		"file": "carrying_capacity",
		"tooltip": "Carrying Capacity"
	},
	"carrying_capacity_cu_ft": {
		"file": "carrying_capacity_cu_ft",
		"tooltip": "Carrying Capacity Cu Ft"
	},
	"carrying_capacity_cu_in": {
		"file": "carrying_capacity_cu_in",
		"tooltip": "Carrying Capacity Cu in"
	},
	"carrying_capacity_fixed_weight": {
		"file": "carrying_capacity_fixed_weight",
		"tooltip": "Carrying Capacity Fixed Weight"
	},
	"carrying_capacity_multiplier": {
		"file": "carrying_capacity_pounds",
		"tooltip": "Carrying Capacity Pounds"
	},
	"carrying_capacity_people": {
		"file": "carrying_capacity_people",
		"tooltip": "Carrying Capacity People"
	},
	"carrying_capacity_pounds": {
		"file": "carrying_capacity_pounds",
		"tooltip": "Carrying Capacity Pounds"
	},
	"cast_1ap_spell": {
		"file": "cast_1ap_spell",
		"tooltip": "Cast 1ap Spell"
	},
	"cast_2ap_spell": {
		"file": "cast_2ap_spell",
		"tooltip": "Cast 2ap Spell"
	},
	"cast_3ap_spell": {
		"file": "cast_3ap_spell",
		"tooltip": "Cast 3ap Spell"
	},
	"cast_reaction_spell": {
		"file": "cast_reaction_spell",
		"tooltip": "Cast Reaction Spell"
	},
	"cast_ritual_spell": {
		"file": "cast_ritual_spell",
		"tooltip": "Cast Ritual Spell"
	},
	"cast_spell": {
		"file": "cast_spell",
		"tooltip": "Cast Spell"
	},
	"cast_spell_through_summon_range": {
		"file": "cast_spell_through_summon_range",
		"tooltip": "Cast Spell Through Summon Range"
	},
	"cast_upcastable_spell": {
		"file": "cast_upcastable_spell",
		"tooltip": "Cast Upcastable Spell"
	},
	"castable_spells": {
		"file": "castable_spells",
		"tooltip": "Castable Spells"
	},
	"caster": {
		"file": "caster",
		"tooltip": "Caster"
	},
	"caster_dive_bombs_target": {
		"file": "caster_dive_bombs_target",
		"tooltip": "Caster Dive Bombs Target"
	},
	"caster_may_move_target_each_turn_ft": {
		"file": "push_any_direction",
		"tooltip": "Move a held creature at the start of your turn (ft)"
	},
	"caster_moves_to_end_point_of_aoe_effect_after_cast": {
		"file": "caster_moves_to_end_point_of_aoe_effect_after_cast",
		"tooltip": "Caster Moves to End Point of Aoe Effect After Cast"
	},
	"caster_moves_towards_target_in_ft": {
		"file": "caster_moves_towards_target_in_ft",
		"tooltip": "Caster Moves Towards Target in Ft"
	},
	"caster_type": {
		"file": "caster_type",
		"tooltip": "Caster Type"
	},
	"casting_ritual": {
		"file": "casting_ritual_spell",
		"tooltip": "Casting Ritual"
	},
	"category": {
		"file": "category_v2",
		"tooltip": "Category"
	},
	"center_axis": {
		"file": "center_axis",
		"tooltip": "Center Axis"
	},
	"chain_dice": {
		"file": "dice",
		"tooltip": "Leap damage dice"
	},
	"chain_die": {
		"file": "die",
		"tooltip": "Leap damage die size"
	},
	"chain_distance_ft": {
		"file": "aoe_distance",
		"tooltip": "Leap targets must be within this distance of the first target (ft)"
	},
	"chain_targets_max": {
		"file": "max_target",
		"tooltip": "Leaps to up to N more creatures on a hit"
	},
	"challenge_rating": {
		"file": "challenge_rating",
		"tooltip": "Challenge Rating"
	},
	"challenge_roll_assistance_roll": {
		"file": "challenge_roll_assistance_roll",
		"tooltip": "Challenge Roll Assistance Roll"
	},
	"change_caster_luck": {
		"file": "change_caster_luck",
		"tooltip": "Change Caster Luck"
	},
	"change_caster_mana": {
		"file": "change_caster_mana",
		"tooltip": "Change Caster Mana"
	},
	"change_charge": {
		"file": "change_charges",
		"tooltip": "Change Charge"
	},
	"change_charges": {
		"file": "change_charges",
		"tooltip": "Change Charges"
	},
	"change_creature_size": {
		"file": "change_creature_size",
		"tooltip": "Change Creature Size"
	},
	"change_encounter_light_type": {
		"file": "change_encounter_light_type",
		"tooltip": "Change Encounter Light Type"
	},
	"change_encounter_weather": {
		"file": "change_encounter_weather",
		"tooltip": "Change Encounter Weather"
	},
	"change_hunger": {
		"file": "change_hunger",
		"tooltip": "Change Hunger"
	},
	"change_luck_for_target": {
		"file": "change_luck_for_target",
		"tooltip": "Change Target's Luck"
	},
	"change_mana_for_target": {
		"file": "change_mana_for_target",
		"tooltip": "Change Target's Mana"
	},
	"change_thirst": {
		"file": "change_thirst",
		"tooltip": "Change Thirst"
	},
	"channel_chosen_orb": {
		"file": "channel_orb",
		"tooltip": "Channel Orbs of Your Choosing"
	},
	"channel_orb": {
		"file": "channel_orb",
		"tooltip": "Channel Orb"
	},
	"channel_orb_each_turn": {
		"file": "channel_orb",
		"tooltip": "Channel Orbs Every Turn"
	},
	"character_description": {
		"file": "character_description",
		"tooltip": "Character Description"
	},
	"character_name": {
		"file": "character_name",
		"tooltip": "Character Name"
	},
	"character_wealth_by_level": {
		"file": "character_wealth_by_level",
		"tooltip": "Character Wealth by Level"
	},
	"charge": {
		"file": "charge",
		"tooltip": "Charge"
	},
	"charged_ability": {
		"file": "charged_ability",
		"tooltip": "Charged Ability"
	},
	"charged_spell": {
		"file": "charged_spell",
		"tooltip": "Charged Spell"
	},
	"charges_cannot_be_reduced": {
		"file": "ability_charges",
		"tooltip": "Ability Charges"
	},
	"charges_remaining": {
		"file": "charges_remaining",
		"tooltip": "Charges Remaining"
	},
	"chat": {
		"file": "chat",
		"tooltip": "Chat"
	},
	"check": {
		"file": "check",
		"tooltip": "Check"
	},
	"chooseable": {
		"file": "chooseable",
		"tooltip": "Chooseable"
	},
	"chooseable_targets_in_aoe": {
		"file": "chooseable_targets_in_aoe",
		"tooltip": "Chooseable Targets in Aoe"
	},
	"circle_of_magic": {
		"file": "circle_of_magic",
		"tooltip": "Circle of Magic"
	},
	"circles_of_magic": {
		"file": "circles_of_magic",
		"tooltip": "Circles of Magic"
	},
	"class": {
		"file": "class",
		"tooltip": "Class"
	},
	"class_aura": {
		"file": "aoe_follows_target",
		"tooltip": "Aoe Follows Target"
	},
	"class_information": {
		"file": "class_information",
		"tooltip": "Class Information"
	},
	"class_spellcasting_restricted_spell_circle": {
		"file": "class_spellcasting_restricted_spell_circle",
		"tooltip": "Class Spellcasting Restricted Spell Circle"
	},
	"class_spellcasting_restricted_spell_sphere": {
		"file": "class_spellcasting_restricted_spell_sphere",
		"tooltip": "Class Spellcasting Restricted Spell Sphere"
	},
	"classes": {
		"file": "classes",
		"tooltip": "Classes"
	},
	"clear": {
		"file": "clear",
		"tooltip": "Clear"
	},
	"clear_all": {
		"file": "clear_all",
		"tooltip": "Clear All"
	},
	"clear_audio": {
		"file": "clear_audio",
		"tooltip": "Clear Audio"
	},
	"clear_caster": {
		"file": "clear_caster",
		"tooltip": "Clear Caster"
	},
	"clear_dice": {
		"file": "clear_dice",
		"tooltip": "Clear Dice"
	},
	"clear_encounter_location_picture": {
		"file": "clear_encounter_location_picture",
		"tooltip": "Clear Encounter Location Picture"
	},
	"clear_filter": {
		"file": "clear_filter",
		"tooltip": "Clear filter"
	},
	"clear_target": {
		"file": "clear_target",
		"tooltip": "Clear Target"
	},
	"clear_trigger": {
		"file": "clear_trigger",
		"tooltip": "Clear trigger overlays (restore default auto-fire)"
	},
	"climate": {
		"file": "climate",
		"tooltip": "Climate"
	},
	"close": {
		"file": "close",
		"tooltip": "Close"
	},
	"close_sidelog": {
		"file": "close_sidelog",
		"tooltip": "Close Sidelog"
	},
	"clothes": {
		"file": "clothes",
		"tooltip": "Clothes"
	},
	"clothing": {
		"file": "clothing",
		"tooltip": "Clothing"
	},
	"coating": {
		"file": "coating",
		"tooltip": "Coating"
	},
	"cobbling_recipe": {
		"file": "cobbling_recipe",
		"tooltip": "Cobbling Recipe"
	},
	"combat": {
		"file": "combat",
		"tooltip": "Combat"
	},
	"combat_descriptor": {
		"file": "combat_descriptor",
		"tooltip": "Combat Descriptor"
	},
	"combat_ended": {
		"file": "combat_ended",
		"tooltip": "Combat Ended"
	},
	"complex_roll": {
		"file": "complex_roll",
		"tooltip": "Complex Roll"
	},
	"concentrating": {
		"file": "concentrating",
		"tooltip": "Concentrating"
	},
	"concentration": {
		"file": "concentration",
		"tooltip": "Concentration"
	},
	"concentration_broken": {
		"file": "concentration_broken",
		"tooltip": "Concentration Broken"
	},
	"concentration_maintained": {
		"file": "concentration_maintained",
		"tooltip": "Concentration Maintained"
	},
	"concentration_roll_is_rolled_at_max": {
		"file": "roll_type_is_rolled_at_max",
		"tooltip": "Concentration rolls are rolled at max"
	},
	"concentration_roll_is_rolled_at_min": {
		"file": "roll_type_is_rolled_at_min",
		"tooltip": "Concentration rolls are rolled at min"
	},
	"confirm": {
		"file": "confirm",
		"tooltip": "Confirm"
	},
	"confirm_aoe": {
		"file": "confirm_aoe",
		"tooltip": "Confirm Aoe"
	},
	"confirm_delete_adventure": {
		"file": "delete_adventure",
		"tooltip": "Confirm Delete Adventure"
	},
	"confirm_delete_campaign": {
		"file": "confirm_delete_campaign",
		"tooltip": "Confirm Delete Campaign"
	},
	"confirm_delete_campaign_session": {
		"file": "confirm_delete_campaign_session",
		"tooltip": "Confirm Delete Campaign Session"
	},
	"confirm_delete_encounter": {
		"file": "confirm_delete_encounter",
		"tooltip": "Confirm Delete Encounter"
	},
	"confirm_delete_encounter_creature": {
		"file": "confirm_delete_encounter_creature",
		"tooltip": "Confirm Delete Encounter Creature"
	},
	"confirm_delete_inventory": {
		"file": "confirm_delete_inventory",
		"tooltip": "Confirm Delete Inventory"
	},
	"confirm_delete_player_character": {
		"file": "confirm_delete_player_character",
		"tooltip": "Confirm Delete Player Character"
	},
	"confirm_delete_world": {
		"file": "confirm_delete_world",
		"tooltip": "Confirm Delete World"
	},
	"confirm_kick_player_character_from_campaign": {
		"file": "confirm_kick_player_character_from_campaign",
		"tooltip": "Confirm Kick Player Character from Campaign"
	},
	"confirm_layer_edit": {
		"file": "confirm_layer_edit",
		"tooltip": "Confirm Layer Edit"
	},
	"confirm_long_rest_party": {
		"file": "confirm_long_rest_party",
		"tooltip": "Confirm Long Rest Party"
	},
	"confirm_primary_picture": {
		"file": "confirm_primary_picture",
		"tooltip": "Confirm Primary Picture"
	},
	"confirm_primary_video": {
		"file": "confirm_primary_video",
		"tooltip": "Confirm Primary Video"
	},
	"constrain_to_environment_type": {
		"file": "constrain_to_environment_type",
		"tooltip": "Constrain to Environment Type"
	},
	"construction_date_day": {
		"file": "construction_date_day",
		"tooltip": "Construction Date Day"
	},
	"construction_date_era": {
		"file": "construction_date_era",
		"tooltip": "Construction Date Era"
	},
	"construction_date_month": {
		"file": "construction_date_month",
		"tooltip": "Construction Date Month"
	},
	"construction_date_year": {
		"file": "construction_date_year",
		"tooltip": "Construction Date Year"
	},
	"consumable": {
		"file": "consumable",
		"tooltip": "Consumable"
	},
	"consume": {
		"file": "consume",
		"tooltip": "Consume"
	},
	"consume_ability_charges_for_target": {
		"file": "consume_ability_charges_for_target",
		"tooltip": "Consume Target Ability Charges"
	},
	"consume_ability_charges_qty_for_target": {
		"file": "consume_ability_charges_qty_for_target",
		"tooltip": "Consume Target Ability Charges — Quantity"
	},
	"consume_v_dice": {
		"file": "v_dice",
		"tooltip": "Consume V Dice"
	},
	"consumes_ability_charges": {
		"file": "consumes_ability_charges",
		"tooltip": "Consumes Ability Charges"
	},
	"consumes_ability_charges_from_caster_after_contesting_roll_failed": {
		"file": "consumes_ability_charges_from_caster_after_contesting_roll_failed",
		"tooltip": "Consumes Ability Charges from Caster After Contesting Roll Failed"
	},
	"consumes_mana_on_hit": {
		"file": "consumes_mana_on_hit",
		"tooltip": "Consumes Mana on Hit"
	},
	"consumes_passive_ability_charges": {
		"file": "consumes_passive_ability_charges",
		"tooltip": "Consumes Passive Ability Charges"
	},
	"consumes_unit_per_use": {
		"file": "consumes_unit_per_use",
		"tooltip": "Consumes Unit Per Use"
	},
	"container": {
		"file": "container",
		"tooltip": "Container"
	},
	"contest_required_to_target_above_spell_level": {
		"file": "contesting_roll_adv_vs_spells",
		"tooltip": "Contesting Roll Adv Vs Spells"
	},
	"contesting_roll": {
		"file": "contesting_roll",
		"tooltip": "Contesting Roll"
	},
	"contesting_roll_adv": {
		"file": "contesting_roll_adv",
		"tooltip": "Contesting Roll Adv"
	},
	"contesting_roll_adv_vs_spells": {
		"file": "contesting_roll_adv_vs_spells",
		"tooltip": "Contesting Roll Adv Vs Spells"
	},
	"contesting_roll_adv_vs_status_effect": {
		"file": "contesting_roll_adv_vs_status_effect",
		"tooltip": "Contesting Roll Adv Vs Status Effect"
	},
	"contesting_roll_dis": {
		"file": "contesting_roll_dis",
		"tooltip": "Contesting Roll Dis"
	},
	"contesting_roll_dis_vs_spells": {
		"file": "contesting_roll_dis_vs_spells",
		"tooltip": "Contesting Roll Dis Vs Spells"
	},
	"contesting_roll_dis_vs_status_effect": {
		"file": "contesting_roll_dis_vs_status_effect",
		"tooltip": "Contesting Roll Dis Vs Status Effect"
	},
	"contesting_roll_mod": {
		"file": "contesting_roll_mod",
		"tooltip": "Contesting Roll Mod"
	},
	"contesting_roll_skipped_for_same_team_type": {
		"file": "contesting_roll_skipped_for_same_team_type",
		"tooltip": "Contesting Roll Skipped for Same Team Type"
	},
	"contesting_roll_successful_for_half_damage": {
		"file": "contesting_roll_successful_for_half_damage",
		"tooltip": "Contesting Roll Successful for Half Damage"
	},
	"contesting_rolls_mod": {
		"file": "contesting_rolls_mod",
		"tooltip": "Contesting Rolls Mod"
	},
	"contingent_ability": {
		"file": "contingent_ability",
		"tooltip": "Contingent Ability"
	},
	"controlled": {
		"file": "controlled",
		"tooltip": "Controlled"
	},
	"controlled_fury": {
		"file": "controlled_fury",
		"tooltip": "Controlled Fury"
	},
	"cooking_recipe": {
		"file": "cooking_recipe",
		"tooltip": "Cooking Recipe"
	},
	"copy": {
		"file": "copy",
		"tooltip": "Copy"
	},
	"copy_adventure_to_campaign": {
		"file": "copy_adventure_to_campaign",
		"tooltip": "Copy Adventure to Campaign"
	},
	"copy_adventure_to_my_world": {
		"file": "copy_adventure_to_my_world",
		"tooltip": "Copy Adventure to My World"
	},
	"copy_campaign_invite_code": {
		"file": "copy_campaign_invite_code",
		"tooltip": "Copy Campaign Invite Code"
	},
	"copy_enchantment_template": {
		"file": "copy_enchantment_template",
		"tooltip": "Copy Enchantment Template"
	},
	"copy_encounter": {
		"file": "copy_encounter",
		"tooltip": "Copy Encounter"
	},
	"copy_item": {
		"file": "copy_item",
		"tooltip": "Copy Item"
	},
	"copy_item_id": {
		"file": "copy_item_id",
		"tooltip": "Copy Item Id"
	},
	"copy_item_name": {
		"file": "copy_item_name",
		"tooltip": "Copy Item Name"
	},
	"copy_layer": {
		"file": "copy_layer",
		"tooltip": "Copy Layer"
	},
	"copy_monster_template": {
		"file": "copy_monster_template",
		"tooltip": "Copy Monster Template"
	},
	"copy_player_character": {
		"file": "copy_player_character",
		"tooltip": "Copy Player Character"
	},
	"copy_prompt": {
		"file": "copy_prompt",
		"tooltip": "Copy Prompt"
	},
	"copy_prompt_with_existing_flavor_text": {
		"file": "copy_prompt_with_existing_flavor_text",
		"tooltip": "Copy Prompt with Existing Flavor Text"
	},
	"copy_selected_locations_to_adventure": {
		"file": "copy_selected_locations_to_adventure",
		"tooltip": "Copy Selected Locations to Adventure"
	},
	"copy_selected_locations_to_campaign": {
		"file": "copy_selected_locations_to_campaign",
		"tooltip": "Copy Selected Locations to Campaign"
	},
	"copy_selected_locations_to_my_world": {
		"file": "copy_selected_locations_to_my_world",
		"tooltip": "Copy Selected Locations to My World"
	},
	"cosmetology_recipe": {
		"file": "cosmetology_recipe",
		"tooltip": "Cosmetology Recipe"
	},
	"cost_gp_max": {
		"file": "cost_gp_max",
		"tooltip": "Cost Gp Max"
	},
	"cost_gp_min": {
		"file": "cost_gp_min",
		"tooltip": "Cost Gp Min"
	},
	"cost_gp_multiplier": {
		"file": "cost_gp_multiplier",
		"tooltip": "Cost Gp Multiplier"
	},
	"counterspell_armed": {
		"file": "cast_spell",
		"tooltip": "Counterspell Armed"
	},
	"counterspell_circle_locked": {
		"file": "counterspell_circle_locked",
		"tooltip": "Counterspell Circle Locked"
	},
	"counterspell_failed": {
		"file": "cast_spell",
		"tooltip": "Counterspell Failed"
	},
	"counterspell_fizzled": {
		"file": "cast_spell",
		"tooltip": "Counterspell Fizzled"
	},
	"counterspell_spell_locked": {
		"file": "counterspell_spell_locked",
		"tooltip": "Counterspell Spell Locked"
	},
	"counterspell_sphere_locked": {
		"file": "counterspell_sphere_locked",
		"tooltip": "Counterspell Sphere Locked"
	},
	"counterspell_success": {
		"file": "cast_spell",
		"tooltip": "Counterspell Succeeded"
	},
	"counterspell_tie": {
		"file": "cast_spell",
		"tooltip": "Counterspell Tie"
	},
	"counterspell_tier": {
		"file": "counterspell_tier",
		"tooltip": "Counterspell Tier"
	},
	"counterspelling_effect": {
		"file": "counterspelling_effect",
		"tooltip": "Counterspelling Effect"
	},
	"cr": {
		"file": "cr",
		"tooltip": "Cr"
	},
	"crafting": {
		"file": "crafting",
		"tooltip": "Crafting"
	},
	"crafting_skill": {
		"file": "crafting_skill",
		"tooltip": "Crafting Skill"
	},
	"crafting_time": {
		"file": "crafting_time",
		"tooltip": "Crafting Time"
	},
	"crafting_waives_nonmagical_reagents": {
		"file": "crafting",
		"tooltip": "Crafting"
	},
	"create_adventure": {
		"file": "create_adventure",
		"tooltip": "Create Adventure"
	},
	"create_article": {
		"file": "create_article",
		"tooltip": "Create Article"
	},
	"create_campaign": {
		"file": "create_campaign",
		"tooltip": "Create Campaign"
	},
	"create_category": {
		"file": "create_category_v2",
		"tooltip": "Create Category"
	},
	"create_enchantment_template": {
		"file": "create_enchantment_template",
		"tooltip": "Create Enchantment Template"
	},
	"create_encounter": {
		"file": "create_encounter",
		"tooltip": "Create Encounter"
	},
	"create_item": {
		"file": "create_item",
		"tooltip": "Create Item"
	},
	"create_item_layer_type": {
		"file": "create_item_layer_type",
		"tooltip": "Create Item Layer Type"
	},
	"create_item_type": {
		"file": "create_item_type",
		"tooltip": "Create Item Type"
	},
	"create_monster_template": {
		"file": "create_monster_template",
		"tooltip": "Create Monster Template"
	},
	"create_player_character": {
		"file": "create_player_character",
		"tooltip": "Create Player Character"
	},
	"create_timeline_age": {
		"file": "create_timeline_age",
		"tooltip": "Create Timeline Age"
	},
	"create_timeline_event": {
		"file": "create_timeline_event",
		"tooltip": "Create Timeline Event"
	},
	"create_world": {
		"file": "create_world",
		"tooltip": "Create World"
	},
	"creature": {
		"file": "creature",
		"tooltip": "Creature"
	},
	"creature_ancestry": {
		"file": "creature_ancestry",
		"tooltip": "Creature Ancestry"
	},
	"creature_ap": {
		"file": "creature_ap",
		"tooltip": "Creature Ap"
	},
	"creature_destroyed": {
		"file": "creature_destroyed",
		"tooltip": "Creature Destroyed"
	},
	"creature_environment": {
		"file": "creature_environment",
		"tooltip": "Creature Environment"
	},
	"creature_fell": {
		"file": "creature_fell",
		"tooltip": "Creature Fell"
	},
	"creature_grouping": {
		"file": "creature_grouping",
		"tooltip": "Creature Grouping"
	},
	"creature_hidden": {
		"file": "creature_hidden",
		"tooltip": "Creature Hidden"
	},
	"creature_killed": {
		"file": "creature_killed",
		"tooltip": "Creature Killed"
	},
	"creature_killed_forever": {
		"file": "creature_killed_forever",
		"tooltip": "Creature Killed Forever"
	},
	"creature_lineage": {
		"file": "creature_lineage",
		"tooltip": "Creature Lineage"
	},
	"creature_model": {
		"file": "creature_model",
		"tooltip": "Creature Model"
	},
	"creature_number": {
		"file": "creature_number",
		"tooltip": "Creature Number"
	},
	"creature_private": {
		"file": "all_creatures_private",
		"tooltip": "Creature Made Private"
	},
	"creature_public": {
		"file": "all_creatures_public",
		"tooltip": "Creature Made Public"
	},
	"creature_qty": {
		"file": "creature_qty",
		"tooltip": "Creature quantity"
	},
	"creature_resurrected": {
		"file": "creature_resurrected",
		"tooltip": "Creature Resurrected"
	},
	"creature_revealed": {
		"file": "creature_revealed",
		"tooltip": "Creature Revealed"
	},
	"creature_role": {
		"file": "creature_role",
		"tooltip": "Creature Role"
	},
	"creature_sank": {
		"file": "creature_sank",
		"tooltip": "Creature Sank"
	},
	"creature_size": {
		"file": "creature_size",
		"tooltip": "Creature Size"
	},
	"creature_sub_type": {
		"file": "creature_sub_type",
		"tooltip": "Creature Sub Type"
	},
	"creature_sub_type_ancestral": {
		"file": "creature_sub_type",
		"tooltip": "Creature Sub Type (Ancestral)"
	},
	"creature_sub_type_grouping": {
		"file": "creature_sub_type",
		"tooltip": "Creature Sub Type (Grouping)"
	},
	"creature_sub_type_monster_bit": {
		"file": "creature_sub_type_monster_bit",
		"tooltip": "Creature Sub Type Monster Bit"
	},
	"creature_template": {
		"file": "creature_template",
		"tooltip": "Creature Template"
	},
	"creature_type": {
		"file": "creature_type",
		"tooltip": "Creature Type"
	},
	"creature_type_monster_bit": {
		"file": "creature_type_monster_bit",
		"tooltip": "Creature Type Monster Bit"
	},
	"creature_visible": {
		"file": "creature_visible",
		"tooltip": "Creature Visible"
	},
	"crit_to_hit": {
		"file": "crit_to_hit",
		"tooltip": "Crit to Hit"
	},
	"critical_hit_damage_multiplier": {
		"file": "critical_hit_range_increase_mod",
		"tooltip": "Critical Hit Range Increase Mod"
	},
	"critical_hit_range_increase_mod": {
		"file": "critical_hit_range_increase_mod",
		"tooltip": "Critical Hit Range Increase Mod"
	},
	"cunning": {
		"file": "cunning",
		"tooltip": "Cunning"
	},
	"current_v_temp_not_exceeded": {
		"file": "current_v_temp_not_exceeded",
		"tooltip": "Current V Temp Not Exceeded"
	},
	"curse": {
		"file": "curse",
		"tooltip": "Curse"
	},
	"curse_known": {
		"file": "curse_known",
		"tooltip": "Curse Known"
	},
	"custom_ability": {
		"file": "custom_ability",
		"tooltip": "Custom Ability"
	},
	"custom_free_ability": {
		"file": "custom_free_ability",
		"tooltip": "Custom Free Ability"
	},
	"custom_full_ability": {
		"file": "custom_full_ability",
		"tooltip": "Custom Full Ability"
	},
	"custom_house_rules": {
		"file": "custom_house_rules",
		"tooltip": "Custom House Rules"
	},
	"custom_inventory_name": {
		"file": "custom_inventory_name",
		"tooltip": "Custom Inventory Name"
	},
	"custom_quick_ability": {
		"file": "custom_quick_ability",
		"tooltip": "Custom Quick Ability"
	},
	"custom_reaction_ability": {
		"file": "custom_reaction_ability",
		"tooltip": "Custom Reaction Ability"
	},
	"d10": {
		"file": "d10",
		"tooltip": "D10"
	},
	"d12": {
		"file": "d12",
		"tooltip": "D12"
	},
	"d20": {
		"file": "d20",
		"tooltip": "D20"
	},
	"d4": {
		"file": "d4",
		"tooltip": "D4"
	},
	"d6": {
		"file": "d6",
		"tooltip": "D6"
	},
	"d8": {
		"file": "d8",
		"tooltip": "D8"
	},
	"damage_dice_quantity_mod": {
		"file": "damage_dice_quantity_mod",
		"tooltip": "Damage Dice Quantity Mod"
	},
	"damage_heals_caster": {
		"file": "damage_heals_caster",
		"tooltip": "Damage Heals Caster"
	},
	"damage_ignores_all_damage_mitigation": {
		"file": "effect_ignores_damage_type_resistance",
		"tooltip": "Effect Ignores Damage Type Resistance"
	},
	"damage_mitigation": {
		"file": "damage_mitigation",
		"tooltip": "Damage Mitigation"
	},
	"damage_on_status_expiry": {
		"file": "effect_ends_on_target_end_of_turn",
		"tooltip": "Deals its damage when the status expires at the end of the holder turn"
	},
	"damage_on_status_expiry_splash_dice": {
		"file": "dice",
		"tooltip": "Detonation splash dice"
	},
	"damage_on_status_expiry_splash_die": {
		"file": "die",
		"tooltip": "Detonation splash die size"
	},
	"damage_on_status_expiry_splash_ft": {
		"file": "aoe_distance",
		"tooltip": "Detonation splash radius (ft)"
	},
	"damage_reduction": {
		"file": "damage_reduction",
		"tooltip": "Damage Reduction"
	},
	"damage_roll": {
		"file": "damage_roll",
		"tooltip": "Damage Roll"
	},
	"damage_roll_adv_dis_stacks": {
		"file": "damage_roll_adv_dis_stacks",
		"tooltip": "Damage Roll Adv Dis Stacks"
	},
	"damage_to_objects_multiplier": {
		"file": "building",
		"tooltip": "Damage multiplier against objects and structures"
	},
	"damage_type": {
		"file": "damage_type",
		"tooltip": "Damage Type"
	},
	"damage_type_immunity": {
		"file": "damage_type_immunity",
		"tooltip": "Damage Type Immunity"
	},
	"damage_type_is_rolled_at_max": {
		"file": "roll_type_is_rolled_at_max",
		"tooltip": "Roll Type Is Rolled at Max"
	},
	"damage_type_reroll_1s_and_2s": {
		"file": "damage_type_reroll_1s_and_2s",
		"tooltip": "Damage Type Reroll 1s and 2s"
	},
	"damage_type_resistance": {
		"file": "damage_type_resistance",
		"tooltip": "Damage Type Resistance"
	},
	"damage_type_vulnerability": {
		"file": "damage_type_vulnerability",
		"tooltip": "Damage Type Vulnerability"
	},
	"database": {
		"file": "database",
		"tooltip": "Database"
	},
	"date_that_it_became_a_ruin_day": {
		"file": "date_that_it_became_a_ruin_day",
		"tooltip": "Date That It Became a Ruin Day"
	},
	"date_that_it_became_a_ruin_era": {
		"file": "date_that_it_became_a_ruin_era",
		"tooltip": "Date That It Became a Ruin Era"
	},
	"date_that_it_became_a_ruin_month": {
		"file": "date_that_it_became_a_ruin_month",
		"tooltip": "Date That It Became a Ruin Month"
	},
	"date_that_it_became_a_ruin_year": {
		"file": "date_that_it_became_a_ruin_year",
		"tooltip": "Date That It Became a Ruin Year"
	},
	"decrease_charge": {
		"file": "decrease_charge",
		"tooltip": "Decrease Charge"
	},
	"decrease_mana": {
		"file": "decrease_mana",
		"tooltip": "Decrease Mana"
	},
	"decrease_max_charges_of_ability": {
		"file": "decrease_max_charges_of_ability",
		"tooltip": "Decrease Max Charges of Ability"
	},
	"decrease_max_charges_of_ability_for_target": {
		"file": "decrease_max_charges_of_ability_for_target",
		"tooltip": "Decrease Max Charges of Target Ability"
	},
	"decrease_max_charges_of_ability_qty_for_target": {
		"file": "decrease_max_charges_of_ability_qty_for_target",
		"tooltip": "Decrease Max Charges of Target Ability — Quantity"
	},
	"decrease_max_charges_of_passive_ability": {
		"file": "decrease_max_charges_of_passive_ability",
		"tooltip": "Decrease Max Charges of Passive Ability"
	},
	"decrease_weapon_attack": {
		"file": "decrease_weapon_attack",
		"tooltip": "Decrease Weapon Attack"
	},
	"decreased_head_attack": {
		"file": "reduce_head_attack",
		"tooltip": "Decreased Head Attack"
	},
	"decreased_weapon_attack": {
		"file": "decreased_weapon_attack",
		"tooltip": "Decreased Weapon Attack"
	},
	"default_calendar_id": {
		"file": "default_calendar_id",
		"tooltip": "Default Calendar Id"
	},
	"default_encounter_amb": {
		"file": "default_encounter_amb",
		"tooltip": "Default Encounter Amb"
	},
	"default_encounter_amb_night": {
		"file": "default_encounter_amb_night",
		"tooltip": "Default Encounter Amb Night"
	},
	"default_encounter_amb_weather": {
		"file": "default_encounter_amb_weather",
		"tooltip": "Default Encounter Amb Weather"
	},
	"default_environment": {
		"file": "default_environment",
		"tooltip": "Default Environment"
	},
	"default_location_inside": {
		"file": "default_location_inside",
		"tooltip": "Default Location Inside"
	},
	"default_location_settings": {
		"file": "default_location_settings",
		"tooltip": "Default Location Settings"
	},
	"default_min_population": {
		"file": "default_min_population",
		"tooltip": "Default Min Population"
	},
	"default_preferred_speed_type": {
		"file": "default_preferred_speed_type",
		"tooltip": "Default Preferred Speed Type"
	},
	"default_team": {
		"file": "default_team",
		"tooltip": "Default Team"
	},
	"default_voice_id": {
		"file": "voice",
		"tooltip": "Default Voice"
	},
	"defense": {
		"file": "defense",
		"tooltip": "Defense"
	},
	"defensive_skill": {
		"file": "defensive_skill",
		"tooltip": "Defensive Skill"
	},
	"delete": {
		"file": "delete",
		"tooltip": "Delete"
	},
	"delete_adventure": {
		"file": "delete_adventure",
		"tooltip": "Delete Adventure"
	},
	"delete_all_encounters": {
		"file": "delete_all_encounters",
		"tooltip": "Delete All Encounters"
	},
	"delete_campaign": {
		"file": "delete_campaign",
		"tooltip": "Delete Campaign"
	},
	"delete_campaign_session": {
		"file": "delete_campaign_session",
		"tooltip": "Delete Campaign Session"
	},
	"delete_empty_layers": {
		"file": "delete_empty_layers",
		"tooltip": "Delete Empty Layers"
	},
	"delete_encounter": {
		"file": "delete_encounter",
		"tooltip": "Delete Encounter"
	},
	"delete_encounter_creature": {
		"file": "delete_encounter_creature",
		"tooltip": "Delete Encounter Creature"
	},
	"delete_inventory": {
		"file": "delete_inventory",
		"tooltip": "Delete Inventory"
	},
	"delete_layer": {
		"file": "delete_layer",
		"tooltip": "Delete Layer"
	},
	"delete_player_character": {
		"file": "delete_player_character",
		"tooltip": "Delete Player Character"
	},
	"delete_status_effect": {
		"file": "delete_status_effect",
		"tooltip": "Delete Status Effect"
	},
	"delete_status_effect_all_connections": {
		"file": "delete_status_effect_all_connections",
		"tooltip": "Delete Status Effect All Connections"
	},
	"delete_world": {
		"file": "delete_world",
		"tooltip": "Delete World"
	},
	"deleted": {
		"file": "deleted",
		"tooltip": "Deleted"
	},
	"depth": {
		"file": "depth",
		"tooltip": "Depth"
	},
	"description": {
		"file": "description",
		"tooltip": "Description"
	},
	"destroy_creature": {
		"file": "destroy_creature",
		"tooltip": "Destroy Creature"
	},
	"dice": {
		"file": "dice",
		"tooltip": "Dice"
	},
	"die": {
		"file": "die",
		"tooltip": "Die"
	},
	"digsite": {
		"file": "digsite",
		"tooltip": "Digsite"
	},
	"dimensions": {
		"file": "dimensions",
		"tooltip": "Dimensions"
	},
	"dis": {
		"file": "dis",
		"tooltip": "Dis"
	},
	"disadvantage": {
		"file": "dis",
		"tooltip": "Disadvantage"
	},
	"disarm": {
		"file": "disarm",
		"tooltip": "Disarm"
	},
	"disarmed": {
		"file": "disarmed",
		"tooltip": "Disarmed"
	},
	"discord": {
		"file": "discord",
		"tooltip": "Discord"
	},
	"disease": {
		"file": "disease",
		"tooltip": "Disease"
	},
	"diseased_applied_to_target_after_contesting_roll_failed": {
		"file": "diseased_applied_to_target_after_contesting_roll_failed",
		"tooltip": "Diseased Applied to Target After Contesting Roll Failed"
	},
	"disenchant": {
		"file": "disenchant",
		"tooltip": "Disenchant"
	},
	"disenchant_inventory": {
		"file": "disenchant_inventory",
		"tooltip": "Disenchant Inventory"
	},
	"disengage": {
		"file": "disengage",
		"tooltip": "Disengage"
	},
	"dismiss_summon": {
		"file": "dismiss_summon",
		"tooltip": "Dismiss Summon"
	},
	"dismount": {
		"file": "dismount",
		"tooltip": "Dismount"
	},
	"dispel_up_to_curse_level": {
		"file": "dispel_up_to_curse_level",
		"tooltip": "Dispel Up to Curse Level"
	},
	"dispelling_effect": {
		"file": "dispelling_effect",
		"tooltip": "Dispelling Effect"
	},
	"distance": {
		"file": "distance",
		"tooltip": "Distance"
	},
	"districts": {
		"file": "districts",
		"tooltip": "Districts"
	},
	"do_not_include_automatic_creature_type_monster_bits": {
		"file": "do_not_include_automatic_creature_type_monster_bits",
		"tooltip": "Do Not Include Automatic Creature Type Monster Bits"
	},
	"dodge": {
		"file": "dodge",
		"tooltip": "Dodge"
	},
	"dodging": {
		"file": "dodging",
		"tooltip": "Dodging"
	},
	"does_not_provoke_overrun_from_size_difference": {
		"file": "does_not_provoke_overrun_from_size_difference",
		"tooltip": "Does Not Provoke Overrun from Size Difference"
	},
	"doffing": {
		"file": "doffing",
		"tooltip": "Doffing"
	},
	"doffing_time": {
		"file": "doffing_time",
		"tooltip": "Doffing Time"
	},
	"donning": {
		"file": "donning",
		"tooltip": "Donning"
	},
	"donning_time": {
		"file": "donning_time",
		"tooltip": "Donning Time"
	},
	"door": {
		"file": "door",
		"tooltip": "Door"
	},
	"draw_sheathed_weapon_for_attack_ability": {
		"file": "draw_sheathed_weapon_for_attack_ability",
		"tooltip": "Draw Sheathed Weapon for Attack Ability"
	},
	"drink": {
		"file": "drink",
		"tooltip": "Drink"
	},
	"drop_inventory": {
		"file": "drop_inventory",
		"tooltip": "Drop Inventory"
	},
	"dscryb": {
		"file": "dscryb",
		"tooltip": "Dscryb"
	},
	"duration": {
		"file": "duration",
		"tooltip": "Duration"
	},
	"duration_permanent": {
		"file": "duration_permanent",
		"tooltip": "Duration Permanent"
	},
	"earth_mote": {
		"file": "earth_mote",
		"tooltip": "Earth Mote"
	},
	"economy": {
		"file": "economy",
		"tooltip": "Economy"
	},
	"ecosystem": {
		"file": "ecosystem",
		"tooltip": "Ecosystem"
	},
	"ecosystem_cycles": {
		"file": "ecosystem_cycles",
		"tooltip": "Ecosystem Cycles"
	},
	"edit": {
		"file": "edit",
		"tooltip": "Edit"
	},
	"edit_adventure": {
		"file": "edit_adventure",
		"tooltip": "Edit Adventure"
	},
	"edit_campaign": {
		"file": "edit_campaign",
		"tooltip": "Edit Campaign"
	},
	"edit_enchantment_template": {
		"file": "edit_enchantment_template",
		"tooltip": "Edit Enchantment Template"
	},
	"edit_encounter": {
		"file": "edit_encounter",
		"tooltip": "Edit Encounter"
	},
	"edit_encounter_creature": {
		"file": "edit_encounter_creature",
		"tooltip": "Edit Encounter Creature"
	},
	"edit_inventory": {
		"file": "edit_inventory",
		"tooltip": "Edit Inventory"
	},
	"edit_item": {
		"file": "edit_item",
		"tooltip": "Edit Item"
	},
	"edit_layer": {
		"file": "edit_layer",
		"tooltip": "Edit Layer"
	},
	"edit_location": {
		"file": "edit_location",
		"tooltip": "Edit Location"
	},
	"edit_map": {
		"file": "edit_map",
		"tooltip": "Edit Map"
	},
	"edit_monster_template": {
		"file": "edit_monster_template",
		"tooltip": "Edit Monster Template"
	},
	"edit_picture": {
		"file": "edit_picture",
		"tooltip": "Edit Picture"
	},
	"edit_player_character": {
		"file": "edit_player_character",
		"tooltip": "Edit Player Character"
	},
	"edit_video": {
		"file": "edit_video",
		"tooltip": "Edit Video"
	},
	"effect_can_heal_inventory": {
		"file": "effect_can_heal_inventory",
		"tooltip": "Effect Can Heal Inventory"
	},
	"effect_can_only_heal_inventory": {
		"file": "effect_can_only_heal_inventory",
		"tooltip": "Effect Can Only Heal Inventory"
	},
	"effect_ends_on_combat_end": {
		"file": "combat_ended",
		"tooltip": "Effect ends when combat ends"
	},
	"effect_ends_when_target_gains_status_effect": {
		"file": "effect_ends_on_target_end_of_turn",
		"tooltip": "Effect ends when the holder gains one of these status effects"
	},
	"effect_ignores_damage_type_immunity": {
		"file": "effect_ignores_damage_type_immunity",
		"tooltip": "Effect Ignores Damage Type Immunity"
	},
	"effect_ignores_damage_type_resistance": {
		"file": "effect_ignores_damage_type_resistance",
		"tooltip": "Effect Ignores Damage Type Resistance"
	},
	"effect_is_reflected_back": {
		"file": "effect_is_reflected_back",
		"tooltip": "Effect Is Reflected Back"
	},
	"effect_only_affects_opposing_team_type": {
		"file": "effect_only_affects_opposing_team_type",
		"tooltip": "Effect Only Affects Opposing Team Type"
	},
	"effect_only_affects_same_team_type": {
		"file": "effect_only_affects_same_team_type",
		"tooltip": "Effect Only Affects Same Team Type"
	},
	"effect_penetration_limitation": {
		"file": "effect_penetration_limitation",
		"tooltip": "Effect Penetration Limitation"
	},
	"effect_requires_preferred_speed_type": {
		"file": "effect_requires_preferred_speed_type",
		"tooltip": "Effect Requires Preferred Speed Type"
	},
	"eject_creature": {
		"file": "dismount",
		"tooltip": "Eject Creature"
	},
	"elixir": {
		"file": "elixir",
		"tooltip": "Elixir"
	},
	"email": {
		"file": "email",
		"tooltip": "Email"
	},
	"enchanting_dust": {
		"file": "enchanting_dust",
		"tooltip": "Enchanting Dust"
	},
	"enchanting_recipe": {
		"file": "enchanting_recipe",
		"tooltip": "Enchanting Recipe"
	},
	"enchantment": {
		"file": "enchantment",
		"tooltip": "Enchantment"
	},
	"enchantment_template": {
		"file": "enchantment_template",
		"tooltip": "Enchantment Template"
	},
	"enchantment_template_applied": {
		"file": "enchantment_template_applied",
		"tooltip": "Enchantment Template Applied"
	},
	"encounter": {
		"file": "encounter",
		"tooltip": "Encounter"
	},
	"encounter_ceiling": {
		"file": "encounter_ceiling",
		"tooltip": "Encounter Ceiling"
	},
	"encounter_creature_private": {
		"file": "encounter_creature_private",
		"tooltip": "Encounter Creature Private"
	},
	"encounter_creatures": {
		"file": "creatures",
		"tooltip": "Encounter Creatures"
	},
	"encounter_description": {
		"file": "encounter_description",
		"tooltip": "Encounter Description"
	},
	"encounter_description_off": {
		"file": "encounter_description_off",
		"tooltip": "Encounter Description Off"
	},
	"encounter_description_on": {
		"file": "encounter_description_on",
		"tooltip": "Encounter Description on"
	},
	"encounter_environment": {
		"file": "encounter_environment",
		"tooltip": "Encounter Environment"
	},
	"encounter_gm_notes": {
		"file": "encounter_gm_notes",
		"tooltip": "Encounter Gm Notes"
	},
	"encounter_inside": {
		"file": "encounter_inside",
		"tooltip": "Encounter Inside"
	},
	"encounter_inventory_off": {
		"file": "encounter_inventory_off",
		"tooltip": "Encounter Inventory Off"
	},
	"encounter_inventory_on": {
		"file": "encounter_inventory_on",
		"tooltip": "Encounter Inventory on"
	},
	"encounter_light": {
		"file": "encounter_light",
		"tooltip": "Encounter Light"
	},
	"encounter_link": {
		"file": "encounter_link",
		"tooltip": "Encounter Link"
	},
	"encounter_loaded": {
		"file": "encounter_loaded",
		"tooltip": "Encounter Loaded"
	},
	"encounter_max_x": {
		"file": "encounter_max_x",
		"tooltip": "Encounter Max X"
	},
	"encounter_max_y": {
		"file": "encounter_max_y",
		"tooltip": "Encounter Max Y"
	},
	"encounter_max_z": {
		"file": "encounter_max_z",
		"tooltip": "Encounter Max Z"
	},
	"encounter_min_z": {
		"file": "encounter_min_z",
		"tooltip": "Encounter Min Z"
	},
	"encounter_picture": {
		"file": "encounter_picture",
		"tooltip": "Encounter Picture"
	},
	"encounter_pictures_off": {
		"file": "encounter_pictures_off",
		"tooltip": "Encounter Pictures Off"
	},
	"encounter_pictures_on": {
		"file": "encounter_pictures_on",
		"tooltip": "Encounter Pictures on"
	},
	"encounter_private": {
		"file": "encounter_private",
		"tooltip": "Encounter Private"
	},
	"encounter_settings": {
		"file": "encounter_settings",
		"tooltip": "Encounter Settings"
	},
	"encounter_source_light_changed": {
		"file": "encounter_source_light_changed",
		"tooltip": "Encounter Source Light Changed"
	},
	"encounter_source_light_removed": {
		"file": "encounter_source_light_removed",
		"tooltip": "Encounter Source Light Removed"
	},
	"encounter_temperature": {
		"file": "encounter_temperature",
		"tooltip": "Encounter Temperature"
	},
	"encounter_tempurature": {
		"file": "encounter_temperature",
		"tooltip": "Encounter Temperature"
	},
	"encounter_treasure": {
		"file": "encounter_treasure",
		"tooltip": "Encounter Treasure"
	},
	"encounter_weather": {
		"file": "encounter_weather",
		"tooltip": "Encounter Weather"
	},
	"encounter_wind": {
		"file": "encounter_wind",
		"tooltip": "Encounter Wind"
	},
	"end": {
		"file": "end",
		"tooltip": "End"
	},
	"end_concentration": {
		"file": "end_concentration",
		"tooltip": "End Concentration"
	},
	"end_hunker_down": {
		"file": "end_hunker_down",
		"tooltip": "End Hunker Down"
	},
	"end_turn": {
		"file": "end_turn",
		"tooltip": "End Turn"
	},
	"enemy_move_past_movement_cost_multiplier": {
		"file": "overrun",
		"tooltip": "Overrun"
	},
	"environment": {
		"file": "environment",
		"tooltip": "Environment"
	},
	"environment_created": {
		"file": "environment_created",
		"tooltip": "Environment Created"
	},
	"equip_both_hands": {
		"file": "equip_both_hands",
		"tooltip": "Equip Both Hands"
	},
	"equip_inventory": {
		"file": "equip_inventory",
		"tooltip": "Equip Inventory"
	},
	"equipment": {
		"file": "equipment",
		"tooltip": "Equipment"
	},
	"equipment_equipped": {
		"file": "equipment_equipped",
		"tooltip": "Equipment Equipped"
	},
	"equipment_packed": {
		"file": "equipment_packed",
		"tooltip": "Equipment Packed"
	},
	"equipment_slot": {
		"file": "equipment_slot",
		"tooltip": "Equipment Slot"
	},
	"equipment_visual_mount": {
		"file": "equipment_visual_mount",
		"tooltip": "Equipment Visual Mount"
	},
	"essence": {
		"file": "essence",
		"tooltip": "Essence"
	},
	"evade": {
		"file": "evade",
		"tooltip": "Evade"
	},
	"evasion": {
		"file": "evasion",
		"tooltip": "Evasion"
	},
	"evasion_class": {
		"file": "evasion_class",
		"tooltip": "Evasion Class"
	},
	"evoke_all_orbs": {
		"file": "evoke_orb",
		"tooltip": "Evoke All Orbs"
	},
	"evoke_orb": {
		"file": "evoke_orb",
		"tooltip": "Evoke Orb"
	},
	"excavation_roll": {
		"file": "excavation_roll",
		"tooltip": "Excavation Roll"
	},
	"exit_combat": {
		"file": "exit_combat",
		"tooltip": "Exit Combat"
	},
	"exit_vehicle": {
		"file": "exit_vehicle",
		"tooltip": "Exit Vehicle"
	},
	"experience_mark": {
		"file": "experience_mark",
		"tooltip": "Experience Mark"
	},
	"explored": {
		"file": "explored",
		"tooltip": "Explored"
	},
	"explosive": {
		"file": "explosive",
		"tooltip": "Explosive"
	},
	"extra_attack": {
		"file": "extra_attack",
		"tooltip": "Extra Attack"
	},
	"extra_damage_requires_damage_type": {
		"file": "damage_type",
		"tooltip": "Extra damage only when the source deals these damage types"
	},
	"fabricate": {
		"file": "fabricate",
		"tooltip": "Fabricate"
	},
	"fabricate_expires_after_duration": {
		"file": "fabricate_expires_after_duration",
		"tooltip": "Fabricate Expires After Duration"
	},
	"facebook": {
		"file": "facebook",
		"tooltip": "Facebook"
	},
	"failed_to_pick_lock": {
		"file": "failed_to_pick_lock",
		"tooltip": "Failed to Pick Lock"
	},
	"family_tree": {
		"file": "family_tree",
		"tooltip": "Family Tree"
	},
	"fast_draw": {
		"file": "fast_draw",
		"tooltip": "Fast Draw"
	},
	"fast_forward": {
		"file": "fast_forward",
		"tooltip": "Fast-forward campaign time"
	},
	"feat": {
		"file": "feat",
		"tooltip": "Feat"
	},
	"feat_essences": {
		"file": "feat_essences",
		"tooltip": "Feat Essences"
	},
	"feat_repeatable": {
		"file": "feat_repeatable",
		"tooltip": "Feat Repeatable"
	},
	"filter": {
		"file": "filter",
		"tooltip": "Filter"
	},
	"finish_doffing": {
		"file": "finish_doffing",
		"tooltip": "Finish Doffing"
	},
	"finish_donning": {
		"file": "finish_donning",
		"tooltip": "Finish Donning"
	},
	"finish_reading": {
		"file": "book_read",
		"tooltip": "Finish Reading"
	},
	"finish_training": {
		"file": "training",
		"tooltip": "Finish Training"
	},
	"fire_mote": {
		"file": "fire_mote",
		"tooltip": "Fire Mote"
	},
	"fireplace": {
		"file": "fireplace",
		"tooltip": "Fireplace"
	},
	"flanked": {
		"file": "flanked",
		"tooltip": "Flanked"
	},
	"flavor_text": {
		"file": "flavor_text",
		"tooltip": "Flavor Text"
	},
	"flaw": {
		"file": "flaw",
		"tooltip": "Flaw"
	},
	"floor": {
		"file": "floor",
		"tooltip": "Floor"
	},
	"flora_and_fauna": {
		"file": "flora_and_fauna",
		"tooltip": "Flora and Fauna"
	},
	"food": {
		"file": "food",
		"tooltip": "Food"
	},
	"food_plant": {
		"file": "food_plant",
		"tooltip": "Food Plant"
	},
	"force_mount_a_creature": {
		"file": "force_mount_a_creature",
		"tooltip": "Force Mount a Creature"
	},
	"force_move_resistance": {
		"file": "force_move_resistance",
		"tooltip": "Force Move Resistance"
	},
	"force_pilot_a_creature": {
		"file": "force_pilot_a_creature",
		"tooltip": "Force Pilot a Creature"
	},
	"force_refresh_caster": {
		"file": "force_refresh_caster",
		"tooltip": "Force Refresh Caster"
	},
	"forced_move": {
		"file": "forced_move",
		"tooltip": "Forced Move"
	},
	"fortunate": {
		"file": "fortunate",
		"tooltip": "Fortunate"
	},
	"forward": {
		"file": "forward",
		"tooltip": "Forward"
	},
	"founding_date_day": {
		"file": "founding_date_day",
		"tooltip": "Founding Date Day"
	},
	"founding_date_era": {
		"file": "founding_date_era",
		"tooltip": "Founding Date Era"
	},
	"founding_date_month": {
		"file": "founding_date_month",
		"tooltip": "Founding Date Month"
	},
	"founding_date_year": {
		"file": "founding_date_year",
		"tooltip": "Founding Date Year"
	},
	"free_abilities": {
		"file": "free_abilities",
		"tooltip": "Free Abilities"
	},
	"free_ability": {
		"file": "free_ability",
		"tooltip": "Free Ability"
	},
	"free_adventure": {
		"file": "free_adventure",
		"tooltip": "Free Adventure"
	},
	"free_campaign": {
		"file": "free_campaign",
		"tooltip": "Free Campaign"
	},
	"free_game": {
		"file": "free_game",
		"tooltip": "Free Game"
	},
	"full_abilities": {
		"file": "full_abilities",
		"tooltip": "Full Abilities"
	},
	"full_ability": {
		"file": "full_ability",
		"tooltip": "Full Ability"
	},
	"furniture": {
		"file": "furniture",
		"tooltip": "Furniture"
	},
	"fury": {
		"file": "fury",
		"tooltip": "Fury"
	},
	"game_experience": {
		"file": "game_experience",
		"tooltip": "Game Experience"
	},
	"game_master_tool": {
		"file": "game_master_tool",
		"tooltip": "Game Master Tool"
	},
	"game_rule": {
		"file": "game_rule",
		"tooltip": "Game Rule"
	},
	"gaming_set": {
		"file": "gaming_set",
		"tooltip": "Gaming Set"
	},
	"gather_resource": {
		"file": "gather_resource",
		"tooltip": "Gather Resource"
	},
	"gather_while_alive": {
		"file": "gather_while_alive",
		"tooltip": "Gather While Alive"
	},
	"gathering": {
		"file": "gathering",
		"tooltip": "Gathering"
	},
	"gathering_skill": {
		"file": "gathering_skill",
		"tooltip": "Gathering Skill"
	},
	"gathering_time": {
		"file": "gathering_time",
		"tooltip": "Gathering Time"
	},
	"gemstone": {
		"file": "gemstone",
		"tooltip": "Gemstone"
	},
	"gender": {
		"file": "gender",
		"tooltip": "Gender"
	},
	"gender_type": {
		"file": "gender_type",
		"tooltip": "Gender Type"
	},
	"generate": {
		"file": "generate",
		"tooltip": "Generate"
	},
	"generate_random": {
		"file": "generate_random",
		"tooltip": "Generate Random"
	},
	"generate_random_name": {
		"file": "generate_random_name",
		"tooltip": "Generate Random Name"
	},
	"genre": {
		"file": "genre",
		"tooltip": "Genre"
	},
	"geographic_location_type": {
		"file": "geographic_location_type",
		"tooltip": "Geographic Location Type"
	},
	"geography": {
		"file": "geography",
		"tooltip": "Geography"
	},
	"gift": {
		"file": "gift",
		"tooltip": "Gift"
	},
	"give_inventory": {
		"file": "give_inventory",
		"tooltip": "Give Inventory"
	},
	"glass_chandelier": {
		"file": "glass_chandelier",
		"tooltip": "Glass Chandelier"
	},
	"glassblowing_recipe": {
		"file": "glassblowing_recipe",
		"tooltip": "Glassblowing Recipe"
	},
	"glowing_fungus_cluster": {
		"file": "glowing_fungus_cluster",
		"tooltip": "Glowing Fungus Cluster"
	},
	"gm": {
		"file": "gm",
		"tooltip": "Gm"
	},
	"gm_added_turn_time": {
		"file": "gm_added_turn_time",
		"tooltip": "Gm Added Turn Time"
	},
	"gm_award_luck": {
		"file": "award_luck",
		"tooltip": "Awarded Luck"
	},
	"gm_changed_encounter_light_type": {
		"file": "gm_changed_encounter_light_type",
		"tooltip": "Gm Changed Encounter Light Type"
	},
	"gm_changed_encounter_weather": {
		"file": "gm_changed_encounter_weather",
		"tooltip": "Gm Changed Encounter Weather"
	},
	"gm_credit": {
		"file": "gm_credit",
		"tooltip": "GM Credit"
	},
	"gm_notes": {
		"file": "gm_notes",
		"tooltip": "Gm Notes"
	},
	"gm_pulled_campaign_time": {
		"file": "gm_pulled_campaign_time",
		"tooltip": "Gm Pulled Campaign Time"
	},
	"gm_pushed_campaign_time": {
		"file": "gm_pushed_campaign_time",
		"tooltip": "Gm Pushed Campaign Time"
	},
	"gm_roll_reveal": {
		"file": "gm_roll_reveal",
		"tooltip": "Gm Roll Reveal"
	},
	"gm_tool": {
		"file": "gm_tool",
		"tooltip": "Gm Tool"
	},
	"gm_vision": {
		"file": "gm_vision",
		"tooltip": "Gm Vision"
	},
	"go_prone": {
		"file": "go_prone",
		"tooltip": "Go Prone"
	},
	"go_to_camp": {
		"file": "go_to_camp",
		"tooltip": "Go to Camp"
	},
	"go_to_creature_turn": {
		"file": "go_to_creature_turn",
		"tooltip": "Go to Creature Turn"
	},
	"go_to_encounter": {
		"file": "go_to_encounter",
		"tooltip": "Go to Encounter"
	},
	"go_to_player_character": {
		"file": "go_to_player_character",
		"tooltip": "Go to Player Character"
	},
	"government": {
		"file": "government",
		"tooltip": "Government"
	},
	"grapple": {
		"file": "grapple",
		"tooltip": "Grapple"
	},
	"grappling": {
		"file": "grappling",
		"tooltip": "Grappling"
	},
	"gravequench": {
		"file": "gravequench",
		"tooltip": "Gravequench"
	},
	"grenade": {
		"file": "grenade",
		"tooltip": "Grenade"
	},
	"grid_hide": {
		"file": "grid_settings",
		"tooltip": "Grid Hide"
	},
	"grid_settings": {
		"file": "grid_settings",
		"tooltip": "Grid Settings"
	},
	"grid_show": {
		"file": "grid_settings",
		"tooltip": "Grid Show"
	},
	"ground_terrain_type": {
		"file": "terrain_type",
		"tooltip": "Terrain Type"
	},
	"guilds_and_factions": {
		"file": "guilds_and_factions",
		"tooltip": "Guilds and Factions"
	},
	"haggle": {
		"file": "haggle",
		"tooltip": "Haggle"
	},
	"harmony": {
		"file": "harmony",
		"tooltip": "Harmony"
	},
	"has_tail": {
		"file": "tail",
		"tooltip": "Has a Tail"
	},
	"haven_return_disabled": {
		"file": "haven_return_disabled",
		"tooltip": "Haven Return Disabled"
	},
	"haven_return_enabled": {
		"file": "haven_return_enabled",
		"tooltip": "Haven Return Enabled"
	},
	"head_attack": {
		"file": "head_attack",
		"tooltip": "Head Attack"
	},
	"heal_to_v_max": {
		"file": "heal_to_v_max",
		"tooltip": "Heal to V Max"
	},
	"healing": {
		"file": "healing",
		"tooltip": "Healing"
	},
	"healing_damages_caster": {
		"file": "healing_damages_caster",
		"tooltip": "Healing Damages Caster"
	},
	"healing_roll_adv_dis_stacks": {
		"file": "healing_roll_adv_dis_stacks",
		"tooltip": "Healing Roll Adv Dis Stacks"
	},
	"healing_surge": {
		"file": "healing_surge",
		"tooltip": "Healing Surge"
	},
	"height": {
		"file": "height",
		"tooltip": "Height"
	},
	"help": {
		"file": "help",
		"tooltip": "Help"
	},
	"herb": {
		"file": "herb",
		"tooltip": "Herb"
	},
	"herbal_plant": {
		"file": "herbal_plant",
		"tooltip": "Herbal Plant"
	},
	"heroforge": {
		"file": "heroforge",
		"tooltip": "Heroforge"
	},
	"heroforge_link": {
		"file": "heroforge_link",
		"tooltip": "Heroforge Link"
	},
	"hidden": {
		"file": "hidden",
		"tooltip": "Hidden"
	},
	"hidden_roll": {
		"file": "hidden_roll",
		"tooltip": "Hidden Roll"
	},
	"hide": {
		"file": "hide",
		"tooltip": "Hide"
	},
	"hide_all_creatures": {
		"file": "hide_all_creatures",
		"tooltip": "Hide All Creatures"
	},
	"hide_creature": {
		"file": "hide_creature",
		"tooltip": "Hide Creature"
	},
	"hide_targets": {
		"file": "hide_targets",
		"tooltip": "Hide Targets"
	},
	"high": {
		"file": "high",
		"tooltip": "High"
	},
	"hit_dice": {
		"file": "hit_dice",
		"tooltip": "Hit Dice"
	},
	"hit_to_crit": {
		"file": "hit_to_crit",
		"tooltip": "Hit to Crit"
	},
	"host": {
		"file": "host",
		"tooltip": "Host"
	},
	"hostile_spell_miscast_chance_in_encounter": {
		"file": "armor_bending_roll",
		"tooltip": "Hostile Spell Miscast Chance (%)"
	},
	"hud_action_bar": {
		"file": "hud_action_bar",
		"tooltip": "Hud Action Bar"
	},
	"hunger": {
		"file": "hunger",
		"tooltip": "Hunger"
	},
	"hunger_thirst_disabled": {
		"file": "hunger_thirst_disabled",
		"tooltip": "Hunger Thirst Disabled"
	},
	"hunger_thirst_enabled": {
		"file": "hunger_thirst_enabled",
		"tooltip": "Hunger Thirst Enabled"
	},
	"hunker_down": {
		"file": "hunker_down",
		"tooltip": "Hunker Down"
	},
	"hurls_unattended_object": {
		"file": "throw_inventory",
		"tooltip": "Hurls an unattended object (largest size)"
	},
	"icon": {
		"file": "icon",
		"tooltip": "Icon"
	},
	"ideal": {
		"file": "ideal",
		"tooltip": "Ideal"
	},
	"identify_object": {
		"file": "identify_object",
		"tooltip": "Identify Object"
	},
	"if_caster_has_status_effect_active": {
		"file": "if_caster_has_status_effect_active",
		"tooltip": "If Caster Has Status Effect Active"
	},
	"if_caster_has_status_effect_not_active": {
		"file": "if_caster_has_status_effect_not_active",
		"tooltip": "If Caster Has Status Effect Not Active"
	},
	"if_caster_summon_within_ft": {
		"file": "summon_tag",
		"tooltip": "Active While Your Summon Is Within (ft)"
	},
	"if_circle_of_magic_cast": {
		"file": "if_circle_of_magic_cast",
		"tooltip": "If Circle of Magic Cast"
	},
	"if_circle_of_magic_not_cast": {
		"file": "if_circle_of_magic_not_cast",
		"tooltip": "If Circle of Magic Not Cast"
	},
	"if_light_type_active": {
		"file": "if_light_type_active",
		"tooltip": "If Light Type Active"
	},
	"if_light_type_not_active": {
		"file": "if_light_type_not_active",
		"tooltip": "If Light Type Not Active"
	},
	"if_status_effect_active": {
		"file": "if_status_effect_active",
		"tooltip": "If Status Effect Active"
	},
	"if_status_effect_not_active": {
		"file": "if_status_effect_not_active",
		"tooltip": "If Status Effect Not Active"
	},
	"if_target_has_status_effect_active": {
		"file": "if_target_has_status_effect_active",
		"tooltip": "If Target Has Status Effect Active"
	},
	"if_target_has_status_effect_not_active": {
		"file": "if_target_has_status_effect_not_active",
		"tooltip": "If Target Has Status Effect Not Active"
	},
	"if_weapon_type_equipped_active": {
		"file": "if_weapon_type_equipped_active",
		"tooltip": "If Weapon Type Equipped Active"
	},
	"if_weapon_type_equipped_not_active": {
		"file": "if_weapon_type_equipped_not_active",
		"tooltip": "If Weapon Type Equipped Not Active"
	},
	"if_weather_active": {
		"file": "if_weather_active",
		"tooltip": "If Weather Active"
	},
	"if_weather_not_active": {
		"file": "if_weather_not_active",
		"tooltip": "If Weather Not Active"
	},
	"ignore_damage_mitigation_damage_type": {
		"file": "damage_mitigation",
		"tooltip": "Damage of these types ignores Damage Mitigation"
	},
	"ignore_damage_type_resistance": {
		"file": "ignore_damage_type_resistance",
		"tooltip": "Ignore Damage Type Resistance"
	},
	"ignore_long_range_attack_roll_dis": {
		"file": "ignore_ranged_weapon_attack_roll_dis_within_an_enemy_reach",
		"tooltip": "Ignore Ranged Weapon Attack Roll Dis Within an Enemy Reach"
	},
	"ignore_ranged_spell_attack_roll_dis_within_an_enemy_reach": {
		"file": "ignore_ranged_spell_attack_roll_dis_within_an_enemy_reach",
		"tooltip": "Ignore Ranged Spell Attack Roll Dis Within an Enemy Reach"
	},
	"ignore_ranged_weapon_attack_roll_dis_within_an_enemy_reach": {
		"file": "ignore_ranged_weapon_attack_roll_dis_within_an_enemy_reach",
		"tooltip": "Ignore Ranged Weapon Attack Roll Dis Within an Enemy Reach"
	},
	"ignore_spell_component_material": {
		"file": "ignore_spell_component_material",
		"tooltip": "Ignore Spell Component Material"
	},
	"ignore_spell_component_somatic": {
		"file": "ignore_spell_component_somatic",
		"tooltip": "Ignore Spell Component Somatic"
	},
	"ignore_spell_component_verbal": {
		"file": "ignore_spell_component_verbal",
		"tooltip": "Ignore Spell Component Verbal"
	},
	"ignores_difficult_terrain": {
		"file": "ignores_difficult_terrain",
		"tooltip": "Ignores Difficult Terrain"
	},
	"ignores_occupied_space_movement_penalty": {
		"file": "overrun",
		"tooltip": "Overrun"
	},
	"ignores_snow_and_ice_terrain": {
		"file": "ignores_difficult_terrain",
		"tooltip": "Ignores Difficult Terrain"
	},
	"immovable": {
		"file": "immovable",
		"tooltip": "Immovable"
	},
	"immune_shapeshift": {
		"file": "immune_shapeshift",
		"tooltip": "Immune Shapeshift"
	},
	"immune_status_effect": {
		"file": "immune_status_effect",
		"tooltip": "Immune Status Effect"
	},
	"immune_to_ability": {
		"file": "immune_to_ability",
		"tooltip": "Immune to Ability"
	},
	"immune_to_ability_after_effect_until_combat_end": {
		"file": "immune_to_ability",
		"tooltip": "Cannot benefit from this again until combat ends"
	},
	"immune_to_ability_upon_successful_contesting_roll_till_long_rest": {
		"file": "immune_to_ability_upon_successful_contesting_roll_till_long_rest",
		"tooltip": "Immune to Ability Upon Successful Contesting Roll Till Long Rest"
	},
	"immune_to_disarm": {
		"file": "immune_to_disarm",
		"tooltip": "Immune to Disarm"
	},
	"immune_to_forced_movement": {
		"file": "immune_to_forced_movement",
		"tooltip": "Immune to Forced Movement"
	},
	"immune_to_forced_movement_from_size_category_number_below": {
		"file": "immune_to_forced_movement",
		"tooltip": "Immune to forced movement from creatures up to your size + N"
	},
	"immune_to_hostile_spells": {
		"file": "immune_to_spells",
		"tooltip": "Immune to Spells"
	},
	"immune_to_size_reduction": {
		"file": "change_creature_size",
		"tooltip": "Change Creature Size"
	},
	"immune_to_spells": {
		"file": "immune_to_spells",
		"tooltip": "Immune to Spells"
	},
	"immune_to_status_effect_prone_from_size_category_number_below": {
		"file": "prone",
		"tooltip": "Cannot be knocked Prone by creatures up to your size + N"
	},
	"immune_to_thought_reading": {
		"file": "telepathy",
		"tooltip": "Telepathy"
	},
	"impale": {
		"file": "impale_inventory",
		"tooltip": "Impale"
	},
	"impale_inventory": {
		"file": "impale_inventory",
		"tooltip": "Impale Inventory"
	},
	"in_combat": {
		"file": "in_combat",
		"tooltip": "In Combat"
	},
	"increase_charge": {
		"file": "increase_charge",
		"tooltip": "Increase Charge"
	},
	"increase_mana": {
		"file": "increase_mana",
		"tooltip": "Increase Mana"
	},
	"increase_max_charges_of_ability": {
		"file": "increase_max_charges_of_ability",
		"tooltip": "Increase Max Charges of Ability"
	},
	"increase_max_charges_of_ability_for_target": {
		"file": "increase_max_charges_of_ability_for_target",
		"tooltip": "Increase Max Charges of Target Ability"
	},
	"increase_max_charges_of_ability_qty_for_target": {
		"file": "increase_max_charges_of_ability_qty_for_target",
		"tooltip": "Increase Max Charges of Target Ability — Quantity"
	},
	"increase_max_charges_of_passive_ability": {
		"file": "increase_max_charges_of_passive_ability",
		"tooltip": "Increase Max Charges of Passive Ability"
	},
	"increase_max_v_per_level": {
		"file": "increase_max_v_per_level",
		"tooltip": "Increase Max V Per Level"
	},
	"increase_weapon_attack": {
		"file": "increase_weapon_attack",
		"tooltip": "Increase Weapon Attack"
	},
	"increased_head_attack": {
		"file": "add_head_attack",
		"tooltip": "Increased Head Attack"
	},
	"increased_weapon_attack": {
		"file": "increased_weapon_attack",
		"tooltip": "Increased Weapon Attack"
	},
	"increases_ability_charges": {
		"file": "increases_ability_charges",
		"tooltip": "Increases Ability Charges"
	},
	"increases_passive_ability_charges": {
		"file": "increases_passive_ability_charges",
		"tooltip": "Increases Passive Ability Charges"
	},
	"industry_and_trade": {
		"file": "industry_and_trade",
		"tooltip": "Industry and Trade"
	},
	"info": {
		"file": "info",
		"tooltip": "Info"
	},
	"infrastructure": {
		"file": "infrastructure",
		"tooltip": "Infrastructure"
	},
	"infusion": {
		"file": "infusion",
		"tooltip": "Infusion"
	},
	"ingot": {
		"file": "ingot",
		"tooltip": "Ingot"
	},
	"inhabitants_demonymn": {
		"file": "inhabitants_demonymn",
		"tooltip": "Inhabitants Demonymn"
	},
	"initiative_order_changed": {
		"file": "initiative_order_changed",
		"tooltip": "Initiative Order Changed"
	},
	"initiative_tiebreaker": {
		"file": "initiative_tiebreaker",
		"tooltip": "Initiative Tiebreaker"
	},
	"innate_ability": {
		"file": "innate_ability",
		"tooltip": "Innate Ability"
	},
	"innate_skill": {
		"file": "innate_skill",
		"tooltip": "Innate Skill"
	},
	"innate_spell_per_long_rest": {
		"file": "innate_spell_per_long_rest",
		"tooltip": "Innate Spell Per Long Rest"
	},
	"inspection_dc": {
		"file": "inspection_dc",
		"tooltip": "Inspection Dc"
	},
	"instagram": {
		"file": "instagram",
		"tooltip": "Instagram"
	},
	"instrument": {
		"file": "instrument",
		"tooltip": "Instrument"
	},
	"instrument_classification": {
		"file": "instrument_classification",
		"tooltip": "Instrument Classification"
	},
	"instrument_classification_skill": {
		"file": "instrument_classification_skill",
		"tooltip": "Instrument Classification Skill"
	},
	"integrated_object": {
		"file": "integrated_object",
		"tooltip": "Integrated Object"
	},
	"invalid_target_for_status_effect": {
		"file": "invalid_target_for_status_effect",
		"tooltip": "Invalid Target for Status Effect"
	},
	"inventory": {
		"file": "inventory",
		"tooltip": "Inventory"
	},
	"inventory_body": {
		"file": "inventory_body",
		"tooltip": "Inventory Body"
	},
	"inventory_deleted": {
		"file": "inventory_deleted",
		"tooltip": "Inventory Deleted"
	},
	"inventory_description": {
		"file": "inventory_description",
		"tooltip": "Inventory Description"
	},
	"inventory_equipped": {
		"file": "inventory_equipped",
		"tooltip": "Inventory Equipped"
	},
	"inventory_essence": {
		"file": "inventory_essence",
		"tooltip": "Inventory Essence"
	},
	"inventory_flavor_text": {
		"file": "inventory_flavor_text",
		"tooltip": "Inventory Flavor Text"
	},
	"inventory_fortune": {
		"file": "inventory_fortune",
		"tooltip": "Inventory Fortune"
	},
	"inventory_gm_notes": {
		"file": "inventory_gm_notes",
		"tooltip": "Inventory Gm Notes"
	},
	"inventory_hidden": {
		"file": "inventory_hidden",
		"tooltip": "Inventory Hidden"
	},
	"inventory_item_id": {
		"file": "inventory_item_id",
		"tooltip": "Inventory Item Id"
	},
	"inventory_lock": {
		"file": "inventory_lock",
		"tooltip": "Inventory Lock"
	},
	"inventory_mind": {
		"file": "inventory_mind",
		"tooltip": "Inventory Mind"
	},
	"inventory_name": {
		"file": "inventory",
		"tooltip": "Inventory Name"
	},
	"inventory_options": {
		"file": "inventory_options",
		"tooltip": "Inventory Options"
	},
	"inventory_private": {
		"file": "inventory_private",
		"tooltip": "Inventory Private"
	},
	"inventory_qty": {
		"file": "quantity",
		"tooltip": "Quantity"
	},
	"inventory_soul": {
		"file": "inventory_soul",
		"tooltip": "Inventory Soul"
	},
	"inventory_spirit": {
		"file": "inventory_spirit",
		"tooltip": "Inventory Spirit"
	},
	"inventory_thrown": {
		"file": "inventory_thrown",
		"tooltip": "Inventory Thrown"
	},
	"inventory_unequipped": {
		"file": "inventory_unequipped",
		"tooltip": "Inventory Unequipped"
	},
	"inventory_updated": {
		"file": "inventory_updated",
		"tooltip": "Inventory Updated"
	},
	"inventory_written_in_language": {
		"file": "written_in_language",
		"tooltip": "Written in Language"
	},
	"iron_door": {
		"file": "iron_door",
		"tooltip": "Iron Door"
	},
	"item_charges": {
		"file": "item_charges",
		"tooltip": "Item Charges"
	},
	"item_composition": {
		"file": "item_composition",
		"tooltip": "Item Composition"
	},
	"item_description": {
		"file": "item_description",
		"tooltip": "Item Description"
	},
	"item_enchanted": {
		"file": "item_enchanted",
		"tooltip": "Item Enchanted"
	},
	"item_id": {
		"file": "item_id",
		"tooltip": "Item Id"
	},
	"item_rechargeable": {
		"file": "item_rechargeable",
		"tooltip": "Item Rechargeable"
	},
	"item_type": {
		"file": "item_type",
		"tooltip": "Item Type"
	},
	"jewelling_recipe": {
		"file": "jewelling_recipe",
		"tooltip": "Jewelling Recipe"
	},
	"jewelry": {
		"file": "jewelry",
		"tooltip": "Jewelry"
	},
	"junk": {
		"file": "junk",
		"tooltip": "Junk"
	},
	"key": {
		"file": "key",
		"tooltip": "Key"
	},
	"keyring": {
		"file": "keyring",
		"tooltip": "Keyring"
	},
	"kick_player_character_from_campaign": {
		"file": "kick_player_character_from_campaign",
		"tooltip": "Kick Player Character from Campaign"
	},
	"kill_creature": {
		"file": "kill_creature",
		"tooltip": "Kill Creature"
	},
	"kill_creature_forever": {
		"file": "kill_creature_forever",
		"tooltip": "Kill Creature Forever"
	},
	"knowledge_skill": {
		"file": "knowledge_skill",
		"tooltip": "Knowledge Skill"
	},
	"ladder": {
		"file": "ladder",
		"tooltip": "Ladder"
	},
	"lair": {
		"file": "lair",
		"tooltip": "Lair"
	},
	"lair_ability": {
		"file": "lair_ability",
		"tooltip": "Lair Ability"
	},
	"language": {
		"file": "language",
		"tooltip": "Language"
	},
	"language_fluent": {
		"file": "language_fluent",
		"tooltip": "Language Fluent"
	},
	"language_skill": {
		"file": "language_skill",
		"tooltip": "Language Skill"
	},
	"language_spoken": {
		"file": "language_spoken",
		"tooltip": "Language Spoken"
	},
	"layer_type": {
		"file": "layer_type",
		"tooltip": "Layer Type"
	},
	"layers": {
		"file": "layers",
		"tooltip": "Layers"
	},
	"leatherworking_recipe": {
		"file": "leatherworking_recipe",
		"tooltip": "Leatherworking Recipe"
	},
	"leave": {
		"file": "leave",
		"tooltip": "Leave"
	},
	"leave_campaign": {
		"file": "leave_campaign",
		"tooltip": "Leave Campaign"
	},
	"legendary_creature": {
		"file": "legendary_creature",
		"tooltip": "Legendary Creature"
	},
	"level": {
		"file": "level",
		"tooltip": "Level"
	},
	"level_up": {
		"file": "level_up",
		"tooltip": "Level Up"
	},
	"license_type": {
		"file": "license_type",
		"tooltip": "License Type"
	},
	"lifestyle": {
		"file": "lifestyle",
		"tooltip": "Lifestyle"
	},
	"light": {
		"file": "light",
		"tooltip": "Light"
	},
	"light_cycle_mode": {
		"file": "light_cycle_mode",
		"tooltip": "Light Cycle Mode"
	},
	"light_cycle_modes": {
		"file": "light_cycle_mode",
		"tooltip": "Light Cycle Modes"
	},
	"light_source": {
		"file": "light_source",
		"tooltip": "Light Source"
	},
	"light_type": {
		"file": "light_type",
		"tooltip": "Light Type"
	},
	"light_type_created": {
		"file": "light_type_created",
		"tooltip": "Light Type Created"
	},
	"limited_visibility_ft": {
		"file": "limited_visibility_ft",
		"tooltip": "Limited Visibility Ft"
	},
	"lineage": {
		"file": "lineage",
		"tooltip": "Lineage"
	},
	"link": {
		"file": "link",
		"tooltip": "Link"
	},
	"link_encounter_location_picture": {
		"file": "link_encounter_location_picture",
		"tooltip": "Link Encounter Location Picture"
	},
	"linked_encounter": {
		"file": "linked_encounter",
		"tooltip": "Linked Encounter"
	},
	"load_encounter": {
		"file": "load_encounter",
		"tooltip": "Load Encounter"
	},
	"localized_phenomena": {
		"file": "localized_phenomena",
		"tooltip": "Localized Phenomena"
	},
	"location": {
		"file": "location",
		"tooltip": "Location"
	},
	"location_amb": {
		"file": "location_amb",
		"tooltip": "Location Amb"
	},
	"location_amb_night": {
		"file": "location_amb_night",
		"tooltip": "Location Amb Night"
	},
	"location_amb_weather": {
		"file": "location_amb_weather",
		"tooltip": "Location Amb Weather"
	},
	"location_ceiling": {
		"file": "location_ceiling",
		"tooltip": "Location Ceiling"
	},
	"location_environment": {
		"file": "location_environment",
		"tooltip": "Location Environment"
	},
	"location_inside": {
		"file": "location_inside",
		"tooltip": "Location Inside"
	},
	"location_light": {
		"file": "location_light",
		"tooltip": "Location Light"
	},
	"location_max_x": {
		"file": "location_max_x",
		"tooltip": "Location Max X"
	},
	"location_max_y": {
		"file": "location_max_y",
		"tooltip": "Location Max Y"
	},
	"location_max_z": {
		"file": "location_max_z",
		"tooltip": "Location Max Z"
	},
	"location_min_z": {
		"file": "location_min_z",
		"tooltip": "Location Min Z"
	},
	"location_parent": {
		"file": "location_parent",
		"tooltip": "Location Parent"
	},
	"location_temperature": {
		"file": "location_temperature",
		"tooltip": "Location Temperature"
	},
	"location_type": {
		"file": "location_type",
		"tooltip": "Location Type"
	},
	"location_weather": {
		"file": "location_weather",
		"tooltip": "Location Weather"
	},
	"location_wind": {
		"file": "location_wind",
		"tooltip": "Location Wind"
	},
	"location_zone": {
		"file": "location_zone",
		"tooltip": "Location Zone"
	},
	"location_zone_prefix": {
		"file": "location_zone_prefix",
		"tooltip": "Location Zone Prefix"
	},
	"lock": {
		"file": "lock",
		"tooltip": "Lock"
	},
	"lock_picked": {
		"file": "lock_picked",
		"tooltip": "Lock Picked"
	},
	"lock_type": {
		"file": "lock_type",
		"tooltip": "Lock Type"
	},
	"locked": {
		"file": "locked",
		"tooltip": "Locked"
	},
	"lockpick": {
		"file": "lockpick",
		"tooltip": "Lockpick"
	},
	"lockpick_difficulty": {
		"file": "lockpick_difficulty",
		"tooltip": "Lock Difficulty"
	},
	"lockpick_effective_skill_tier_bonus": {
		"file": "lockpicking",
		"tooltip": "Lockpick Effective Skill Tier Bonus"
	},
	"lockpick_pick_durability_changed_by_percentage": {
		"file": "lockpicking",
		"tooltip": "Lockpick Pick Durability Changed by Percentage"
	},
	"lockpick_sweet_spot_changed_by_percentage": {
		"file": "lockpicking",
		"tooltip": "Lockpick Sweet Spot Changed by Percentage"
	},
	"lockpicking": {
		"file": "lockpicking",
		"tooltip": "Lockpicking"
	},
	"lockpicking_mastery": {
		"file": "lockpicking_reroll_1s",
		"tooltip": "Lockpicking Mastery"
	},
	"log_fading": {
		"file": "log_fading",
		"tooltip": "Log Fading"
	},
	"logout": {
		"file": "logout",
		"tooltip": "Logout"
	},
	"long_rest": {
		"file": "rest",
		"tooltip": "Long Rest"
	},
	"long_rest_party": {
		"file": "long_rest_party",
		"tooltip": "Long Rest Party"
	},
	"loot": {
		"file": "loot",
		"tooltip": "Loot"
	},
	"lost_a_mirror_image": {
		"file": "mirror_image_3",
		"tooltip": "Lost a Mirror Image"
	},
	"lost_shapeshift": {
		"file": "lost_shapeshift",
		"tooltip": "Lost Shapeshift"
	},
	"low": {
		"file": "low",
		"tooltip": "Low"
	},
	"machining_recipe": {
		"file": "machining_recipe",
		"tooltip": "Machining Recipe"
	},
	"magical_darkness": {
		"file": "magical_darkness",
		"tooltip": "Magical Darkness"
	},
	"magical_light": {
		"file": "magical_light",
		"tooltip": "Magical Light"
	},
	"maintained_by_ability": {
		"file": "maintained_by_ability",
		"tooltip": "Maintained by Ability"
	},
	"maintained_by_ability_for_target": {
		"file": "maintained_by_ability_for_target",
		"tooltip": "Maintained by Target Ability"
	},
	"maintained_by_ability_qty_for_target": {
		"file": "maintained_by_ability_qty_for_target",
		"tooltip": "Maintained by Target Ability — Quantity"
	},
	"maintained_by_passive_ability": {
		"file": "maintained_by_passive_ability",
		"tooltip": "Maintained by Passive Ability"
	},
	"mana": {
		"file": "mana",
		"tooltip": "Mana"
	},
	"mana_cannot_be_reduced": {
		"file": "mana",
		"tooltip": "Mana"
	},
	"map": {
		"file": "map",
		"tooltip": "Map"
	},
	"map_marker": {
		"file": "map_marker",
		"tooltip": "Map Marker"
	},
	"marching_order_updated": {
		"file": "marching_order",
		"tooltip": "Marching Order Updated"
	},
	"mark_player_character_as_show": {
		"file": "mark_player_character_as_show",
		"tooltip": "Mark Player Character As Show"
	},
	"mark_player_character_late": {
		"file": "mark_player_character_late",
		"tooltip": "Mark Player Character Late"
	},
	"mark_player_character_left_early": {
		"file": "mark_player_character_left_early",
		"tooltip": "Mark Player Character Left Early"
	},
	"mark_player_character_no_show": {
		"file": "mark_player_character_no_show",
		"tooltip": "Mark Player Character No Show"
	},
	"mark_player_character_not_late": {
		"file": "mark_player_character_not_late",
		"tooltip": "Mark Player Character Not Late"
	},
	"mark_player_character_not_left_early": {
		"file": "mark_player_character_not_left_early",
		"tooltip": "Mark Player Character Not Left Early"
	},
	"masoning_recipe": {
		"file": "masoning_recipe",
		"tooltip": "Masoning Recipe"
	},
	"mass_dispelling_effect": {
		"file": "mass_dispelling_effect",
		"tooltip": "Mass Dispelling Effect"
	},
	"mastery": {
		"file": "mastery",
		"tooltip": "Mastery"
	},
	"max_cantrips_known": {
		"file": "max_cantrips_known",
		"tooltip": "Max Cantrips Known"
	},
	"max_item_charges": {
		"file": "max_item_charges",
		"tooltip": "Max Item Charges"
	},
	"max_pact_slots": {
		"file": "max_pact_slots",
		"tooltip": "Max Pact Slots"
	},
	"max_spells_known": {
		"file": "max_spells_known",
		"tooltip": "Max Spells Known"
	},
	"max_summons": {
		"file": "max_summons",
		"tooltip": "Max Summons"
	},
	"max_target": {
		"file": "max_target",
		"tooltip": "Max Target"
	},
	"max_temp_vitality": {
		"file": "max_temp_vitality",
		"tooltip": "Max Temp Vitality"
	},
	"max_vitality": {
		"file": "max_vitality",
		"tooltip": "Max Vitality"
	},
	"maximize": {
		"file": "maximize",
		"tooltip": "Maximize"
	},
	"maximum_damage_against_creature_type": {
		"file": "roll_type_is_rolled_at_max",
		"tooltip": "Roll Type Is Rolled at Max"
	},
	"melody": {
		"file": "melody",
		"tooltip": "Melody"
	},
	"menace": {
		"file": "menace",
		"tooltip": "Menace"
	},
	"menta": {
		"file": "menta",
		"tooltip": "Menta"
	},
	"menta_casting_time": {
		"file": "menta_casting_time",
		"tooltip": "Menta Casting Time"
	},
	"menta_level": {
		"file": "menta_level",
		"tooltip": "Menta Level"
	},
	"mental_manifestation": {
		"file": "mental_manifestation",
		"tooltip": "Mental Manifestation"
	},
	"merchant": {
		"file": "merchant",
		"tooltip": "Merchant"
	},
	"merchant_haggle": {
		"file": "haggle",
		"tooltip": "Merchant Haggle"
	},
	"merge_item_layers": {
		"file": "merge_item_layers",
		"tooltip": "Merge Item Layers"
	},
	"mesh": {
		"file": "mesh",
		"tooltip": "Mesh"
	},
	"metamagic": {
		"file": "metamagic",
		"tooltip": "Metamagic"
	},
	"microphone_required": {
		"file": "microphone_required",
		"tooltip": "Microphone Required"
	},
	"mid": {
		"file": "mid",
		"tooltip": "Mid"
	},
	"milling_recipe": {
		"file": "milling_recipe",
		"tooltip": "Milling Recipe"
	},
	"minimize": {
		"file": "minimize",
		"tooltip": "Minimize"
	},
	"minus": {
		"file": "minus",
		"tooltip": "Minus"
	},
	"misc": {
		"file": "misc",
		"tooltip": "Misc"
	},
	"miscellaneous": {
		"file": "miscellaneous",
		"tooltip": "Miscellaneous"
	},
	"missing_reagent": {
		"file": "missing_reagent",
		"tooltip": "Missing Reagent"
	},
	"missing_tool": {
		"file": "missing_tool",
		"tooltip": "Missing Tool"
	},
	"mod": {
		"file": "mod",
		"tooltip": "Mod"
	},
	"modifer": {
		"file": "modifer",
		"tooltip": "Modifer"
	},
	"modify": {
		"file": "modify",
		"tooltip": "Modify"
	},
	"modify_adventure_header_gallery": {
		"file": "modify_adventure_header_gallery",
		"tooltip": "Modify Adventure Header Gallery"
	},
	"modify_campaign_header_gallery": {
		"file": "modify_campaign_header_gallery",
		"tooltip": "Modify Campaign Header Gallery"
	},
	"modify_campaign_sessions": {
		"file": "modify_campaign_sessions",
		"tooltip": "Modify Campaign Sessions"
	},
	"modify_encounter": {
		"file": "modify_encounter",
		"tooltip": "Modify Encounter"
	},
	"modify_encounter_creature_pictures": {
		"file": "modify_encounter_creature_pictures",
		"tooltip": "Modify Encounter Creature Pictures"
	},
	"modify_initiative_order": {
		"file": "modify_initiative_order",
		"tooltip": "Modify Initiative Order"
	},
	"modify_location_gallery": {
		"file": "modify_location_gallery",
		"tooltip": "Modify Location Gallery"
	},
	"modify_picture_gallery": {
		"file": "modify_picture_gallery",
		"tooltip": "Modify Picture Gallery"
	},
	"modify_source_header_gallery": {
		"file": "modify_source_header_gallery",
		"tooltip": "Modify Source Header Gallery"
	},
	"modify_status_effect": {
		"file": "modify_status_effect",
		"tooltip": "Modify Status Effect"
	},
	"mog": {
		"file": "mog_button",
		"tooltip": "Mog Button"
	},
	"monster_bit": {
		"file": "monster_bit",
		"tooltip": "Monster Bit"
	},
	"monster_template": {
		"file": "monster_template",
		"tooltip": "Monster Template"
	},
	"motivation": {
		"file": "motivation",
		"tooltip": "Motivation"
	},
	"mount": {
		"file": "mount",
		"tooltip": "Mount"
	},
	"mount_a_creature": {
		"file": "mount_a_creature",
		"tooltip": "Mount a Creature"
	},
	"mount_back_bow": {
		"file": "mount_back_bow",
		"tooltip": "Mount Back Bow"
	},
	"mount_back_pack": {
		"file": "mount_back_pack",
		"tooltip": "Mount Back Pack"
	},
	"mount_back_primary": {
		"file": "mount_back_primary",
		"tooltip": "Mount Back Primary"
	},
	"mount_back_quiver": {
		"file": "mount_back_quiver",
		"tooltip": "Mount Back Quiver"
	},
	"mount_back_shield": {
		"file": "mount_back_shield",
		"tooltip": "Mount Back Shield"
	},
	"mount_creature": {
		"file": "mount_creature",
		"tooltip": "Mount Creature"
	},
	"mount_held_main": {
		"file": "mount_held_main",
		"tooltip": "Mount Held Main"
	},
	"mount_held_off": {
		"file": "mount_held_off",
		"tooltip": "Mount Held Off"
	},
	"mount_hidden": {
		"file": "mount_hidden",
		"tooltip": "Mount Hidden"
	},
	"mount_hip_auto": {
		"file": "mount_hip_auto",
		"tooltip": "Mount Hip Auto"
	},
	"mount_hip_left": {
		"file": "mount_hip_left",
		"tooltip": "Mount Hip Left"
	},
	"mount_hip_right": {
		"file": "mount_hip_right",
		"tooltip": "Mount Hip Right"
	},
	"mount_target": {
		"file": "mount_target",
		"tooltip": "Mount Target"
	},
	"mount_thigh_left": {
		"file": "mount_thigh_left",
		"tooltip": "Mount Thigh Left"
	},
	"mount_thigh_right": {
		"file": "mount_thigh_right",
		"tooltip": "Mount Thigh Right"
	},
	"mount_waist": {
		"file": "mount_waist",
		"tooltip": "Mount Waist"
	},
	"mount_worn": {
		"file": "mount_worn",
		"tooltip": "Mount Worn"
	},
	"mount_worn_cloak": {
		"file": "mount_worn_cloak",
		"tooltip": "Mount Worn Cloak"
	},
	"mount_worn_feet": {
		"file": "mount_worn_feet",
		"tooltip": "Mount Worn Feet"
	},
	"mount_worn_hands": {
		"file": "mount_worn_hands",
		"tooltip": "Mount Worn Hands"
	},
	"mount_worn_head": {
		"file": "mount_worn_head",
		"tooltip": "Mount Worn Head"
	},
	"mount_worn_legs": {
		"file": "mount_worn_legs",
		"tooltip": "Mount Worn Legs"
	},
	"mount_worn_neck": {
		"file": "mount_worn_neck",
		"tooltip": "Mount Worn Neck"
	},
	"mount_worn_torso": {
		"file": "mount_worn_torso",
		"tooltip": "Mount Worn Torso"
	},
	"move_inventory": {
		"file": "move_inventory",
		"tooltip": "Move Inventory"
	},
	"move_map_marker": {
		"file": "move_map_marker",
		"tooltip": "Move map marker"
	},
	"moved_to_encounter": {
		"file": "moved_to_encounter",
		"tooltip": "Moved to Encounter"
	},
	"movement": {
		"file": "movement",
		"tooltip": "Movement"
	},
	"multiple_head_attacks": {
		"file": "multiple_head_attacks",
		"tooltip": "Multiple Head Attacks"
	},
	"multiplier": {
		"file": "multiplier",
		"tooltip": "Multiplier"
	},
	"multiply": {
		"file": "multiply",
		"tooltip": "Multiply"
	},
	"music": {
		"file": "music",
		"tooltip": "Music"
	},
	"my_account": {
		"file": "my_account",
		"tooltip": "My Account"
	},
	"my_adventures": {
		"file": "my_adventures",
		"tooltip": "My Adventures"
	},
	"my_campaign_join_requests": {
		"file": "request",
		"tooltip": "My Campaign Join Requests"
	},
	"my_campaign_settings": {
		"file": "my_campaign_settings",
		"tooltip": "My Campaign Settings"
	},
	"my_campaigns": {
		"file": "my_campaigns",
		"tooltip": "My Campaigns"
	},
	"my_characters": {
		"file": "my_characters",
		"tooltip": "My Characters"
	},
	"my_sale": {
		"file": "my_sale",
		"tooltip": "My Sale"
	},
	"my_sales": {
		"file": "my_sales",
		"tooltip": "My Sales"
	},
	"my_schedule": {
		"file": "my_schedule",
		"tooltip": "My Schedule"
	},
	"my_sources": {
		"file": "source",
		"tooltip": "My Sources"
	},
	"my_worlds": {
		"file": "my_worlds",
		"tooltip": "My Worlds"
	},
	"mythic_creature": {
		"file": "mythic_creature",
		"tooltip": "Mythic Creature"
	},
	"name_generator": {
		"file": "name_generator",
		"tooltip": "Name Generator"
	},
	"natural_armor": {
		"file": "armor_type",
		"tooltip": "Natural Armor"
	},
	"natural_resources": {
		"file": "natural_resources",
		"tooltip": "Natural Resources"
	},
	"natural_weapon": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon"
	},
	"natural_weapon_form": {
		"file": "natural_weapon",
		"tooltip": "Natural Weapon Form"
	},
	"negate_falling_damage_in_feet": {
		"file": "negate_falling_damage_in_feet",
		"tooltip": "Negate Falling Damage in Feet"
	},
	"next_challenge_roll_adv": {
		"file": "next_challenge_roll_adv",
		"tooltip": "Next Challenge Roll Adv"
	},
	"next_challenge_roll_dis": {
		"file": "next_challenge_roll_dis",
		"tooltip": "Next Challenge Roll Dis"
	},
	"next_roll_type_is_rolled_at_max": {
		"file": "next_roll_type_is_rolled_at_max",
		"tooltip": "Next Roll Type Is Rolled at Max"
	},
	"next_roll_type_is_rolled_at_min": {
		"file": "next_roll_type_is_rolled_at_min",
		"tooltip": "Next Roll Type Is Rolled at Min"
	},
	"next_roll_type_roll_result_is_doubled": {
		"file": "next_roll_type_roll_result_is_doubled",
		"tooltip": "Next Roll Type Roll Result Is Doubled"
	},
	"next_roll_type_roll_result_is_halved": {
		"file": "next_roll_type_roll_result_is_halved",
		"tooltip": "Next Roll Type Roll Result Is Halved"
	},
	"next_summon_ap_override": {
		"file": "ap_change_during_turn",
		"tooltip": "Ap Change During Turn"
	},
	"next_turn": {
		"file": "next_turn",
		"tooltip": "Next Turn"
	},
	"no_charges_to_maintain": {
		"file": "ability_charges",
		"tooltip": "No Charges to Maintain"
	},
	"no_healing_rolls": {
		"file": "no_healing_rolls",
		"tooltip": "No Healing Rolls"
	},
	"non_lethal_attack": {
		"file": "non_lethal_attack",
		"tooltip": "Non Lethal Attack"
	},
	"notify": {
		"file": "notify",
		"tooltip": "Notify"
	},
	"notify_players": {
		"file": "notify_players",
		"tooltip": "Notify Players"
	},
	"object": {
		"file": "object",
		"tooltip": "Object"
	},
	"object_allows_outside_light_to_pass_through": {
		"file": "object_allows_outside_light_to_pass_through",
		"tooltip": "Object Allows Outside Light to Pass Through"
	},
	"object_becomes_attached_to_target": {
		"file": "object_becomes_attached_to_target",
		"tooltip": "Object Becomes Attached to Target"
	},
	"object_damage_mitigation": {
		"file": "object_damage_mitigation",
		"tooltip": "Object Damage Mitigation"
	},
	"object_damage_type_immunity": {
		"file": "object_damage_type_immunity",
		"tooltip": "Object Damage Type Immunity"
	},
	"object_damage_type_resistance": {
		"file": "object_damage_type_resistance",
		"tooltip": "Object Damage Type Resistance"
	},
	"object_damage_type_vulnerability": {
		"file": "object_damage_type_vulnerability",
		"tooltip": "Object Damage Type Vulnerability"
	},
	"object_destroyed_after_duration_complete": {
		"file": "object_destroyed_after_duration_complete",
		"tooltip": "Object Destroyed After Duration Complete"
	},
	"object_does_not_grant_environmental_cover": {
		"file": "object_does_not_grant_environmental_cover",
		"tooltip": "Object Does Not Grant Environmental Cover"
	},
	"object_identified": {
		"file": "identify_object",
		"tooltip": "Object Identified"
	},
	"object_ignore_damage_type_resistance": {
		"file": "object_ignore_damage_type_resistance",
		"tooltip": "Object Ignore Damage Type Resistance"
	},
	"object_interaction_range_ft": {
		"file": "reach",
		"tooltip": "Unattended-object reach (ft)"
	},
	"object_vitality_multiplier": {
		"file": "object_vitality_multiplier",
		"tooltip": "Object Vitality Multiplier"
	},
	"objects": {
		"file": "object",
		"tooltip": "Objects"
	},
	"off_hand_body_damage": {
		"file": "body",
		"tooltip": "Off-Hand Body Damage"
	},
	"open_container": {
		"file": "open_container",
		"tooltip": "Open Container"
	},
	"opportunity_attack": {
		"file": "opportunity_attack",
		"tooltip": "Opportunity Attack"
	},
	"opportunity_attack_abilities": {
		"file": "opportunity_attack_abilities",
		"tooltip": "Opportunity Attack Abilities"
	},
	"opportunity_attack_ability": {
		"file": "opportunity_attack_ability",
		"tooltip": "Opportunity Attack Ability"
	},
	"opportunity_attack_roll_adv": {
		"file": "pack_tactics",
		"tooltip": "Pack Tactics"
	},
	"ore": {
		"file": "ore",
		"tooltip": "Ore"
	},
	"ore_vein": {
		"file": "ore_vein",
		"tooltip": "Ore Vein"
	},
	"other": {
		"file": "other",
		"tooltip": "Other"
	},
	"out_of_combat": {
		"file": "out_of_combat",
		"tooltip": "Out of Combat"
	},
	"overlapping_skill_point": {
		"file": "overlapping_skill_point",
		"tooltip": "Overlapping Skill Point"
	},
	"override_ability": {
		"file": "override_ability",
		"tooltip": "Override Ability"
	},
	"override_cost_gp": {
		"file": "cost_gp",
		"tooltip": "Override Cost (gp)"
	},
	"overrun": {
		"file": "overrun",
		"tooltip": "Overrun"
	},
	"overrun_roll_adv": {
		"file": "overrun",
		"tooltip": "Overrun"
	},
	"pack_tactics": {
		"file": "pack_tactics",
		"tooltip": "Pack Tactics"
	},
	"pact_boon": {
		"file": "pact_boon",
		"tooltip": "Pact Boon"
	},
	"pact_slot_level": {
		"file": "pact_slot_level",
		"tooltip": "Pact Slot Level"
	},
	"paid_adventure": {
		"file": "paid_adventure",
		"tooltip": "Paid Adventure"
	},
	"paid_campaign": {
		"file": "paid_campaign",
		"tooltip": "Paid Campaign"
	},
	"paid_game": {
		"file": "paid_game",
		"tooltip": "Paid Game"
	},
	"painting_recipe": {
		"file": "painting_recipe",
		"tooltip": "Painting Recipe"
	},
	"parameters": {
		"file": "parameters",
		"tooltip": "Parameters"
	},
	"partial_disenchant": {
		"file": "partial_disenchant",
		"tooltip": "Partial Disenchant"
	},
	"party_attention_roll": {
		"file": "party_attention_roll",
		"tooltip": "Party Attention Roll"
	},
	"party_inspection_roll": {
		"file": "party_inspection_roll",
		"tooltip": "Party Inspection Roll"
	},
	"party_long_rested": {
		"file": "party_long_rested",
		"tooltip": "Party Long Rested"
	},
	"party_vote": {
		"file": "party_vote",
		"tooltip": "Party Vote"
	},
	"passive_abilities": {
		"file": "passive_abilities",
		"tooltip": "Passive Abilities"
	},
	"passive_ability": {
		"file": "passive_ability",
		"tooltip": "Passive Ability"
	},
	"passive_ability_applied_to_caster_after_cast": {
		"file": "status_effect_applied_to_caster_after_cast",
		"tooltip": "Passive applied to the caster for the cast"
	},
	"pause": {
		"file": "pause",
		"tooltip": "Pause"
	},
	"pause_campaign": {
		"file": "pause_campaign",
		"tooltip": "Pause Campaign"
	},
	"pause_turn_timer": {
		"file": "pause_turn_timer",
		"tooltip": "Pause Turn Timer"
	},
	"payment_method": {
		"file": "payment_method",
		"tooltip": "Payment Method"
	},
	"persistent_aoe": {
		"file": "persistent_aoe",
		"tooltip": "Persistent Aoe"
	},
	"personality": {
		"file": "personality",
		"tooltip": "Personality"
	},
	"pickpocket": {
		"file": "pickpocket",
		"tooltip": "Pickpocket"
	},
	"picture": {
		"file": "picture",
		"tooltip": "Picture"
	},
	"pie_chart": {
		"file": "pie_chart",
		"tooltip": "Pie Chart"
	},
	"pillar_candle": {
		"file": "pillar_candle",
		"tooltip": "Pillar Candle"
	},
	"pilot_a_creature": {
		"file": "pilot_a_creature",
		"tooltip": "Pilot a Creature"
	},
	"pilot_a_vehicle": {
		"file": "pilot_a_vehicle",
		"tooltip": "Pilot a Vehicle"
	},
	"pin": {
		"file": "pin",
		"tooltip": "Pin"
	},
	"plane": {
		"file": "plane",
		"tooltip": "Plane"
	},
	"plank": {
		"file": "plank",
		"tooltip": "Plank"
	},
	"plant": {
		"file": "plant",
		"tooltip": "Plant"
	},
	"play": {
		"file": "play",
		"tooltip": "Play"
	},
	"play_ambience": {
		"file": "play_ambience",
		"tooltip": "Play Ambience"
	},
	"player": {
		"file": "player",
		"tooltip": "Player"
	},
	"player_character": {
		"file": "player_character",
		"tooltip": "Player Character"
	},
	"player_character_active": {
		"file": "player_character_active",
		"tooltip": "Player Character Active"
	},
	"player_character_inactive": {
		"file": "player_character_inactive",
		"tooltip": "Player Character Inactive"
	},
	"player_notes": {
		"file": "player_notes",
		"tooltip": "Player Notes"
	},
	"player_settings": {
		"file": "player_settings",
		"tooltip": "Player Settings"
	},
	"player_sheet_haven_return_allowed": {
		"file": "haven_return_enabled",
		"tooltip": "Player Sheet Haven Return Allowed"
	},
	"player_sheet_haven_return_blocked": {
		"file": "haven_return_disabled",
		"tooltip": "Player Sheet Haven Return Blocked"
	},
	"player_sheet_haven_return_disabled": {
		"file": "haven_return_disabled",
		"tooltip": "Player Sheet Haven Return Disabled"
	},
	"player_sheet_haven_return_enabled": {
		"file": "haven_return_enabled",
		"tooltip": "Player Sheet Haven Return Enabled"
	},
	"player_tool": {
		"file": "player_tool",
		"tooltip": "Player Tool"
	},
	"plus": {
		"file": "plus",
		"tooltip": "Plus"
	},
	"points_of_interest": {
		"file": "points_of_interest",
		"tooltip": "Points of Interest"
	},
	"poison": {
		"file": "poison",
		"tooltip": "Poison"
	},
	"poison_type": {
		"file": "poison_type",
		"tooltip": "Poison Type"
	},
	"population": {
		"file": "population",
		"tooltip": "Population"
	},
	"potion": {
		"file": "potion",
		"tooltip": "Potion"
	},
	"power_level": {
		"file": "power_level",
		"tooltip": "Power Level"
	},
	"precision_shots": {
		"file": "precision_shots",
		"tooltip": "Precision Shots"
	},
	"preference": {
		"file": "preference",
		"tooltip": "Preference"
	},
	"preferred_speed_type": {
		"file": "preferred_speed_type",
		"tooltip": "Preferred Speed Type"
	},
	"prepare_additional_cantrips": {
		"file": "prepare_additional_cantrips",
		"tooltip": "Prepare Additional Cantrips"
	},
	"prepare_additional_spells": {
		"file": "prepare_additional_spells",
		"tooltip": "Prepare Additional Spells"
	},
	"prepare_spell": {
		"file": "prepare_spell",
		"tooltip": "Prepare Spell"
	},
	"prepare_spell_list": {
		"file": "prepare_spell",
		"tooltip": "Prepare Spell List"
	},
	"prepare_spells": {
		"file": "prepare_spells",
		"tooltip": "Prepare Spells"
	},
	"prepared_spells": {
		"file": "prepared_spells",
		"tooltip": "Prepared Spells"
	},
	"previous": {
		"file": "previous",
		"tooltip": "Previous"
	},
	"previous_turn": {
		"file": "previous_turn",
		"tooltip": "Previous Turn"
	},
	"priceless": {
		"file": "priceless",
		"tooltip": "Priceless"
	},
	"privacy": {
		"file": "privacy",
		"tooltip": "Privacy"
	},
	"private": {
		"file": "private",
		"tooltip": "Private"
	},
	"private_adventure": {
		"file": "private_adventure",
		"tooltip": "Private Adventure"
	},
	"private_all_creatures": {
		"file": "private_all_creatures",
		"tooltip": "Private All Creatures"
	},
	"private_campaign": {
		"file": "private_campaign",
		"tooltip": "Private Campaign"
	},
	"private_encounter": {
		"file": "private_encounter",
		"tooltip": "Private Encounter"
	},
	"private_location": {
		"file": "private_location",
		"tooltip": "Private Location"
	},
	"private_player_character": {
		"file": "private_player_character",
		"tooltip": "Private Player Character"
	},
	"product_type": {
		"file": "product_type",
		"tooltip": "Product type (catalog scope)"
	},
	"profile": {
		"file": "profile",
		"tooltip": "Profile"
	},
	"projectiles_created": {
		"file": "projectiles_created",
		"tooltip": "Projectiles Created"
	},
	"psi": {
		"file": "psi",
		"tooltip": "Psi"
	},
	"public": {
		"file": "public",
		"tooltip": "Public"
	},
	"public_adventure": {
		"file": "public_adventure",
		"tooltip": "Public Adventure"
	},
	"public_all_creatures": {
		"file": "public_all_creatures",
		"tooltip": "Public All Creatures"
	},
	"public_campaign": {
		"file": "public_campaign",
		"tooltip": "Public Campaign"
	},
	"public_encounter": {
		"file": "public_encounter",
		"tooltip": "Public Encounter"
	},
	"public_location": {
		"file": "public_location",
		"tooltip": "Public Location"
	},
	"public_player_character": {
		"file": "public_player_character",
		"tooltip": "Public Player Character"
	},
	"public_roll": {
		"file": "public_roll",
		"tooltip": "Public Roll"
	},
	"publisher": {
		"file": "publisher",
		"tooltip": "Publisher"
	},
	"pull_all_creatures_from_encounter": {
		"file": "pull_all_creatures_from_encounter",
		"tooltip": "Pull All Creatures from Encounter"
	},
	"pull_ft_after_hit": {
		"file": "pull_ft_after_hit",
		"tooltip": "Pull Ft After Hit"
	},
	"pull_player_to_encounter_loaded": {
		"file": "pull_player_to_encounter_loaded",
		"tooltip": "Pull Player to Encounter Loaded"
	},
	"pull_to_caster_center": {
		"file": "pull_to_caster_center",
		"tooltip": "Pull To Caster Center"
	},
	"purpose": {
		"file": "purpose",
		"tooltip": "Purpose"
	},
	"push_all_creatures_to_encounter": {
		"file": "push_all_creatures_to_encounter",
		"tooltip": "Push All Creatures to Encounter"
	},
	"push_any_direction": {
		"file": "push_any_direction",
		"tooltip": "Push Any Direction"
	},
	"push_ft_after_hit": {
		"file": "push_ft_after_hit",
		"tooltip": "Push Ft After Hit"
	},
	"push_party_to_campaign_campsite": {
		"file": "push_party_to_campaign_campsite",
		"tooltip": "Push Party to Campaign Campsite"
	},
	"push_party_to_campaign_stronghold": {
		"file": "push_party_to_campaign_stronghold",
		"tooltip": "Push Party to Campaign Stronghold"
	},
	"push_party_to_encounter": {
		"file": "push_party_to_encounter",
		"tooltip": "Push Party to Encounter"
	},
	"push_player_to_campaign_campsite": {
		"file": "push_player_to_campaign_campsite",
		"tooltip": "Push Player to Campaign Campsite"
	},
	"push_targets_to_encounter": {
		"file": "push_targets_to_encounter",
		"tooltip": "Push Targets to Encounter"
	},
	"push_through_ap": {
		"file": "ap",
		"tooltip": "Push Through Ap"
	},
	"push_through_dc": {
		"file": "willpower",
		"tooltip": "Push Through Dc"
	},
	"puzzle": {
		"file": "puzzle",
		"tooltip": "Puzzle"
	},
	"qty": {
		"file": "quantity",
		"tooltip": "Quantity"
	},
	"qty_icon": {
		"file": "quantity",
		"tooltip": "Quantity"
	},
	"quadruped": {
		"file": "mount_creature",
		"tooltip": "Quadruped Body (limbs do not pair)"
	},
	"quantity": {
		"file": "quantity",
		"tooltip": "Quantity"
	},
	"quick_abilities": {
		"file": "quick_abilities",
		"tooltip": "Quick Abilities"
	},
	"quick_ability": {
		"file": "quick_ability",
		"tooltip": "Quick Ability"
	},
	"quirk": {
		"file": "quirk",
		"tooltip": "Quirk"
	},
	"random": {
		"file": "random",
		"tooltip": "Random"
	},
	"random_creature": {
		"file": "random",
		"tooltip": "Random Creature"
	},
	"random_disease_applied_to_target_after_contesting_roll_failed": {
		"file": "random_disease_applied_to_target_after_contesting_roll_failed",
		"tooltip": "Random Disease Applied to Target After Contesting Roll Failed"
	},
	"random_encounter_table": {
		"file": "random_encounter_table",
		"tooltip": "Random Encounter Table"
	},
	"random_food_plant": {
		"file": "random_food_plant",
		"tooltip": "Random Food Plant"
	},
	"random_herbal_plant": {
		"file": "random_herbal_plant",
		"tooltip": "Random Herbal Plant"
	},
	"random_loot_table": {
		"file": "random_loot_table",
		"tooltip": "Random Loot Table"
	},
	"random_name_table": {
		"file": "random_name_table",
		"tooltip": "Random Name Table"
	},
	"random_name_table_female": {
		"file": "random_name_table_female",
		"tooltip": "Random Name Table Female"
	},
	"random_name_table_last_name": {
		"file": "random_name_table_last_name",
		"tooltip": "Random Name Table Last Name"
	},
	"random_name_table_male": {
		"file": "random_name_table_male",
		"tooltip": "Random Name Table Male"
	},
	"random_ore_vein": {
		"file": "random_ore_vein",
		"tooltip": "Random Ore Vein"
	},
	"random_scroll_generator": {
		"file": "random_scroll_generator",
		"tooltip": "Random Scroll Generator"
	},
	"random_table": {
		"file": "random_table",
		"tooltip": "Random Table"
	},
	"random_tree": {
		"file": "random_tree",
		"tooltip": "Random Tree"
	},
	"randomize": {
		"file": "randomize",
		"tooltip": "Randomize"
	},
	"range": {
		"file": "range",
		"tooltip": "Range"
	},
	"range_bound_charges": {
		"file": "range_bound_charges",
		"tooltip": "Range Bound Charges"
	},
	"range_type": {
		"file": "range_type",
		"tooltip": "Range Type"
	},
	"ranged_attacks_ignore_cover": {
		"file": "ignore_ranged_weapon_attack_roll_dis_within_an_enemy_reach",
		"tooltip": "Ignore Ranged Weapon Attack Roll Dis Within an Enemy Reach"
	},
	"ranged_attacks_ignore_partial_cover": {
		"file": "ignore_ranged_weapon_attack_roll_dis_within_an_enemy_reach",
		"tooltip": "Ignore Ranged Weapon Attack Roll Dis Within an Enemy Reach"
	},
	"ranged_loading": {
		"file": "ranged_loading",
		"tooltip": "Ranged Loading"
	},
	"ranged_spell_attacks_ignore_cover": {
		"file": "ignore_ranged_spell_attack_roll_dis_within_an_enemy_reach",
		"tooltip": "Ignore Ranged Spell Attack Roll Dis Within an Enemy Reach"
	},
	"ranged_weapon_attacks_ignore_cover": {
		"file": "ignore_ranged_weapon_attack_roll_dis_within_an_enemy_reach",
		"tooltip": "Ignore Ranged Weapon Attack Roll Dis Within an Enemy Reach"
	},
	"reach": {
		"file": "reach",
		"tooltip": "Reach"
	},
	"reaction": {
		"file": "reaction",
		"tooltip": "Reaction"
	},
	"reaction_abilities": {
		"file": "reaction_abilities",
		"tooltip": "Reaction Abilities"
	},
	"reaction_ability": {
		"file": "reaction_ability",
		"tooltip": "Reaction Ability"
	},
	"reaction_gained": {
		"file": "reaction_gained",
		"tooltip": "Reaction Gained"
	},
	"reaction_reset": {
		"file": "reaction_reset",
		"tooltip": "Reaction Reset"
	},
	"read": {
		"file": "read",
		"tooltip": "Read"
	},
	"reading": {
		"file": "reading",
		"tooltip": "Reading"
	},
	"reading_time": {
		"file": "reading_time",
		"tooltip": "Reading Time"
	},
	"reads_all_languages": {
		"file": "written_in_language",
		"tooltip": "Written in Language"
	},
	"reads_target_thoughts": {
		"file": "telepathy",
		"tooltip": "Telepathy"
	},
	"ready": {
		"file": "ready",
		"tooltip": "Ready"
	},
	"reagent": {
		"file": "reagent",
		"tooltip": "Reagent"
	},
	"recall_summon": {
		"file": "recall_summon",
		"tooltip": "Recall Summon"
	},
	"recharge": {
		"file": "recharge",
		"tooltip": "Recharge"
	},
	"recharge_v_dice": {
		"file": "v_dice",
		"tooltip": "Recharge V Dice"
	},
	"rechargeable_by_ability": {
		"file": "rechargeable_by_ability",
		"tooltip": "Rechargeable by Ability"
	},
	"rechargeable_by_passive_ability": {
		"file": "rechargeable_by_ability",
		"tooltip": "Rechargeable by Passive Ability"
	},
	"recipe": {
		"file": "recipe",
		"tooltip": "Recipe"
	},
	"reduce_attack": {
		"file": "reduce_attack",
		"tooltip": "Reduce Attack"
	},
	"reduce_head_attack": {
		"file": "reduce_head_attack",
		"tooltip": "Reduce Head Attack"
	},
	"refresh": {
		"file": "refresh",
		"tooltip": "Refresh"
	},
	"refresh_log": {
		"file": "refresh_log",
		"tooltip": "Refresh Log"
	},
	"regional_effect": {
		"file": "regional_effect",
		"tooltip": "Regional Effect"
	},
	"regress_grapple_escape": {
		"file": "regress_grapple_escape",
		"tooltip": "Regress Grapple Escape"
	},
	"regress_grapple_restrained": {
		"file": "regress_grapple_restrained",
		"tooltip": "Regress Grapple Restrained"
	},
	"rejoin_campaign_session": {
		"file": "rejoin_campaign_session",
		"tooltip": "Rejoin Campaign Session"
	},
	"release_grapple": {
		"file": "release_grapple",
		"tooltip": "Release Grapple"
	},
	"rename_inventory": {
		"file": "rename_inventory",
		"tooltip": "Rename Inventory"
	},
	"request": {
		"file": "request",
		"tooltip": "Request"
	},
	"requested_signup": {
		"file": "requested_signup",
		"tooltip": "Requested Signup"
	},
	"requires_alternative_reagent_1": {
		"file": "requires_alternative_reagent_1",
		"tooltip": "Requires Alternative Reagent 1"
	},
	"requires_alternative_reagent_2": {
		"file": "requires_alternative_reagent_2",
		"tooltip": "Requires Alternative Reagent 2"
	},
	"requires_alternative_reagent_3": {
		"file": "requires_alternative_reagent_3",
		"tooltip": "Requires Alternative Reagent 3"
	},
	"requires_alternative_reagent_4": {
		"file": "requires_alternative_reagent_4",
		"tooltip": "Requires Alternative Reagent 4"
	},
	"requires_ancestry": {
		"file": "requires_ancestry",
		"tooltip": "Requires Ancestry"
	},
	"requires_class": {
		"file": "requires_class",
		"tooltip": "Requires Class"
	},
	"requires_essence": {
		"file": "requires_essence",
		"tooltip": "Requires Essence"
	},
	"requires_feat": {
		"file": "requires_feat",
		"tooltip": "Requires Feat"
	},
	"requires_in_combat": {
		"file": "requires_in_combat",
		"tooltip": "Requires in Combat"
	},
	"requires_legendary_skill_tier": {
		"file": "requires_legendary_skill_tier",
		"tooltip": "Requires Legendary Skill Tier"
	},
	"requires_lineage": {
		"file": "requires_lineage",
		"tooltip": "Requires Lineage"
	},
	"requires_out_of_combat": {
		"file": "requires_out_of_combat",
		"tooltip": "Requires Out of Combat"
	},
	"requires_skill_tier": {
		"file": "requires_skill_tier",
		"tooltip": "Requires Skill Tier"
	},
	"requires_skill_tier_0": {
		"file": "requires_skill_tier_0",
		"tooltip": "Requires Skill Tier"
	},
	"requires_skill_tier_1": {
		"file": "requires_skill_tier_1",
		"tooltip": "Requires Skill Tier 1"
	},
	"requires_skill_tier_10": {
		"file": "requires_skill_tier_10",
		"tooltip": "Requires Skill Tier 10"
	},
	"requires_skill_tier_11": {
		"file": "requires_skill_tier_11",
		"tooltip": "Requires Skill Tier 11"
	},
	"requires_skill_tier_12": {
		"file": "requires_skill_tier_12",
		"tooltip": "Requires Skill Tier 12"
	},
	"requires_skill_tier_13": {
		"file": "requires_skill_tier_13",
		"tooltip": "Requires Skill Tier 13"
	},
	"requires_skill_tier_14": {
		"file": "requires_skill_tier_14",
		"tooltip": "Requires Skill Tier 14"
	},
	"requires_skill_tier_15": {
		"file": "requires_skill_tier_15",
		"tooltip": "Requires Skill Tier 15"
	},
	"requires_skill_tier_16": {
		"file": "requires_skill_tier_16",
		"tooltip": "Requires Skill Tier 16"
	},
	"requires_skill_tier_17": {
		"file": "requires_skill_tier_17",
		"tooltip": "Requires Skill Tier 17"
	},
	"requires_skill_tier_18": {
		"file": "requires_skill_tier_18",
		"tooltip": "Requires Skill Tier 18"
	},
	"requires_skill_tier_19": {
		"file": "requires_skill_tier_19",
		"tooltip": "Requires Skill Tier 19"
	},
	"requires_skill_tier_2": {
		"file": "requires_skill_tier_2",
		"tooltip": "Requires Skill Tier 2"
	},
	"requires_skill_tier_20": {
		"file": "requires_skill_tier_20",
		"tooltip": "Requires Skill Tier 20"
	},
	"requires_skill_tier_21": {
		"file": "requires_skill_tier_21",
		"tooltip": "Requires Skill Tier 21"
	},
	"requires_skill_tier_22": {
		"file": "requires_skill_tier_22",
		"tooltip": "Requires Skill Tier 22"
	},
	"requires_skill_tier_23": {
		"file": "requires_skill_tier_23",
		"tooltip": "Requires Skill Tier 23"
	},
	"requires_skill_tier_24": {
		"file": "requires_skill_tier_24",
		"tooltip": "Requires Skill Tier 24"
	},
	"requires_skill_tier_3": {
		"file": "requires_skill_tier_3",
		"tooltip": "Requires Skill Tier 3"
	},
	"requires_skill_tier_4": {
		"file": "requires_skill_tier_4",
		"tooltip": "Requires Skill Tier 4"
	},
	"requires_skill_tier_5": {
		"file": "requires_skill_tier_5",
		"tooltip": "Requires Skill Tier 5"
	},
	"requires_skill_tier_6": {
		"file": "requires_skill_tier_6",
		"tooltip": "Requires Skill Tier 6"
	},
	"requires_skill_tier_7": {
		"file": "requires_skill_tier_7",
		"tooltip": "Requires Skill Tier 7"
	},
	"requires_skill_tier_8": {
		"file": "requires_skill_tier_8",
		"tooltip": "Requires Skill Tier 8"
	},
	"requires_skill_tier_9": {
		"file": "requires_skill_tier_9",
		"tooltip": "Requires Skill Tier 9"
	},
	"requires_subclass": {
		"file": "requires_subclass",
		"tooltip": "Requires Subclass"
	},
	"requires_tool": {
		"file": "requires_tool",
		"tooltip": "Requires Tool"
	},
	"reroll": {
		"file": "reroll",
		"tooltip": "Reroll"
	},
	"reschedule_session": {
		"file": "schedule",
		"tooltip": "Reschedule Session"
	},
	"reset_axis": {
		"file": "reset_axis",
		"tooltip": "Reset Axis"
	},
	"reset_prepared_spell_list": {
		"file": "prepare_spell",
		"tooltip": "Reset Prepared Spell List"
	},
	"reset_turn_timer": {
		"file": "reset_turn_timer",
		"tooltip": "Reset Turn Timer"
	},
	"resolve": {
		"file": "resolve",
		"tooltip": "Resolve"
	},
	"rest": {
		"file": "rest",
		"tooltip": "Rest"
	},
	"restart_campaign": {
		"file": "restart_campaign",
		"tooltip": "Restart Campaign"
	},
	"restore_encounter": {
		"file": "restore_encounter",
		"tooltip": "Restore Encounter"
	},
	"restrained_by_caster_cannot_teleport": {
		"file": "restrained",
		"tooltip": "Restrained"
	},
	"restricted": {
		"file": "restricted",
		"tooltip": "Restricted"
	},
	"resume": {
		"file": "resume_turn_timer",
		"tooltip": "Resume"
	},
	"resume_turn_timer": {
		"file": "resume_turn_timer",
		"tooltip": "Resume Turn Timer"
	},
	"resurrect_creature": {
		"file": "resurrect_creature",
		"tooltip": "Resurrect Creature"
	},
	"reveal": {
		"file": "reveal",
		"tooltip": "Reveal"
	},
	"reveal_all_creatures": {
		"file": "reveal_all_creatures",
		"tooltip": "Reveal All Creatures"
	},
	"reveal_creature": {
		"file": "reveal_creature",
		"tooltip": "Reveal Creature"
	},
	"reveal_targets": {
		"file": "reveal_targets",
		"tooltip": "Reveal Targets"
	},
	"reveals_target_essence": {
		"file": "essence",
		"tooltip": "Essence"
	},
	"revert_shapeshift": {
		"file": "revert_shapeshift",
		"tooltip": "Revert Shapeshift"
	},
	"reverted_shapeshift": {
		"file": "reverted_shapeshift",
		"tooltip": "Reverted Shapeshift"
	},
	"ride_a_vehicle": {
		"file": "ride_a_vehicle",
		"tooltip": "Ride a Vehicle"
	},
	"rite": {
		"file": "rite",
		"tooltip": "Rite"
	},
	"robust_build": {
		"file": "robust_build",
		"tooltip": "Robust Build"
	},
	"roleplay": {
		"file": "roleplay",
		"tooltip": "Roleplay"
	},
	"roleplaying": {
		"file": "roleplaying",
		"tooltip": "Roleplaying"
	},
	"roll_1_triggers_only_if_target_is_below_hp_max": {
		"file": "roll_1_triggers_only_if_target_is_below_hp_max",
		"tooltip": "Roll 1 Triggers Only If Target Is Below Hp Max"
	},
	"roll_1_triggers_when_target_is_hit_by_melee_spell_attack": {
		"file": "roll_1_triggers_when_target_is_hit_by_melee_spell_attack",
		"tooltip": "Roll 1 Triggers When Target Is Hit by Melee Spell Attack"
	},
	"roll_1_triggers_when_target_is_hit_by_melee_weapon_attack": {
		"file": "roll_1_triggers_when_target_is_hit_by_melee_weapon_attack",
		"tooltip": "Roll 1 Triggers When Target Is Hit by Melee Weapon Attack"
	},
	"roll_1_triggers_when_target_is_hit_by_ranged_spell_attack": {
		"file": "roll_1_triggers_when_target_is_hit_by_ranged_spell_attack",
		"tooltip": "Roll 1 Triggers When Target Is Hit by Ranged Spell Attack"
	},
	"roll_1_triggers_when_target_is_hit_by_ranged_weapon_attack": {
		"file": "roll_1_triggers_when_target_is_hit_by_ranged_weapon_attack",
		"tooltip": "Roll 1 Triggers When Target Is Hit by Ranged Weapon Attack"
	},
	"roll_1_triggers_when_target_moves": {
		"file": "roll_1_triggers_when_target_moves",
		"tooltip": "Roll 1 Triggers When Target Moves"
	},
	"roll_1_triggers_when_target_takes_damage": {
		"file": "roll_1_triggers_when_target_takes_damage",
		"tooltip": "Roll 1 Triggers When Target Takes Damage"
	},
	"roll_2_triggers_only_if_target_is_below_hp_max": {
		"file": "roll_2_triggers_only_if_target_is_below_hp_max",
		"tooltip": "Roll 2 Triggers Only If Target Is Below Hp Max"
	},
	"roll_2_triggers_when_target_is_hit_by_melee_spell_attack": {
		"file": "roll_2_triggers_when_target_is_hit_by_melee_spell_attack",
		"tooltip": "Roll 2 Triggers When Target Is Hit by Melee Spell Attack"
	},
	"roll_2_triggers_when_target_is_hit_by_melee_weapon_attack": {
		"file": "roll_1_triggers_when_target_is_hit_by_melee_weapon_attack",
		"tooltip": "Roll 2 Triggers When Target Is Hit by Melee Weapon Attack"
	},
	"roll_2_triggers_when_target_is_hit_by_ranged_spell_attack": {
		"file": "roll_2_triggers_when_target_is_hit_by_ranged_spell_attack",
		"tooltip": "Roll 2 Triggers When Target Is Hit by Ranged Spell Attack"
	},
	"roll_2_triggers_when_target_is_hit_by_ranged_weapon_attack": {
		"file": "roll_2_triggers_when_target_is_hit_by_ranged_weapon_attack",
		"tooltip": "Roll 2 Triggers When Target Is Hit by Ranged Weapon Attack"
	},
	"roll_2_triggers_when_target_moves": {
		"file": "roll_2_triggers_when_target_moves",
		"tooltip": "Roll 2 Triggers When Target Moves"
	},
	"roll_2_triggers_when_target_takes_damage": {
		"file": "roll_2_triggers_when_target_takes_damage",
		"tooltip": "Roll 2 Triggers When Target Takes Damage"
	},
	"roll_complex_dice": {
		"file": "roll_complex_dice",
		"tooltip": "Roll Complex Dice"
	},
	"roll_creatures_sneak_initiative": {
		"file": "roll_creatures_sneak_initiative",
		"tooltip": "Roll Creatures Sneak Initiative"
	},
	"roll_initiative": {
		"file": "roll_initiative",
		"tooltip": "Roll Initiative"
	},
	"roll_players_sneak_initiative": {
		"file": "roll_players_sneak_initiative",
		"tooltip": "Roll Players Sneak Initiative"
	},
	"roll_random_table": {
		"file": "roll_random_table",
		"tooltip": "Roll Random Table"
	},
	"roll_triggers": {
		"file": "roll_triggers",
		"tooltip": "Roll Triggers"
	},
	"roll_type": {
		"file": "roll_type",
		"tooltip": "Roll Type"
	},
	"roll_type_adv": {
		"file": "roll_type_adv",
		"tooltip": "Roll Type Adv"
	},
	"roll_type_against_adv": {
		"file": "roll_type_against_adv",
		"tooltip": "Roll Type Against Adv"
	},
	"roll_type_against_dis": {
		"file": "roll_type_against_dis",
		"tooltip": "Roll Type Against Dis"
	},
	"roll_type_against_is_rolled_at_max": {
		"file": "roll_type_against_is_rolled_at_max",
		"tooltip": "Roll Type Against Is Rolled at Max"
	},
	"roll_type_against_is_rolled_at_min": {
		"file": "roll_type_against_is_rolled_at_min",
		"tooltip": "Roll Type Against Is Rolled at Min"
	},
	"roll_type_against_roll_result_is_doubled": {
		"file": "roll_type_against_roll_result_is_doubled",
		"tooltip": "Roll Type Against Roll Result Is Doubled"
	},
	"roll_type_against_roll_result_is_halved": {
		"file": "roll_type_against_roll_result_is_halved",
		"tooltip": "Roll Type Against Roll Result Is Halved"
	},
	"roll_type_dis": {
		"file": "roll_type_dis",
		"tooltip": "Roll Type Dis"
	},
	"roll_type_is_rolled_at_max": {
		"file": "roll_type_is_rolled_at_max",
		"tooltip": "Roll Type Is Rolled at Max"
	},
	"roll_type_is_rolled_at_min": {
		"file": "roll_type_is_rolled_at_min",
		"tooltip": "Roll Type Is Rolled at Min"
	},
	"roll_type_roll_result_is_doubled": {
		"file": "roll_type_roll_result_is_doubled",
		"tooltip": "Roll Type Roll Result Is Doubled"
	},
	"roll_type_roll_result_is_halved": {
		"file": "roll_type_roll_result_is_halved",
		"tooltip": "Roll Type Roll Result Is Halved"
	},
	"roof": {
		"file": "roof",
		"tooltip": "Roof"
	},
	"room": {
		"file": "room",
		"tooltip": "Room"
	},
	"rubble": {
		"file": "rubble",
		"tooltip": "Rubble"
	},
	"ruins": {
		"file": "ruins",
		"tooltip": "Ruins"
	},
	"ruler": {
		"file": "ruler",
		"tooltip": "Measure distance"
	},
	"rules_glossary": {
		"file": "rules_glossary",
		"tooltip": "Rules Glossary"
	},
	"runeforging_recipe": {
		"file": "runeforging_recipe",
		"tooltip": "Runeforging Recipe"
	},
	"sale": {
		"file": "sale",
		"tooltip": "Sale"
	},
	"sanguine": {
		"file": "sanguine",
		"tooltip": "Sanguine"
	},
	"sanguine_free_for_sanguine": {
		"file": "sanguine",
		"tooltip": "Sanguine"
	},
	"sanguine_free_max_spell_level": {
		"file": "sanguine",
		"tooltip": "Sanguine"
	},
	"sanguine_spells_cannot_be_counterspelled": {
		"file": "counterspelling_effect",
		"tooltip": "Counterspelling Effect"
	},
	"scalable_cantrip": {
		"file": "scalable_cantrip",
		"tooltip": "Scalable Cantrip"
	},
	"scatter": {
		"file": "scatter",
		"tooltip": "Scatter"
	},
	"scene_origin": {
		"file": "scene_origin",
		"tooltip": "Scene Origin"
	},
	"scene_pointer_coordinates": {
		"file": "scene_pointer_coordinates",
		"tooltip": "Scene Pointer Coordinates"
	},
	"schedule": {
		"file": "schedule",
		"tooltip": "Schedule"
	},
	"scroll": {
		"file": "scroll",
		"tooltip": "Scroll"
	},
	"scroll_spell_damage_multiplier": {
		"file": "scroll",
		"tooltip": "Scroll"
	},
	"search_for_hidden_inventory": {
		"file": "search_for_hidden_inventory",
		"tooltip": "Search for Hidden Inventory"
	},
	"search_for_hidden_inventory_search": {
		"file": "search_for_hidden_inventory",
		"tooltip": "Search for Hidden Inventory"
	},
	"season": {
		"file": "season",
		"tooltip": "Season"
	},
	"secret": {
		"file": "secret",
		"tooltip": "Secret"
	},
	"secret_roll": {
		"file": "secret_roll",
		"tooltip": "Secret Roll"
	},
	"see_through_walls_max_thickness_ft": {
		"file": "truesight",
		"tooltip": "Truesight"
	},
	"seed": {
		"file": "seed",
		"tooltip": "Seed"
	},
	"self_adjust_attack": {
		"file": "self_adjust_attack",
		"tooltip": "Self Adjust Attack"
	},
	"self_adjust_hunger": {
		"file": "self_adjust_hunger",
		"tooltip": "Self Adjust Hunger"
	},
	"self_adjust_luck": {
		"file": "self_adjust_luck",
		"tooltip": "Self Adjust Luck"
	},
	"self_adjust_mana": {
		"file": "self_adjust_mana",
		"tooltip": "Self Adjust Mana"
	},
	"self_adjust_max_v": {
		"file": "self_adjust_max_v",
		"tooltip": "Self Adjust Max V"
	},
	"self_adjust_temp_max_v": {
		"file": "self_adjust_temp_max_v",
		"tooltip": "Self Adjust Temp Max V"
	},
	"self_adjust_temp_v": {
		"file": "self_adjust_temp_v",
		"tooltip": "Self Adjust Temp V"
	},
	"self_adjust_thirst": {
		"file": "self_adjust_thirst",
		"tooltip": "Self Adjust Thirst"
	},
	"self_adjust_v": {
		"file": "self_adjust_v",
		"tooltip": "Self Adjust V"
	},
	"sense": {
		"file": "sense",
		"tooltip": "Sense"
	},
	"session_duration": {
		"file": "session_duration",
		"tooltip": "Session Duration"
	},
	"session_paused": {
		"file": "pause",
		"tooltip": "Session Paused"
	},
	"session_resumed": {
		"file": "play",
		"tooltip": "Session Resumed"
	},
	"set_campaign_campsite": {
		"file": "set_campaign_campsite",
		"tooltip": "Set Campaign Campsite"
	},
	"set_campaign_stronghold": {
		"file": "set_campaign_stronghold",
		"tooltip": "Set Campaign Stronghold"
	},
	"set_encounter_creature_presentation_pic_id": {
		"file": "picture",
		"tooltip": "Picture"
	},
	"set_encounter_creature_thumbnail_pic_id": {
		"file": "set_encounter_creature_thumbnail_pic_id",
		"tooltip": "Set Encounter Creature Thumbnail Pic Id"
	},
	"set_inventory_presentation_pic_id": {
		"file": "picture",
		"tooltip": "Picture"
	},
	"set_inventory_thumbnail_pic_id": {
		"file": "set_inventory_thumbnail_pic_id",
		"tooltip": "Set Inventory Thumbnail Pic Id"
	},
	"setting": {
		"file": "setting",
		"tooltip": "Setting"
	},
	"settings": {
		"file": "settings",
		"tooltip": "Settings"
	},
	"settlement_location_type": {
		"file": "settlement_location_type",
		"tooltip": "Settlement Location Type"
	},
	"shapechange": {
		"file": "shapechange",
		"tooltip": "Shapechange"
	},
	"shapeshift": {
		"file": "shapeshift",
		"tooltip": "Shapeshift"
	},
	"shapeshift_inventory_remains_on_form": {
		"file": "shapeshift_inventory_remains_on_form",
		"tooltip": "Shapeshift Inventory Remains on Form"
	},
	"shapeshift_monster_template": {
		"file": "shapeshift_monster_template",
		"tooltip": "Shapeshift Monster Template"
	},
	"shapeshifted": {
		"file": "shapeshifted",
		"tooltip": "Shapeshifted"
	},
	"share_campaign_settings": {
		"file": "share_campaign_settings",
		"tooltip": "Share Campaign Settings"
	},
	"share_player_character": {
		"file": "share_player_character",
		"tooltip": "Share Player Character"
	},
	"share_player_character_allowed": {
		"file": "share_player_character_allowed",
		"tooltip": "Share Player Character Allowed"
	},
	"share_player_character_disallowed": {
		"file": "share_player_character_disallowed",
		"tooltip": "Share Player Character Disallowed"
	},
	"shield": {
		"file": "shield",
		"tooltip": "Shield"
	},
	"shield_shattering_blow": {
		"file": "shield_shattering_blow",
		"tooltip": "Shield Shattering Blow"
	},
	"short_rest": {
		"file": "rest",
		"tooltip": "Short Rest"
	},
	"shove": {
		"file": "shove",
		"tooltip": "Shove"
	},
	"show_class": {
		"file": "show_class",
		"tooltip": "Show Class"
	},
	"show_encounter_description": {
		"file": "show_encounter_description",
		"tooltip": "Show Encounter Description"
	},
	"show_encounter_gm_notes": {
		"file": "show_encounter_gm_notes",
		"tooltip": "Show Encounter Gm Notes"
	},
	"show_status_effects": {
		"file": "show_status_effects",
		"tooltip": "Show Status Effects"
	},
	"signup": {
		"file": "signup",
		"tooltip": "Signup"
	},
	"silverware": {
		"file": "silverware",
		"tooltip": "Silverware"
	},
	"simple_roll": {
		"file": "simple_roll",
		"tooltip": "Simple Roll"
	},
	"size": {
		"file": "size",
		"tooltip": "Size"
	},
	"size_scalable": {
		"file": "size",
		"tooltip": "Size-Scalable Recipe"
	},
	"size_type": {
		"file": "size_type",
		"tooltip": "Size Type"
	},
	"skill": {
		"file": "skill",
		"tooltip": "Skill"
	},
	"skill_adept": {
		"file": "skill_adept",
		"tooltip": "Skill Adept"
	},
	"skill_flawed": {
		"file": "skill_flawed",
		"tooltip": "Skill Flawed"
	},
	"skill_godlike": {
		"file": "skill_godlike",
		"tooltip": "Skill Godlike"
	},
	"skill_is_rolled_at_max": {
		"file": "skill_is_rolled_at_max",
		"tooltip": "Skill Is Rolled at Max"
	},
	"skill_is_rolled_at_min": {
		"file": "skill_is_rolled_at_min",
		"tooltip": "Skill Is Rolled at Min"
	},
	"skill_legendary": {
		"file": "skill_legendary",
		"tooltip": "Skill Legendary"
	},
	"skill_major": {
		"file": "skill_major",
		"tooltip": "Skill Major"
	},
	"skill_master": {
		"file": "skill_master",
		"tooltip": "Skill Master"
	},
	"skill_minor": {
		"file": "skill_minor",
		"tooltip": "Skill Minor"
	},
	"skill_point_allocating": {
		"file": "skill_point_allocating",
		"tooltip": "Skill Point Allocating"
	},
	"skill_point_training": {
		"file": "skill_point_training",
		"tooltip": "Skill Point Training"
	},
	"skill_points": {
		"file": "skill_points",
		"tooltip": "Skill Points"
	},
	"skill_points_allocating": {
		"file": "skill_points_allocating",
		"tooltip": "Skill Points Allocating"
	},
	"skill_points_training": {
		"file": "skill_points_training",
		"tooltip": "Skill Points Training"
	},
	"skill_roll": {
		"file": "skill_roll",
		"tooltip": "Skill Roll"
	},
	"skill_roll_adv": {
		"file": "skill_roll_adv",
		"tooltip": "Skill Roll Adv"
	},
	"skill_roll_assistance_roll": {
		"file": "skill_roll_assistance_roll",
		"tooltip": "Skill Roll Assistance Roll"
	},
	"skill_roll_contest": {
		"file": "skill_roll_contest",
		"tooltip": "Skill Roll Contest"
	},
	"skill_roll_contestee": {
		"file": "skill_roll_contestee",
		"tooltip": "Skill Roll Contestee"
	},
	"skill_roll_contester": {
		"file": "skill_roll_contester",
		"tooltip": "Skill Roll Contester"
	},
	"skill_roll_dis": {
		"file": "skill_roll_dis",
		"tooltip": "Skill Roll Dis"
	},
	"skill_roll_ignore_dis": {
		"file": "skill_roll_adv",
		"tooltip": "Skill Roll Adv"
	},
	"skill_roll_mod": {
		"file": "skill_roll_mod",
		"tooltip": "Skill Roll Mod"
	},
	"skill_roll_retracting_roll": {
		"file": "skill_roll_retracting_roll",
		"tooltip": "Skill Roll Retracting Roll"
	},
	"skill_rolls_adv": {
		"file": "skill_rolls_adv",
		"tooltip": "Skill Rolls Adv"
	},
	"skill_rolls_dis": {
		"file": "skill_rolls_dis",
		"tooltip": "Skill Rolls Dis"
	},
	"skill_rolls_mod": {
		"file": "skill_rolls_mod",
		"tooltip": "Skill Rolls Mod"
	},
	"skill_tier": {
		"file": "skill_tier",
		"tooltip": "Skill Tier"
	},
	"skill_trained": {
		"file": "skill_trained",
		"tooltip": "Skill Trained"
	},
	"skill_type": {
		"file": "skill_type",
		"tooltip": "Skill Type"
	},
	"skip_campaign_session": {
		"file": "skip_campaign_session",
		"tooltip": "Skip Campaign Session"
	},
	"skipping_campaign_session": {
		"file": "skipping_campaign_session",
		"tooltip": "Skipping Campaign Session"
	},
	"smithing_recipe": {
		"file": "smithing_recipe",
		"tooltip": "Smithing Recipe"
	},
	"snap_outta_it": {
		"file": "snap_outta_it",
		"tooltip": "Snap Outta It"
	},
	"source": {
		"file": "source",
		"tooltip": "Source"
	},
	"source_artist": {
		"file": "artist",
		"tooltip": "Source Artist"
	},
	"source_author": {
		"file": "source_author",
		"tooltip": "Source Author"
	},
	"source_link": {
		"file": "source_link",
		"tooltip": "Source link"
	},
	"speaks_all_languages": {
		"file": "written_in_language",
		"tooltip": "Written in Language"
	},
	"speed_cannot_be_reduced": {
		"file": "immune_to_forced_movement",
		"tooltip": "Immune to Forced Movement"
	},
	"speed_jumping_multiplier": {
		"file": "speed_jumping",
		"tooltip": "Speed Jumping"
	},
	"speed_type": {
		"file": "speed_type",
		"tooltip": "Speed Type"
	},
	"spell": {
		"file": "spell",
		"tooltip": "Spell"
	},
	"spell_casting_time": {
		"file": "spell_casting_time",
		"tooltip": "Spell Casting Time"
	},
	"spell_circle": {
		"file": "spell_circle",
		"tooltip": "Spell Circle"
	},
	"spell_component_material": {
		"file": "spell_component_material",
		"tooltip": "Spell Component Material"
	},
	"spell_component_material_consumed": {
		"file": "spell_component_material_consumed",
		"tooltip": "Spell Component Material Consumed"
	},
	"spell_component_somatic": {
		"file": "spell_component_somatic",
		"tooltip": "Spell Component Somatic"
	},
	"spell_component_verbal": {
		"file": "spell_component_verbal",
		"tooltip": "Spell Component Verbal"
	},
	"spell_damage_resistance": {
		"file": "spell_damage_resistance",
		"tooltip": "Spell Damage Resistance"
	},
	"spell_damage_vulnerability": {
		"file": "spell_damage_vulnerability",
		"tooltip": "Spell Damage Vulnerability"
	},
	"spell_known": {
		"file": "spell_known",
		"tooltip": "Spell Known"
	},
	"spell_level": {
		"file": "spell_level",
		"tooltip": "Spell Level"
	},
	"spell_level_0": {
		"file": "spell_level_0",
		"tooltip": "Spell Level"
	},
	"spell_level_1": {
		"file": "spell_level_1",
		"tooltip": "Spell Level 1"
	},
	"spell_level_10": {
		"file": "spell_level_10",
		"tooltip": "Spell Level 10"
	},
	"spell_level_2": {
		"file": "spell_level_2",
		"tooltip": "Spell Level 2"
	},
	"spell_level_3": {
		"file": "spell_level_3",
		"tooltip": "Spell Level 3"
	},
	"spell_level_4": {
		"file": "spell_level_4",
		"tooltip": "Spell Level 4"
	},
	"spell_level_5": {
		"file": "spell_level_5",
		"tooltip": "Spell Level 5"
	},
	"spell_level_6": {
		"file": "spell_level_6",
		"tooltip": "Spell Level 6"
	},
	"spell_level_7": {
		"file": "spell_level_7",
		"tooltip": "Spell Level 7"
	},
	"spell_level_8": {
		"file": "spell_level_8",
		"tooltip": "Spell Level 8"
	},
	"spell_level_9": {
		"file": "spell_level_9",
		"tooltip": "Spell Level 9"
	},
	"spell_mana_discount": {
		"file": "mana",
		"tooltip": "Mana"
	},
	"spell_material_component": {
		"file": "spell_material_component",
		"tooltip": "Spell Material Component"
	},
	"spell_material_item_id": {
		"file": "spell_material_item_id",
		"tooltip": "Spell Material Item Id"
	},
	"spell_melee_attack_rolls_adv": {
		"file": "spell_melee_attack_rolls_adv",
		"tooltip": "Spell Melee Attack Rolls Adv"
	},
	"spell_melee_attack_rolls_against_adv": {
		"file": "spell_melee_attack_rolls_against_adv",
		"tooltip": "Spell Melee Attack Rolls Against Adv"
	},
	"spell_melee_attack_rolls_against_dis": {
		"file": "spell_melee_attack_rolls_against_dis",
		"tooltip": "Spell Melee Attack Rolls Against Dis"
	},
	"spell_melee_attack_rolls_dis": {
		"file": "spell_melee_attack_rolls_dis",
		"tooltip": "Spell Melee Attack Rolls Dis"
	},
	"spell_miscast": {
		"file": "armor_bending_roll",
		"tooltip": "Spell Miscast"
	},
	"spell_options": {
		"file": "spell_options",
		"tooltip": "Spell Options"
	},
	"spell_prepared_1": {
		"file": "spell_prepared_1",
		"tooltip": "Spell Prepared 1"
	},
	"spell_prepared_2": {
		"file": "spell_prepared_2",
		"tooltip": "Spell Prepared 2"
	},
	"spell_prepared_3": {
		"file": "spell_prepared_3",
		"tooltip": "Spell Prepared 3"
	},
	"spell_range_multiplier": {
		"file": "range_very_far",
		"tooltip": "Range Very Far"
	},
	"spell_ranged_attack_roll_range_increased_from": {
		"file": "spell_ranged_attack_roll_range_increased_from",
		"tooltip": "Spell Ranged Attack Range Increased — From (minimum)"
	},
	"spell_ranged_attack_roll_range_increased_to": {
		"file": "spell_ranged_attack_roll_range_increased_to",
		"tooltip": "Spell Ranged Attack Range Increased — To"
	},
	"spell_ranged_attack_rolls_adv": {
		"file": "spell_ranged_attack_rolls_adv",
		"tooltip": "Spell Ranged Attack Rolls Adv"
	},
	"spell_ranged_attack_rolls_against_adv": {
		"file": "spell_ranged_attack_rolls_against_adv",
		"tooltip": "Spell Ranged Attack Rolls Against Adv"
	},
	"spell_ranged_attack_rolls_against_dis": {
		"file": "spell_ranged_attack_rolls_against_dis",
		"tooltip": "Spell Ranged Attack Rolls Against Dis"
	},
	"spell_ranged_attack_rolls_dis": {
		"file": "spell_ranged_attack_rolls_dis",
		"tooltip": "Spell Ranged Attack Rolls Dis"
	},
	"spell_ritual": {
		"file": "spell_ritual",
		"tooltip": "Spell Ritual"
	},
	"spell_scalable_cantrip": {
		"file": "spell_scalable_cantrip",
		"tooltip": "Spell Scalable Cantrip"
	},
	"spell_sphere": {
		"file": "spell_sphere",
		"tooltip": "Spell Sphere"
	},
	"spell_upcast_additional_projectiles_created": {
		"file": "spell_upcast_additional_projectiles_created",
		"tooltip": "Spell Upcast Additional Projectiles Created"
	},
	"spell_upcast_additional_targets_int": {
		"file": "spell_upcast_additional_targets_int",
		"tooltip": "Spell Upcast Additional Targets Int"
	},
	"spell_upcast_duration_int": {
		"file": "spell_upcast_duration_int",
		"tooltip": "Spell Upcast Duration Int"
	},
	"spell_upcast_duration_type": {
		"file": "spell_upcast_duration_type",
		"tooltip": "Spell Upcast Duration Type"
	},
	"spell_upcastable": {
		"file": "spell_upcastable",
		"tooltip": "Spell Upcastable"
	},
	"spellcasting_essence": {
		"file": "spellcasting_essence",
		"tooltip": "Spellcasting Essence"
	},
	"spellcasting_focus": {
		"file": "spellcasting_focus",
		"tooltip": "Spellcasting Focus"
	},
	"spells_cannot_be_counterspelled": {
		"file": "counterspelling_effect",
		"tooltip": "Counterspelling Effect"
	},
	"spells_cannot_be_counterspelled_below_level": {
		"file": "counterspell_tier",
		"tooltip": "Counterspell Tier"
	},
	"spells_ignore_damage_mitigation": {
		"file": "effect_ignores_damage_type_resistance",
		"tooltip": "Effect Ignores Damage Type Resistance"
	},
	"spells_prepared_1": {
		"file": "spells_prepared_1",
		"tooltip": "Spells Prepared 1"
	},
	"spells_prepared_2": {
		"file": "spells_prepared_2",
		"tooltip": "Spells Prepared 2"
	},
	"spells_prepared_3": {
		"file": "spells_prepared_3",
		"tooltip": "Spells Prepared 3"
	},
	"sphere_of_magic": {
		"file": "sphere_of_magic",
		"tooltip": "Sphere of Magic"
	},
	"spheres_of_magic": {
		"file": "spheres_of_magic",
		"tooltip": "Spheres of Magic"
	},
	"spoilage": {
		"file": "spoilage",
		"tooltip": "Spoilage"
	},
	"spot_hidden_creature": {
		"file": "spot_hidden_creature",
		"tooltip": "Spot Hidden Creature"
	},
	"spot_hidden_creatures_search": {
		"file": "spot_hidden_creatures",
		"tooltip": "Spot Hidden Creatures"
	},
	"squeeze_size_category_offset": {
		"file": "squeezed",
		"tooltip": "Squeezes as this many size categories smaller"
	},
	"stacks_applied": {
		"file": "quantity",
		"tooltip": "Status Stacks Applied"
	},
	"stairs_stone": {
		"file": "stairs_stone",
		"tooltip": "Stairs Stone"
	},
	"stairs_wooden": {
		"file": "stairs_wooden",
		"tooltip": "Stairs Wooden"
	},
	"stalk": {
		"file": "stalk",
		"tooltip": "Stalk"
	},
	"stance": {
		"file": "stance",
		"tooltip": "Stance"
	},
	"stand_up": {
		"file": "stand_up",
		"tooltip": "Stand Up"
	},
	"start": {
		"file": "start",
		"tooltip": "Start"
	},
	"start_sneaking": {
		"file": "start_sneaking",
		"tooltip": "Start Sneaking"
	},
	"start_training": {
		"file": "training",
		"tooltip": "Start Training"
	},
	"started_turn": {
		"file": "started_turn",
		"tooltip": "Started Turn"
	},
	"starting_equipment_item_id": {
		"file": "starting_equipment_item_id",
		"tooltip": "Starting Equipment Item Id"
	},
	"starting_equipment_item_id_equipped": {
		"file": "starting_equipment_item_id_equipped",
		"tooltip": "Starting Equipment Item Id Equipped"
	},
	"starting_equipment_item_id_unequipped": {
		"file": "starting_equipment_item_id_unequipped",
		"tooltip": "Starting Equipment Item Id Unequipped"
	},
	"status_effect": {
		"file": "status_effect",
		"tooltip": "Status Effect"
	},
	"status_effect_applied_is_caster_choice": {
		"file": "ability_choice",
		"tooltip": "Caster chooses one applied status effect"
	},
	"status_effect_applied_to_caster_after_cast": {
		"file": "status_effect_applied_to_caster_after_cast",
		"tooltip": "Status Effect Applied to Caster After Cast"
	},
	"status_effect_applied_to_caster_after_contesting_roll_failed": {
		"file": "status_effect_applied_to_caster_after_contesting_roll_failed",
		"tooltip": "Status Effect Applied to Caster After Contesting Roll Failed"
	},
	"status_effect_applied_to_caster_on_hit": {
		"file": "status_effect_applied_to_caster_on_hit",
		"tooltip": "Status Effect Applied to Caster on Hit"
	},
	"status_effect_applied_to_caster_when_contestee_wins": {
		"file": "status_effect_applied_to_caster_when_contestee_wins",
		"tooltip": "Status Effect Applied to Caster When Contestee Wins"
	},
	"status_effect_applied_to_target_after_cast": {
		"file": "status_effect_applied_to_target_after_cast",
		"tooltip": "Status Effect Applied to Target After Cast"
	},
	"status_effect_applied_to_target_after_contesting_roll_failed": {
		"file": "status_effect_applied_to_target_after_contesting_roll_failed",
		"tooltip": "Status Effect Applied to Target After Contesting Roll Failed"
	},
	"status_effect_applied_to_target_on_hit": {
		"file": "status_effect_applied_to_target_on_hit",
		"tooltip": "Status Effect Applied to Target on Hit"
	},
	"status_effect_moved": {
		"file": "status_effect_moved",
		"tooltip": "Status Effect Moved"
	},
	"status_effect_origin": {
		"file": "status_effect_origin",
		"tooltip": "Status Effect Origin"
	},
	"status_effect_parameters": {
		"file": "status_effect_parameters",
		"tooltip": "Status Effect Parameters"
	},
	"status_effect_pausable": {
		"file": "status_effect_pausable",
		"tooltip": "Status Effect Pausable"
	},
	"status_effect_permanent": {
		"file": "status_effect_permanent",
		"tooltip": "Status Effect Permanent"
	},
	"status_effect_removed_from_caster_after_cast": {
		"file": "status_effect_removed_from_caster_after_cast",
		"tooltip": "Status Effect Removed from Caster After Cast"
	},
	"status_effect_removed_from_caster_after_contesting_roll_failed": {
		"file": "status_effect_removed_from_caster_after_contesting_roll_failed",
		"tooltip": "Status Effect Removed from Caster After Contesting Roll Failed"
	},
	"status_effect_removed_from_caster_on_hit": {
		"file": "status_effect_removed_from_caster_on_hit",
		"tooltip": "Status Effect Removed from Caster on Hit"
	},
	"status_effect_removed_from_target_after_cast": {
		"file": "status_effect_removed_from_target_after_cast",
		"tooltip": "Status Effect Removed from Target After Cast"
	},
	"status_effect_removed_from_target_after_contesting_roll_failed": {
		"file": "status_effect_removed_from_target_after_contesting_roll_failed",
		"tooltip": "Status Effect Removed from Target After Contesting Roll Failed"
	},
	"status_effect_removed_from_target_on_hit": {
		"file": "status_effect_removed_from_target_on_hit",
		"tooltip": "Status Effect Removed from Target on Hit"
	},
	"status_stack_decayed": {
		"file": "burning_extinguished",
		"tooltip": "Status Stack Decayed"
	},
	"status_stack_decreased": {
		"file": "quantity",
		"tooltip": "Status Stacks Decreased"
	},
	"status_stack_increased": {
		"file": "quantity",
		"tooltip": "Status Stacks Increased"
	},
	"stop": {
		"file": "stop",
		"tooltip": "Stop"
	},
	"stop_burning": {
		"file": "stop_burning",
		"tooltip": "Stop Burning"
	},
	"stop_sneaking": {
		"file": "stop_sneaking",
		"tooltip": "Stop Sneaking"
	},
	"stop_the_bleeding": {
		"file": "stop_the_bleeding",
		"tooltip": "Stop the Bleeding"
	},
	"subclass": {
		"file": "subclass",
		"tooltip": "Subclass"
	},
	"subclasses": {
		"file": "subclasses",
		"tooltip": "Subclasses"
	},
	"subgenre": {
		"file": "subgenre",
		"tooltip": "Subgenre"
	},
	"submit_character": {
		"file": "submit_character",
		"tooltip": "Submit Character"
	},
	"subplane": {
		"file": "subplane",
		"tooltip": "Subplane"
	},
	"subscription": {
		"file": "subscription",
		"tooltip": "Subscription"
	},
	"subset_table_roll": {
		"file": "subset_table_roll",
		"tooltip": "Subset Table Roll"
	},
	"sum": {
		"file": "sum",
		"tooltip": "Sum"
	},
	"sum_weight": {
		"file": "sum_weight",
		"tooltip": "Sum Weight"
	},
	"summon": {
		"file": "summon",
		"tooltip": "Summon"
	},
	"summon_adept": {
		"file": "summon_adept",
		"tooltip": "Summon Adept"
	},
	"summon_creature": {
		"file": "summon_creature",
		"tooltip": "Summon Creature"
	},
	"summon_dismissed": {
		"file": "summon_dismissed",
		"tooltip": "Summon Dismissed"
	},
	"summon_flawed": {
		"file": "summon_flawed",
		"tooltip": "Summon Flawed"
	},
	"summon_major": {
		"file": "summon_major",
		"tooltip": "Summon Major"
	},
	"summon_master": {
		"file": "summon_master",
		"tooltip": "Summon Master"
	},
	"summon_minor": {
		"file": "summon_minor",
		"tooltip": "Summon Minor"
	},
	"summon_recalled": {
		"file": "summon_recalled",
		"tooltip": "Summon Recalled"
	},
	"summon_trigger_on_kill_grants_caster_menace": {
		"file": "summon_trigger_on_kill_grants_caster_menace",
		"tooltip": "Summon Trigger on Kill Grants Caster Menace"
	},
	"summon_type": {
		"file": "summon_type",
		"tooltip": "Summon Type"
	},
	"summoned_creature": {
		"file": "summoned_creature",
		"tooltip": "Summoned Creature"
	},
	"summons_gain_caster_cantrips": {
		"file": "spell_scalable_cantrip",
		"tooltip": "Spell Scalable Cantrip"
	},
	"sun_state": {
		"file": "sun_state",
		"tooltip": "Sun State"
	},
	"swap_hands": {
		"file": "swap_hands",
		"tooltip": "Swap Hands"
	},
	"swap_positions_with_target": {
		"file": "swap_positions_with_target",
		"tooltip": "Swap Positions with Target"
	},
	"swapped_hands": {
		"file": "swapped_hands",
		"tooltip": "Swapped Hands"
	},
	"table": {
		"file": "table",
		"tooltip": "Table"
	},
	"tack_and_harness": {
		"file": "tack_and_harness",
		"tooltip": "Tack and Harness"
	},
	"tactic": {
		"file": "tactics",
		"tooltip": "Tactic"
	},
	"tag": {
		"file": "tag",
		"tooltip": "Tag"
	},
	"tanning_recipe": {
		"file": "tanning_recipe",
		"tooltip": "Tanning Recipe"
	},
	"taper_candle": {
		"file": "taper_candle",
		"tooltip": "Taper Candle"
	},
	"target": {
		"file": "target",
		"tooltip": "Target"
	},
	"target_all": {
		"file": "target_all",
		"tooltip": "Target All"
	},
	"target_contesting_roll_dis_vs_spell_circle": {
		"file": "contesting_roll_dis_vs_spells",
		"tooltip": "Contesting Roll Dis Vs Spells"
	},
	"target_creature_no_cover": {
		"file": "target",
		"tooltip": "Target Creature: No Cover"
	},
	"target_creature_revealed": {
		"file": "creature_revealed",
		"tooltip": "Target Creature Revealed"
	},
	"target_inventory_revealed": {
		"file": "inventory",
		"tooltip": "Target Inventory Revealed"
	},
	"target_is_marked_by_the_caster": {
		"file": "target_is_marked_by_the_caster",
		"tooltip": "Target Is Marked by the Caster"
	},
	"target_marked_by_caster": {
		"file": "target_marked_by_caster",
		"tooltip": "Target Marked by Caster"
	},
	"target_moved_to_encounter": {
		"file": "target_moved_to_encounter",
		"tooltip": "Target Moved to Encounter"
	},
	"target_retries_contesting_roll_on_damage_taken": {
		"file": "target_retries_contesting_roll_on_end_of_turn",
		"tooltip": "Target retries the contest when damaged by the caster or allies"
	},
	"target_retries_contesting_roll_on_end_of_turn": {
		"file": "target_retries_contesting_roll_on_end_of_turn",
		"tooltip": "Target Retries Contesting Roll on End of Turn"
	},
	"target_retries_contesting_roll_on_start_of_turn": {
		"file": "target_retries_contesting_roll_on_start_of_turn",
		"tooltip": "Target Retries Contesting Roll on Start of Turn"
	},
	"tattoo": {
		"file": "tattoo",
		"tooltip": "Tattoo"
	},
	"team": {
		"file": "team",
		"tooltip": "Team"
	},
	"team_type": {
		"file": "team_type",
		"tooltip": "Team Type"
	},
	"template_location": {
		"file": "template_location",
		"tooltip": "Template Location"
	},
	"temporary_vitality": {
		"file": "temporary_vitality",
		"tooltip": "Temporary Vitality"
	},
	"tempurature_type": {
		"file": "tempurature_type",
		"tooltip": "Temperature Type"
	},
	"term": {
		"file": "term",
		"tooltip": "Term"
	},
	"terms_and_condition": {
		"file": "terms_and_condition",
		"tooltip": "Terms and Condition"
	},
	"terrain_created": {
		"file": "terrain_created",
		"tooltip": "Terrain Created"
	},
	"terrain_type": {
		"file": "terrain_type",
		"tooltip": "Terrain Type"
	},
	"the_party_abstains": {
		"file": "party_vote",
		"tooltip": "Party Vote"
	},
	"the_party_is_divided": {
		"file": "party_vote",
		"tooltip": "Party Vote"
	},
	"the_party_votes_no": {
		"file": "party_vote",
		"tooltip": "Party Vote"
	},
	"the_party_votes_yes": {
		"file": "party_vote",
		"tooltip": "Party Vote"
	},
	"the_sun_begins_to_rise": {
		"file": "the_sun_begins_to_rise",
		"tooltip": "The Sun Begins to Rise"
	},
	"the_sun_begins_to_set": {
		"file": "the_sun_begins_to_set",
		"tooltip": "The Sun Begins to Set"
	},
	"the_sun_has_risen": {
		"file": "the_sun_has_risen",
		"tooltip": "The Sun Has Risen"
	},
	"the_sun_has_set": {
		"file": "the_sun_has_set",
		"tooltip": "The Sun Has Set"
	},
	"theatre_of_the_mind": {
		"file": "roleplay",
		"tooltip": "Theatre of the Mind"
	},
	"theme_dark_mode": {
		"file": "theme_dark_mode",
		"tooltip": "Theme Dark Mode"
	},
	"theme_light_mode": {
		"file": "theme_light_mode",
		"tooltip": "Theme Light Mode"
	},
	"thirst": {
		"file": "thirst",
		"tooltip": "Thirst"
	},
	"throw": {
		"file": "throw",
		"tooltip": "Throw"
	},
	"throw_inventory": {
		"file": "throw_inventory",
		"tooltip": "Throw Inventory"
	},
	"throw_object_max_size_type": {
		"file": "throw_inventory",
		"tooltip": "Largest object size you can throw"
	},
	"throw_weapon": {
		"file": "throw_weapon",
		"tooltip": "Throw Weapon"
	},
	"throwing_distance_changed_by_percentage": {
		"file": "throwing_distance_changed_by_percentage",
		"tooltip": "Throwing Distance Changed by Percentage"
	},
	"timber": {
		"file": "timber",
		"tooltip": "Timber"
	},
	"timeline": {
		"file": "timeline",
		"tooltip": "Timeline"
	},
	"to_next_tier": {
		"file": "to_next_tier",
		"tooltip": "To Next Tier"
	},
	"toggle": {
		"file": "toggle",
		"tooltip": "Toggle"
	},
	"toggle_admins": {
		"file": "toggle_admins",
		"tooltip": "Toggle Admins"
	},
	"toggle_dead_encounter_creatures": {
		"file": "toggle_dead_encounter_creatures",
		"tooltip": "Toggle Dead Encounter Creatures"
	},
	"toggle_encounter_description": {
		"file": "toggle_encounter_description",
		"tooltip": "Toggle Encounter Description"
	},
	"toggle_encounter_gm_notes": {
		"file": "toggle_encounter_gm_notes",
		"tooltip": "Toggle Encounter Gm Notes"
	},
	"toggle_encounter_loot": {
		"file": "toggle_encounter_loot",
		"tooltip": "Toggle Encounter Loot"
	},
	"toggle_encounter_view": {
		"file": "toggle_encounter_view",
		"tooltip": "Toggle Encounter View"
	},
	"toggle_flanked": {
		"file": "toggle_flanked",
		"tooltip": "Toggle Flanked"
	},
	"toggle_log": {
		"file": "toggle_log",
		"tooltip": "Toggle Log"
	},
	"toggle_panels_off": {
		"file": "toggle_panels_off",
		"tooltip": "Toggle Panels Off"
	},
	"toggle_panels_on": {
		"file": "toggle_panels_on",
		"tooltip": "Toggle Panels on"
	},
	"toggle_protected": {
		"file": "toggle_protected",
		"tooltip": "Toggle Protected"
	},
	"toggle_targets_private": {
		"file": "private_all_creatures",
		"tooltip": "Toggle Targets Private"
	},
	"toggle_targets_visibility": {
		"file": "toggle_targets_visibility",
		"tooltip": "Toggle Targets Visibility"
	},
	"tools": {
		"file": "tools",
		"tooltip": "Tools"
	},
	"torch": {
		"file": "torch",
		"tooltip": "Torch"
	},
	"torchlight": {
		"file": "torchlight",
		"tooltip": "Torchlight"
	},
	"total_gp": {
		"file": "total_gp",
		"tooltip": "Total (gp)"
	},
	"tourism": {
		"file": "tourism",
		"tooltip": "Tourism"
	},
	"trade_good": {
		"file": "trade_good",
		"tooltip": "Trade Good"
	},
	"trade_inventory": {
		"file": "trade_inventory",
		"tooltip": "Trade Inventory"
	},
	"trainer": {
		"file": "trainer",
		"tooltip": "Trainer"
	},
	"training": {
		"file": "training",
		"tooltip": "Training"
	},
	"training_book_tier": {
		"file": "training_book_tier",
		"tooltip": "Training Book Tier"
	},
	"training_grounds": {
		"file": "training_grounds",
		"tooltip": "Training Grounds"
	},
	"training_roll": {
		"file": "training_roll",
		"tooltip": "Training Roll"
	},
	"training_skill_tier_up": {
		"file": "skill_point_training",
		"tooltip": "Training Skill Tier Up"
	},
	"training_time": {
		"file": "training_time",
		"tooltip": "Training Time"
	},
	"trait": {
		"file": "trait",
		"tooltip": "Trait"
	},
	"transfer_damage_percentage_to_caster_of_status_effect": {
		"file": "transfer_damage_percentage_to_caster_of_status_effect",
		"tooltip": "Transfer Damage Percentage to Caster of Status Effect"
	},
	"transform": {
		"file": "transform",
		"tooltip": "Transform"
	},
	"transform_into_creature_on_self_zero_vitality": {
		"file": "transform_into_creature_on_self_zero_vitality",
		"tooltip": "Transform Into Creature on Self Zero Vitality"
	},
	"transform_into_creature_on_self_zero_vitality_drop_inventory": {
		"file": "transform_into_creature_on_self_zero_vitality_drop_inventory",
		"tooltip": "Transform Into Creature on Self Zero Vitality Drop Inventory"
	},
	"transform_into_creature_on_self_zero_vitality_equip_inventory": {
		"file": "transform_into_creature_on_self_zero_vitality_equip_inventory",
		"tooltip": "Transform Into Creature on Self Zero Vitality Equip Inventory"
	},
	"transform_into_creature_on_self_zero_vitality_qty": {
		"file": "transform_into_creature_on_self_zero_vitality_qty",
		"tooltip": "Transform Into Creature on Self Zero Vitality Qty"
	},
	"trap": {
		"file": "trap",
		"tooltip": "Trap"
	},
	"treasure": {
		"file": "treasure",
		"tooltip": "Treasure"
	},
	"tree": {
		"file": "tree",
		"tooltip": "Tree"
	},
	"trick_shot": {
		"file": "trick_shot",
		"tooltip": "Trick Shot"
	},
	"trigger": {
		"file": "trigger",
		"tooltip": "Trigger"
	},
	"trigger_ignores_self_source": {
		"file": "triggers_when_caster_takes_any_damage",
		"tooltip": "Triggers When Caster Takes Any Damage"
	},
	"trigger_only_leveled_spells": {
		"file": "triggers_when_caster_casts_a_spell",
		"tooltip": "Triggers When Caster Casts a Spell"
	},
	"triggered": {
		"file": "triggered",
		"tooltip": "Triggered"
	},
	"triggered_roll_type_is_at_adv": {
		"file": "triggered_roll_type_is_at_adv",
		"tooltip": "Triggered Roll Type Is at Adv"
	},
	"triggered_roll_type_is_at_dis": {
		"file": "triggered_roll_type_is_at_dis",
		"tooltip": "Triggered Roll Type Is at Dis"
	},
	"triggers_after_combat_begins": {
		"file": "triggers_after_combat_begins",
		"tooltip": "Triggers After Combat Begins"
	},
	"triggers_after_short_rest": {
		"file": "triggers_after_short_rest",
		"tooltip": "Triggers After Short Rest"
	},
	"triggers_if_ability_charge_is_not_used": {
		"file": "triggers_if_ability_charge_is_not_used",
		"tooltip": "Triggers If Ability Charge Is Not Used"
	},
	"triggers_if_ability_charge_is_used": {
		"file": "triggers_if_ability_charge_is_used",
		"tooltip": "Triggers If Ability Charge Is Used"
	},
	"triggers_if_roll_type_is_at_adv": {
		"file": "triggers_if_roll_type_is_at_adv",
		"tooltip": "Triggers If Roll Type Is at Adv"
	},
	"triggers_if_roll_type_is_at_dis": {
		"file": "triggers_if_roll_type_is_at_dis",
		"tooltip": "Triggers If Roll Type Is at Dis"
	},
	"triggers_on_attack_roll": {
		"file": "triggers_on_attack_roll",
		"tooltip": "Triggers on Attack Roll"
	},
	"triggers_on_attack_roll_adv": {
		"file": "triggers_on_attack_roll_adv",
		"tooltip": "Triggers on Attack Roll Adv"
	},
	"triggers_on_attack_roll_dis": {
		"file": "triggers_on_attack_roll_dis",
		"tooltip": "Triggers on Attack Roll Dis"
	},
	"triggers_on_attack_roll_hit": {
		"file": "triggers_on_attack_roll_hit",
		"tooltip": "Triggers on Attack Roll Hit"
	},
	"triggers_on_attack_roll_hit_against": {
		"file": "triggers_on_attack_roll_hit_against",
		"tooltip": "Triggers on Attack Roll Hit Against"
	},
	"triggers_on_attack_roll_hit_spell_melee": {
		"file": "triggers_on_attack_roll_hit_spell_melee",
		"tooltip": "Triggers on Attack Roll Hit Spell Melee"
	},
	"triggers_on_attack_roll_hit_spell_melee_against": {
		"file": "triggers_on_attack_roll_hit_spell_melee_against",
		"tooltip": "Triggers on Attack Roll Hit Spell Melee Against"
	},
	"triggers_on_attack_roll_hit_spell_ranged": {
		"file": "triggers_on_attack_roll_hit_spell_ranged",
		"tooltip": "Triggers on Attack Roll Hit Spell Ranged"
	},
	"triggers_on_attack_roll_hit_spell_ranged_against": {
		"file": "triggers_on_attack_roll_hit_spell_ranged_against",
		"tooltip": "Triggers on Attack Roll Hit Spell Ranged Against"
	},
	"triggers_on_attack_roll_hit_weapon_melee": {
		"file": "triggers_on_attack_roll_hit_weapon_melee",
		"tooltip": "Triggers on Attack Roll Hit Weapon Melee"
	},
	"triggers_on_attack_roll_hit_weapon_melee_against": {
		"file": "triggers_on_attack_roll_hit_weapon_melee_against",
		"tooltip": "Triggers on Attack Roll Hit Weapon Melee Against"
	},
	"triggers_on_attack_roll_hit_weapon_ranged": {
		"file": "triggers_on_attack_roll_hit_weapon_ranged",
		"tooltip": "Triggers on Attack Roll Hit Weapon Ranged"
	},
	"triggers_on_attack_roll_hit_weapon_ranged_against": {
		"file": "triggers_on_attack_roll_hit_weapon_ranged_against",
		"tooltip": "Triggers on Attack Roll Hit Weapon Ranged Against"
	},
	"triggers_on_attack_roll_spell_melee": {
		"file": "triggers_on_attack_roll_spell_melee",
		"tooltip": "Triggers on Attack Roll Spell Melee"
	},
	"triggers_on_attack_roll_spell_melee_adv": {
		"file": "triggers_on_attack_roll_spell_melee_adv",
		"tooltip": "Triggers on Attack Roll Spell Melee Adv"
	},
	"triggers_on_attack_roll_spell_melee_against": {
		"file": "triggers_on_attack_roll_spell_melee_against",
		"tooltip": "Triggers on Attack Roll Spell Melee Against"
	},
	"triggers_on_attack_roll_spell_melee_dis": {
		"file": "triggers_on_attack_roll_spell_melee_dis",
		"tooltip": "Triggers on Attack Roll Spell Melee Dis"
	},
	"triggers_on_attack_roll_spell_ranged": {
		"file": "triggers_on_attack_roll_spell_ranged",
		"tooltip": "Triggers on Attack Roll Spell Ranged"
	},
	"triggers_on_attack_roll_spell_ranged_adv": {
		"file": "triggers_on_attack_roll_spell_ranged_adv",
		"tooltip": "Triggers on Attack Roll Spell Ranged Adv"
	},
	"triggers_on_attack_roll_spell_ranged_against": {
		"file": "triggers_on_attack_roll_spell_ranged_against",
		"tooltip": "Triggers on Attack Roll Spell Ranged Against"
	},
	"triggers_on_attack_roll_spell_ranged_dis": {
		"file": "triggers_on_attack_roll_spell_ranged_dis",
		"tooltip": "Triggers on Attack Roll Spell Ranged Dis"
	},
	"triggers_on_attack_roll_weapon_melee": {
		"file": "triggers_on_attack_roll_weapon_melee",
		"tooltip": "Triggers on Attack Roll Weapon Melee"
	},
	"triggers_on_attack_roll_weapon_melee_adv": {
		"file": "triggers_on_attack_roll_weapon_melee_adv",
		"tooltip": "Triggers on Attack Roll Weapon Melee Adv"
	},
	"triggers_on_attack_roll_weapon_melee_against": {
		"file": "triggers_on_attack_roll_weapon_melee_against",
		"tooltip": "Triggers on Attack Roll Weapon Melee Against"
	},
	"triggers_on_attack_roll_weapon_melee_dis": {
		"file": "triggers_on_attack_roll_weapon_melee_dis",
		"tooltip": "Triggers on Attack Roll Weapon Melee Dis"
	},
	"triggers_on_attack_roll_weapon_ranged": {
		"file": "triggers_on_attack_roll_weapon_ranged",
		"tooltip": "Triggers on Attack Roll Weapon Ranged"
	},
	"triggers_on_attack_roll_weapon_ranged_adv": {
		"file": "triggers_on_attack_roll_weapon_ranged_adv",
		"tooltip": "Triggers on Attack Roll Weapon Ranged Adv"
	},
	"triggers_on_attack_roll_weapon_ranged_against": {
		"file": "triggers_on_attack_roll_weapon_ranged_against",
		"tooltip": "Triggers on Attack Roll Weapon Ranged Against"
	},
	"triggers_on_attack_roll_weapon_ranged_dis": {
		"file": "triggers_on_attack_roll_weapon_ranged_dis",
		"tooltip": "Triggers on Attack Roll Weapon Ranged Dis"
	},
	"triggers_on_caster_summon_death": {
		"file": "triggers_on_caster_summon_death",
		"tooltip": "Triggers on Caster Summon Death"
	},
	"triggers_on_caster_summon_death_creature_sub_type": {
		"file": "triggers_on_caster_summon_death",
		"tooltip": "Triggers on Caster Summon Death"
	},
	"triggers_on_critical_hit": {
		"file": "triggers_on_critical_hit",
		"tooltip": "Triggers on Critical Hit"
	},
	"triggers_on_critical_hit_against": {
		"file": "triggers_on_critical_hit_against",
		"tooltip": "Triggers on Critical Hit Against"
	},
	"triggers_on_critical_hit_spell_melee": {
		"file": "triggers_on_critical_hit_spell_melee",
		"tooltip": "Triggers on Critical Hit Spell Melee"
	},
	"triggers_on_critical_hit_spell_melee_against": {
		"file": "triggers_on_critical_hit_spell_melee_against",
		"tooltip": "Triggers on Critical Hit Spell Melee Against"
	},
	"triggers_on_critical_hit_spell_ranged": {
		"file": "triggers_on_critical_hit_spell_ranged",
		"tooltip": "Triggers on Critical Hit Spell Ranged"
	},
	"triggers_on_critical_hit_spell_ranged_against": {
		"file": "triggers_on_critical_hit_spell_ranged_against",
		"tooltip": "Triggers on Critical Hit Spell Ranged Against"
	},
	"triggers_on_critical_hit_weapon_melee": {
		"file": "triggers_on_critical_hit_weapon_melee",
		"tooltip": "Triggers on Critical Hit Weapon Melee"
	},
	"triggers_on_critical_hit_weapon_melee_against": {
		"file": "triggers_on_critical_hit_weapon_melee_against",
		"tooltip": "Triggers on Critical Hit Weapon Melee Against"
	},
	"triggers_on_critical_hit_weapon_ranged": {
		"file": "triggers_on_critical_hit_weapon_ranged",
		"tooltip": "Triggers on Critical Hit Weapon Ranged"
	},
	"triggers_on_critical_hit_weapon_ranged_against": {
		"file": "triggers_on_critical_hit_weapon_ranged_against",
		"tooltip": "Triggers on Critical Hit Weapon Ranged Against"
	},
	"triggers_on_death_save": {
		"file": "on_deaths_door",
		"tooltip": "Triggers on Death Save"
	},
	"triggers_on_dying_stratum_roll": {
		"file": "triggers_on_dying_stratum_roll",
		"tooltip": "Triggers on Dying Stratum Roll"
	},
	"triggers_on_hit": {
		"file": "triggers_on_hit",
		"tooltip": "Triggers on Hit"
	},
	"triggers_on_kill": {
		"file": "triggers_on_kill",
		"tooltip": "Triggers on Kill"
	},
	"triggers_on_miss": {
		"file": "triggers_on_miss",
		"tooltip": "Triggers on Miss"
	},
	"triggers_on_move": {
		"file": "triggers_on_move",
		"tooltip": "Triggers on Move"
	},
	"triggers_on_next_move": {
		"file": "triggers_on_move",
		"tooltip": "Triggers on Next Move"
	},
	"triggers_on_next_roll_type": {
		"file": "triggers_on_next_roll_type",
		"tooltip": "Triggers on Next Roll Type"
	},
	"triggers_on_next_roll_type_against": {
		"file": "triggers_on_next_roll_type_against",
		"tooltip": "Triggers on Next Roll Type Against"
	},
	"triggers_on_next_roll_type_against_and_hits": {
		"file": "triggers_on_next_roll_type_against_and_hits",
		"tooltip": "Triggers on Next Roll Type Against and Hits"
	},
	"triggers_on_not_a_critical_hit": {
		"file": "triggers_on_not_a_critical_hit",
		"tooltip": "Triggers on Not a Critical Hit"
	},
	"triggers_on_opportunity_attack": {
		"file": "triggers_on_opportunity_attack",
		"tooltip": "Triggers on Opportunity Attack"
	},
	"triggers_on_opportunity_attack_against": {
		"file": "triggers_on_opportunity_attack_against",
		"tooltip": "Triggers on Opportunity Attack Against"
	},
	"triggers_on_roll_type": {
		"file": "triggers_on_roll_type",
		"tooltip": "Triggers on Roll Type"
	},
	"triggers_on_roll_type_against_the_caster": {
		"file": "triggers_on_roll_type_against_the_caster",
		"tooltip": "Triggers on Roll Type Against the Caster"
	},
	"triggers_on_roll_type_against_the_caster_and_hits": {
		"file": "triggers_on_roll_type_against_the_caster_and_hits",
		"tooltip": "Triggers on Roll Type Against the Caster and Hits"
	},
	"triggers_on_roll_type_against_the_target": {
		"file": "triggers_on_roll_type_against_the_target",
		"tooltip": "Triggers on Roll Type Against the Target"
	},
	"triggers_on_roll_type_against_the_target_and_hits": {
		"file": "triggers_on_roll_type_against_the_target_and_hits",
		"tooltip": "Triggers on Roll Type Against the Target and Hits"
	},
	"triggers_on_self_zero_hp": {
		"file": "triggers_on_self_zero_hp",
		"tooltip": "Triggers on Self Zero Hp"
	},
	"triggers_on_self_zero_vitality": {
		"file": "triggers_on_self_zero_vitality",
		"tooltip": "Triggers on Self Zero Vitality"
	},
	"triggers_on_unlucky_roll": {
		"file": "triggers_on_unlucky_roll",
		"tooltip": "Triggers on Unlucky Roll"
	},
	"triggers_when_caster_begins_falling": {
		"file": "triggers_when_caster_begins_falling",
		"tooltip": "Triggers When Caster Begins Falling"
	},
	"triggers_when_caster_casts_a_spell": {
		"file": "triggers_when_caster_casts_a_spell",
		"tooltip": "Triggers When Caster Casts a Spell"
	},
	"triggers_when_caster_gains_luck": {
		"file": "triggers_when_caster_gains_luck",
		"tooltip": "Triggers When Caster Gains Luck"
	},
	"triggers_when_caster_gains_status_effect": {
		"file": "triggers_when_caster_gains_status_effect",
		"tooltip": "Triggers When Caster Gains Status Effect"
	},
	"triggers_when_caster_gets_item_type_against": {
		"file": "triggers_when_caster_gets_item_type_against",
		"tooltip": "Triggers When Caster Gets Item Type Against"
	},
	"triggers_when_caster_gets_item_type_against_and_hits": {
		"file": "triggers_when_caster_gets_item_type_against_and_hits",
		"tooltip": "Triggers When Caster Gets Item Type Against and Hits"
	},
	"triggers_when_caster_loses_status_effect": {
		"file": "triggers_when_caster_loses_status_effect",
		"tooltip": "Triggers When Caster Loses Status Effect"
	},
	"triggers_when_caster_makes_roll_type": {
		"file": "triggers_when_caster_makes_roll_type",
		"tooltip": "Triggers When Caster Makes Roll Type"
	},
	"triggers_when_caster_makes_roll_type_and_hits": {
		"file": "triggers_when_caster_makes_roll_type_and_hits",
		"tooltip": "Triggers When Caster Makes Roll Type and Hits"
	},
	"triggers_when_caster_spends_mana": {
		"file": "triggers_when_caster_casts_a_spell",
		"tooltip": "Triggers When Caster Casts a Spell"
	},
	"triggers_when_caster_takes_any_damage": {
		"file": "triggers_when_caster_takes_any_damage",
		"tooltip": "Triggers When Caster Takes Any Damage"
	},
	"triggers_when_caster_takes_damage_type": {
		"file": "triggers_when_caster_takes_damage_type",
		"tooltip": "Triggers When Caster Takes Damage Type"
	},
	"triggers_when_caster_turn_begins": {
		"file": "triggers_when_caster_turn_begins",
		"tooltip": "Triggers When Caster Turn Begins"
	},
	"triggers_when_caster_uses_corpse": {
		"file": "triggers_on_caster_summon_death",
		"tooltip": "Triggers on Caster Summon Death"
	},
	"triggers_when_caster_uses_item_type": {
		"file": "triggers_when_caster_uses_item_type",
		"tooltip": "Triggers When Caster Uses Item Type"
	},
	"triggers_when_caster_uses_item_type_and_hits": {
		"file": "triggers_when_caster_uses_item_type_and_hits",
		"tooltip": "Triggers When Caster Uses Item Type and Hits"
	},
	"triggers_when_enemy_within_ft_reduced_to_zero_vitality": {
		"file": "triggers_on_kill",
		"tooltip": "Triggers on Kill"
	},
	"triggers_when_target_casts_a_spell": {
		"file": "triggers_when_target_casts_a_spell",
		"tooltip": "Triggers When Target Casts a Spell"
	},
	"triggers_when_target_enters_reach": {
		"file": "triggers_when_target_enters_reach",
		"tooltip": "Triggers When Target Enters Reach"
	},
	"triggers_when_target_gains_status_effect": {
		"file": "triggers_when_target_gains_status_effect",
		"tooltip": "Triggers When Target Gains Status Effect"
	},
	"triggers_when_target_gets_item_type_against": {
		"file": "triggers_when_target_gets_item_type_against",
		"tooltip": "Triggers When Target Gets Item Type Against"
	},
	"triggers_when_target_gets_item_type_against_and_hits": {
		"file": "triggers_when_target_gets_item_type_against_and_hits",
		"tooltip": "Triggers When Target Gets Item Type Against and Hits"
	},
	"triggers_when_target_leaves_reach": {
		"file": "triggers_when_target_leaves_reach",
		"tooltip": "Triggers When Target Leaves Reach"
	},
	"triggers_when_target_loses_status_effect": {
		"file": "triggers_when_target_loses_status_effect",
		"tooltip": "Triggers When Target Loses Status Effect"
	},
	"triggers_when_target_makes_roll_type": {
		"file": "triggers_when_target_makes_roll_type",
		"tooltip": "Triggers When Target Makes Roll Type"
	},
	"triggers_when_target_makes_roll_type_and_hits": {
		"file": "triggers_when_target_makes_roll_type_and_hits",
		"tooltip": "Triggers When Target Makes Roll Type and Hits"
	},
	"triggers_when_target_moves": {
		"file": "triggers_when_target_moves",
		"tooltip": "Triggers When Target Moves"
	},
	"triggers_when_target_stands_up_from_prone": {
		"file": "stand_up",
		"tooltip": "Stand Up"
	},
	"triggers_when_target_takes_any_damage": {
		"file": "triggers_when_target_takes_any_damage",
		"tooltip": "Triggers When Target Takes Any Damage"
	},
	"triggers_when_target_takes_damage_type": {
		"file": "triggers_when_target_takes_damage_type",
		"tooltip": "Triggers When Target Takes Damage Type"
	},
	"triggers_when_target_uses_item_type": {
		"file": "triggers_when_target_uses_item_type",
		"tooltip": "Triggers When Target Uses Item Type"
	},
	"triggers_when_target_uses_item_type_and_hits": {
		"file": "triggers_when_target_uses_item_type_and_hits",
		"tooltip": "Triggers When Target Uses Item Type and Hits"
	},
	"tumble": {
		"file": "tumble",
		"tooltip": "Tumble"
	},
	"turn_timer_paused": {
		"file": "turn_timer_paused",
		"tooltip": "Turn Timer Paused"
	},
	"turn_timer_reset": {
		"file": "reset_turn_timer",
		"tooltip": "Turn Timer Reset"
	},
	"turn_timer_resumed": {
		"file": "turn_timer_resumed",
		"tooltip": "Turn Timer Resumed"
	},
	"twitch": {
		"file": "twitch",
		"tooltip": "Twitch"
	},
	"twitter": {
		"file": "twitter",
		"tooltip": "Twitter"
	},
	"undispellable": {
		"file": "undispellable",
		"tooltip": "Undispellable"
	},
	"unenchantable": {
		"file": "unenchantable",
		"tooltip": "Unenchantable"
	},
	"unequip_both_hands": {
		"file": "unequip_both_hands",
		"tooltip": "Unequip Both Hands"
	},
	"unequip_inventory": {
		"file": "unequip_inventory",
		"tooltip": "Unequip Inventory"
	},
	"unexplored": {
		"file": "unexplored",
		"tooltip": "Unexplored"
	},
	"unfinished_craftable": {
		"file": "unfinished_craftable",
		"tooltip": "Unfinished Craftable"
	},
	"unhindered_attack": {
		"file": "unhindered_attack",
		"tooltip": "Unhindered Attack"
	},
	"unidentified": {
		"file": "unidentified",
		"tooltip": "Unidentified"
	},
	"unlucky_roll": {
		"file": "unlucky_roll",
		"tooltip": "Unlucky Roll"
	},
	"unprepare_spell": {
		"file": "unprepare_spell",
		"tooltip": "Unprepare Spell"
	},
	"update": {
		"file": "update",
		"tooltip": "Update"
	},
	"upload": {
		"file": "upload",
		"tooltip": "Upload"
	},
	"upload_adventure_header_picture": {
		"file": "upload_adventure_header_picture",
		"tooltip": "Upload Adventure Header Picture"
	},
	"upload_audio": {
		"file": "upload_audio",
		"tooltip": "Upload Audio"
	},
	"upload_campaign_header_picture": {
		"file": "upload_campaign_header_picture",
		"tooltip": "Upload Campaign Header Picture"
	},
	"upload_creature_picture": {
		"file": "upload_creature_picture",
		"tooltip": "Upload Creature Picture"
	},
	"upload_encounter_creature_picture": {
		"file": "upload_encounter_creature_picture",
		"tooltip": "Upload Encounter Creature Picture"
	},
	"upload_encounter_location_picture": {
		"file": "upload_encounter_location_picture",
		"tooltip": "Upload Encounter Location Picture"
	},
	"upload_encounter_picture": {
		"file": "upload_encounter_picture",
		"tooltip": "Upload Encounter Picture"
	},
	"upload_item_image": {
		"file": "upload_item_image",
		"tooltip": "Upload Item Image"
	},
	"upload_location_map": {
		"file": "upload_location_map",
		"tooltip": "Upload Location Map"
	},
	"upload_location_picture": {
		"file": "upload_location_picture",
		"tooltip": "Upload Location Picture"
	},
	"upload_picture": {
		"file": "upload_picture",
		"tooltip": "Upload Picture"
	},
	"upload_player_character_picture": {
		"file": "upload_player_character_picture",
		"tooltip": "Upload Player Character Picture"
	},
	"upload_source_header_picture": {
		"file": "upload_source_header_picture",
		"tooltip": "Upload Source Header Picture"
	},
	"upload_video": {
		"file": "upload_video",
		"tooltip": "Upload Video"
	},
	"use_1ap_menta": {
		"file": "use_1ap_menta",
		"tooltip": "Use 1ap Menta"
	},
	"use_2ap_menta": {
		"file": "use_2ap_menta",
		"tooltip": "Use 2ap Menta"
	},
	"use_3ap_menta": {
		"file": "use_3ap_menta",
		"tooltip": "Use 3ap Menta"
	},
	"use_reaction_menta": {
		"file": "use_reaction_menta",
		"tooltip": "Use Reaction Menta"
	},
	"user": {
		"file": "user",
		"tooltip": "User"
	},
	"user_choice_1_ability": {
		"file": "user_choice_1_ability",
		"tooltip": "User Choice 1 Ability"
	},
	"user_choice_1_attack_ability": {
		"file": "user_choice_1_attack_ability",
		"tooltip": "User Choice 1 Attack Ability"
	},
	"user_choice_1_diseased_applied_to_target_after_contesting_roll_failed": {
		"file": "user_choice_1_diseased_applied_to_target_after_contesting_roll_failed",
		"tooltip": "User Choice 1 Diseased Applied to Target After Contesting Roll Failed"
	},
	"user_choice_1_free_ability": {
		"file": "user_choice_1_free_ability",
		"tooltip": "User Choice 1 Free Ability"
	},
	"user_choice_1_full_ability": {
		"file": "user_choice_1_full_ability",
		"tooltip": "User Choice 1 Full Ability"
	},
	"user_choice_1_opportunity_attack_ability": {
		"file": "user_choice_1_opportunity_attack_ability",
		"tooltip": "User Choice 1 Opportunity Attack Ability"
	},
	"user_choice_1_passive_ability": {
		"file": "user_choice_1_passive_ability",
		"tooltip": "User Choice 1 Passive Ability"
	},
	"user_choice_1_quick_ability": {
		"file": "user_choice_1_quick_ability",
		"tooltip": "User Choice 1 Quick Ability"
	},
	"user_choice_1_reaction_ability": {
		"file": "user_choice_1_reaction_ability",
		"tooltip": "User Choice 1 Reaction Ability"
	},
	"user_choice_1_shapeshift": {
		"file": "user_choice_1_shapeshift",
		"tooltip": "User Choice 1 Shapeshift"
	},
	"user_choice_1_shapeshift_inventory_remains_on_form": {
		"file": "user_choice_1_shapeshift_inventory_remains_on_form",
		"tooltip": "User Choice 1 Shapeshift Inventory Remains on Form"
	},
	"uses_corpse": {
		"file": "summon",
		"tooltip": "Summon"
	},
	"v_current": {
		"file": "v_current",
		"tooltip": "V Current"
	},
	"v_dice": {
		"file": "v_dice",
		"tooltip": "V Dice"
	},
	"v_dice_multiplier": {
		"file": "v_dice",
		"tooltip": "V Dice Multiplier"
	},
	"v_die": {
		"file": "v_die",
		"tooltip": "V Die"
	},
	"v_max": {
		"file": "v_max",
		"tooltip": "V Max"
	},
	"v_max_temp": {
		"file": "v_max_temp",
		"tooltip": "V Max Temp"
	},
	"v_method": {
		"file": "v_method",
		"tooltip": "Creature variable method"
	},
	"v_mod": {
		"file": "v_mod",
		"tooltip": "V Mod"
	},
	"v_temp": {
		"file": "v_temp",
		"tooltip": "V Temp"
	},
	"vehicle_air": {
		"file": "vehicle_air",
		"tooltip": "Vehicle Air"
	},
	"vehicle_land": {
		"file": "vehicle_land",
		"tooltip": "Vehicle Land"
	},
	"vehicle_water": {
		"file": "vehicle_water",
		"tooltip": "Vehicle Water"
	},
	"vehicles_air": {
		"file": "vehicles_air",
		"tooltip": "Vehicles Air"
	},
	"vehicles_land": {
		"file": "vehicles_land",
		"tooltip": "Vehicles Land"
	},
	"vehicles_water": {
		"file": "vehicles_water",
		"tooltip": "Vehicles Water"
	},
	"video": {
		"file": "video",
		"tooltip": "Video"
	},
	"view_adventure": {
		"file": "view_adventure",
		"tooltip": "View Adventure"
	},
	"view_all_encounters": {
		"file": "view_all_encounters",
		"tooltip": "View All Encounters"
	},
	"view_ancestry": {
		"file": "view_ancestry",
		"tooltip": "View Ancestry"
	},
	"view_audio_files": {
		"file": "view_audio_files",
		"tooltip": "View Audio Files"
	},
	"view_campaign": {
		"file": "view_campaign",
		"tooltip": "View Campaign"
	},
	"view_campaign_players": {
		"file": "view_campaign_players",
		"tooltip": "View Campaign Players"
	},
	"view_encounter": {
		"file": "view_encounter",
		"tooltip": "View Encounter"
	},
	"view_forms": {
		"file": "view_forms",
		"tooltip": "View Forms"
	},
	"view_item_layer_types": {
		"file": "view_item_layer_types",
		"tooltip": "View Item Layer Types"
	},
	"view_items_work": {
		"file": "view_items_work",
		"tooltip": "View Items Work"
	},
	"view_log": {
		"file": "view_log",
		"tooltip": "View Log"
	},
	"view_my_campaign": {
		"file": "view_my_campaign",
		"tooltip": "View My Campaign"
	},
	"view_private_encounters": {
		"file": "view_private_encounters",
		"tooltip": "View Private Encounters"
	},
	"view_public_encounters": {
		"file": "view_public_encounters",
		"tooltip": "View Public Encounters"
	},
	"view_soundboard": {
		"file": "view_soundboard",
		"tooltip": "View Soundboard"
	},
	"vitality": {
		"file": "vitality",
		"tooltip": "Vitality"
	},
	"voice": {
		"file": "voice",
		"tooltip": "Voice"
	},
	"waking_weariness_disabled": {
		"file": "waking_weariness_disabled",
		"tooltip": "Waking Weariness Disabled"
	},
	"waking_weariness_enabled": {
		"file": "waking_weariness_enabled",
		"tooltip": "Waking Weariness Enabled"
	},
	"walks_on_water_and_ice": {
		"file": "water_mote",
		"tooltip": "Water Mote"
	},
	"wall": {
		"file": "wall",
		"tooltip": "Wall"
	},
	"war_machine": {
		"file": "war_machine",
		"tooltip": "War Machine"
	},
	"water_mote": {
		"file": "water_mote",
		"tooltip": "Water Mote"
	},
	"weapon": {
		"file": "weapon",
		"tooltip": "Weapon"
	},
	"weapon_ammo_classification": {
		"file": "weapon_ammo_classification",
		"tooltip": "Weapon Ammo Classification"
	},
	"weapon_attack_count": {
		"file": "weapon_attack_count",
		"tooltip": "Weapon Attack Count"
	},
	"weapon_attack_count_change": {
		"file": "weapon_attack_count_change",
		"tooltip": "Weapon Attack Count Change"
	},
	"weapon_attack_counter": {
		"file": "weapon_attack_counter",
		"tooltip": "Weapon Attack Counter"
	},
	"weapon_attack_mod": {
		"file": "weapon_attack_mod",
		"tooltip": "Weapon Attack Mod"
	},
	"weapon_attack_roll_assistance_roll": {
		"file": "weapon_attack_roll_assistance_roll",
		"tooltip": "Weapon Attack Roll Assistance Roll"
	},
	"weapon_category": {
		"file": "weapon_category",
		"tooltip": "Weapon Category"
	},
	"weapon_classification": {
		"file": "weapon_classification",
		"tooltip": "Weapon Classification"
	},
	"weapon_equipped": {
		"file": "weapon_equipped",
		"tooltip": "Weapon Equipped"
	},
	"weapon_essence": {
		"file": "weapon_essence",
		"tooltip": "Weapon Essence"
	},
	"weapon_finesse": {
		"file": "weapon_finesse",
		"tooltip": "Weapon Finesse"
	},
	"weapon_melee_attack_rolls_adv": {
		"file": "weapon_melee_attack_rolls_adv",
		"tooltip": "Weapon Melee Attack Rolls Adv"
	},
	"weapon_melee_attack_rolls_against_adv": {
		"file": "weapon_melee_attack_rolls_against_adv",
		"tooltip": "Weapon Melee Attack Rolls Against Adv"
	},
	"weapon_melee_attack_rolls_against_dis": {
		"file": "weapon_melee_attack_rolls_against_dis",
		"tooltip": "Weapon Melee Attack Rolls Against Dis"
	},
	"weapon_melee_attack_rolls_dis": {
		"file": "weapon_melee_attack_rolls_dis",
		"tooltip": "Weapon Melee Attack Rolls Dis"
	},
	"weapon_ranged_attack_rolls_adv": {
		"file": "weapon_ranged_attack_rolls_adv",
		"tooltip": "Weapon Ranged Attack Rolls Adv"
	},
	"weapon_ranged_attack_rolls_against_adv": {
		"file": "weapon_ranged_attack_rolls_against_adv",
		"tooltip": "Weapon Ranged Attack Rolls Against Adv"
	},
	"weapon_ranged_attack_rolls_against_dis": {
		"file": "weapon_ranged_attack_rolls_against_dis",
		"tooltip": "Weapon Ranged Attack Rolls Against Dis"
	},
	"weapon_ranged_attack_rolls_dis": {
		"file": "weapon_ranged_attack_rolls_dis",
		"tooltip": "Weapon Ranged Attack Rolls Dis"
	},
	"weapon_skill": {
		"file": "weapon_skill",
		"tooltip": "Weapon Skill"
	},
	"weapon_type": {
		"file": "weapon_type",
		"tooltip": "Weapon Type"
	},
	"weapons_equipped": {
		"file": "weapons_equipped",
		"tooltip": "Weapons Equipped"
	},
	"weather": {
		"file": "weather",
		"tooltip": "Weather"
	},
	"weather_vision_immunity": {
		"file": "weather",
		"tooltip": "Weather"
	},
	"weaving_recipe": {
		"file": "weaving_recipe",
		"tooltip": "Weaving Recipe"
	},
	"webcam_required": {
		"file": "webcam_required",
		"tooltip": "Webcam Required"
	},
	"weight": {
		"file": "weight",
		"tooltip": "Weight"
	},
	"weight_multiplier": {
		"file": "weight_multiplier",
		"tooltip": "Weight Multiplier"
	},
	"well_of_creation_connected": {
		"file": "well_of_creation_connected",
		"tooltip": "Well of Creation Connected"
	},
	"width": {
		"file": "width",
		"tooltip": "Width"
	},
	"wind_type": {
		"file": "wind_type",
		"tooltip": "Wind Type"
	},
	"window": {
		"file": "window",
		"tooltip": "Window"
	},
	"window_climb": {
		"file": "window_climb",
		"tooltip": "Window Climb"
	},
	"window_close": {
		"file": "window_close",
		"tooltip": "Window Close"
	},
	"window_open": {
		"file": "window_open",
		"tooltip": "Window Open"
	},
	"wishlist_picture": {
		"file": "wishlist_picture",
		"tooltip": "Wishlist Picture"
	},
	"withdraw": {
		"file": "withdraw",
		"tooltip": "Withdraw"
	},
	"wooden_door": {
		"file": "wooden_door",
		"tooltip": "Wooden Door"
	},
	"woodworking_recipe": {
		"file": "woodworking_recipe",
		"tooltip": "Woodworking Recipe"
	},
	"world": {
		"file": "world",
		"tooltip": "World"
	},
	"world_locations": {
		"file": "world_locations",
		"tooltip": "World Locations"
	},
	"written_in_language": {
		"file": "written_in_language",
		"tooltip": "Written in Language"
	},
	"x": {
		"file": "x",
		"tooltip": "X"
	},
	"x_pos": {
		"file": "x_pos",
		"tooltip": "X Pos"
	},
	"y_pos": {
		"file": "y_pos",
		"tooltip": "Y Pos"
	},
	"youtube": {
		"file": "youtube",
		"tooltip": "Youtube"
	},
	"z_pos": {
		"file": "z_pos",
		"tooltip": "Z Pos"
	},
	"zone": {
		"file": "zone",
		"tooltip": "Zone"
	}
};
